import React, { useEffect, /*useContext,*/ useState, useRef } from "react";
// import {
//   OnBoardNotClear,
//   TokenVerificationLoggedin,
//   ScreenView
// } from "../utils/tokenVerify";
// import { LoadingContext } from "react-router-loading";
// import {
//   Col,
//   Row,
//   Input,
//   Space,
//   Select,
//   Radio,
//   Switch,
//   message,
//   Upload,
// } from "antd";
import copyIcon from '../assets/images/icons/copy.svg';
import Cookies from "js-cookie";
import { Link } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import axios from "axios";
import configData from "../config/config.json";
import { notifysuccess } from "../utils/toast";
import { notifyfailure } from "../utils/toast";
import backButton from '../assets/images/back_button_arrow.svg';
import { notifycatch } from "../utils/toast";
import { Radio, Select, Col, Row, Input, Checkbox, Tooltip, Modal } from "antd";
import BlockCategoryTable from './BlockCategoryTable';
import creativetemicon from '../assets/images/icons/creative_tem_icon.svg';
// import homeIcon from "../assets/images/icons/home.svg";
import loaderIcon from "../assets/images/login-and-signup/loader.gif";
import uploadIcon from "../assets/images/icons/upload-cloud.svg";
import zoneInfoIcon from '../assets/images/icons/zone-info.svg';
import deleteIcon from '../assets/images/icons/trash.svg';
import zoomIcon from '../assets/images/icons/expand.svg';
import playIcon from '../assets/images/icons/play.svg';
import addVideoIcon from '../assets/images/icons/addVideoicon.svg';
import zoneIcon from '../assets/images/icons/zone.svg';
import searchIcon from '../assets/images/icons/search.svg';
import gamSizesData from '../constants/GamSizes/sizes.json';
import gamVastMasterSizesData from '../constants/GamSizes/vastMasterSizes.json';
import gamCompanionSizesData from '../constants/GamSizes/companionSizes.json';
// import NotIntig from '../assets/images/icons/not_inti.svg';
// import IntegrationRrequest from '../assets/images/icons/integration_request_text.svg';
// import { toast } from "react-toastify";
const { TextArea } = Input;
const { Option } = Select;

const ZoneCreate = ({ handlePageViewChange }) => {
  // const loadingContext = useContext(LoadingContext);

  const scrollToItem = (ref, offset = 80) => {
    if (ref && ref.current) {
      ref.current.style.scrollMarginTop = `${offset}px`;
      ref.current.scrollIntoView({ behavior: "smooth", block: "start" });
      setTimeout(() => {
        ref.current.style.scrollMarginTop = '';
      }, 0);
    }
  };

  useEffect(() => {
    const inputs = document.querySelectorAll('.ant-select-selection-search-input');

    inputs.forEach(input => {
      const handleInput = () => {
        const parent = input.closest('.ant-select-selection-search');
        if (input.value.length > 0) {
          parent.classList.add('searching');
        } else {
          parent.classList.remove('searching');
        }
      };

      input.addEventListener('input', handleInput);

      // Cleanup event listener on component unmount
      return () => {
        input.removeEventListener('input', handleInput);
      };
    });
  });


  const [gamStatusDirect, setGamStatusDirect] = useState(false);

  useEffect(() => {
    // TokenVerificationLoggedin();
    // ScreenView();
    let status = Cookies.get("token_xapads_ssp") ? true : false;
    if (status) {
      let token = Cookies.get("token_xapads_ssp");
      let role = jwtDecode(token).role;
      let name = jwtDecode(token).p_name;
      if ((role === "admin" || role === "u_admin")) {
        setPublisherName(name);
        setTokenIsGam(jwtDecode(token).isGam === true);
        setZoneName_prebid(name + "-Website-Banner");

        axios
          .get(configData.SERVER_URL + "ops/gamStatus", {
            headers: {
              "Content-Type": "application/json",
              "x-access-token": token,
            },
          })
          .then((response) => {
            setGamShow(response.data.data);
            setAniviewShow(response.data.aniview_data)
            setGamStatusDirect(response.data?.isDirect)
            if (response.data?.isDirect) {
              setHuman_prebid("50");
              setHuman_openrtb("50");
              setHuman_publica("50");
              setHuman_vastzone("50");
            } else {
              setHuman_prebid("0");
              setHuman_openrtb("0");
              setHuman_publica("0");
              setHuman_vastzone("0");
            }

          })
          .catch((error) => { });

      }

      // if (role === "mobops" || role === "sa" || role === "am") {
      axios
        .get(configData.SERVER_URL + "ops/getExchangeTypes", {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          setIntegrationTypeOptions_openrtb(response.data.data);
        })
        .catch((error) => { });
      // }
      setRole(role);

    }
    // loadingContext.done();
  }, []);

  useEffect(() => {
    let status = Cookies.get("token_xapads_ssp") ? true : false;
    if (status) {


      let token = Cookies.get("token_xapads_ssp");

      if (jwtDecode(token).role !== "admin" && jwtDecode(token).role !== "u_admin") {
        axios
          .get(configData.SERVER_URL + "zone/pubMinifiedList", {
            headers: {
              "Content-Type": "application/json",
              "x-access-token": token,
            },
          })
          .then((response) => {
            setPublisherList(response.data.data);
          })
          .catch((error) => { });
      }

      if (jwtDecode(token).role === "admin" || jwtDecode(token).role === "u_admin") {

        axios
          .get(configData.SERVER_URL + "ops/blockCategory", {
            headers: {
              "Content-Type": "application/json",
              "x-access-token": token,
            },
          })
          .then((response) => {
            setBlockCategorySelected(new Set(response.data.data?.block_cat) || new Set())
            setBlockCategorySelectedTrack(new Set(response.data.data?.block_cat) || new Set())
            setBlockCategoryNormalizeKey(k => k + 1)
          })
          .catch((error) => { });
      }

      axios
        .get(configData.SERVER_URL + "zone/getAdKTempList", {
          headers: {
            "Content-Type": "application/json",
            "x-access-token": token,
          },
        })
        .then((response) => {
          setTemplateOptions_vastzone(response.data)
        })
        .catch((error) => { });
    }

    axios
      .get(configData.SERVER_URL + "publica/templates", {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setTemplateOptions_publica(response.data.data)

      })
      .catch((error) => { });


  }, []);

  ////////////////////////////////////////////role and publisher list/publisher for not admin states  and form view////////////////////////////////

  function resetFormView() {
    setPublisherName("");
    setPublisherIsRequiredError(false);
    reset_prebid()
    setFormType("Prebid");
    setSelectedPublisher("");
    setButtonProcessing(false)

  }

  const [role, setRole] = useState("admin");
  // For admin / u_admin the publisher is themselves (no publisher dropdown), so GAM
  // integration status is read from the token's isGam key instead of the publisher list.
  const [tokenIsGam, setTokenIsGam] = useState(false);
  // For these roles the GAM TV-app / Override-UPR / UPR-Category fields are hidden
  const isGamRestricted = role === "admin" || role === "u_admin" || role === "am";
  const [publisherName, setPublisherName] = useState("");
  const [selectedPublisher, setSelectedPublisher] = useState("");
  const [publisherIsRequiredError, setPublisherIsRequiredError] =
    useState(false);
  const [publisherList, setPublisherList] = useState([]);
  const [buttonProcessing, setButtonProcessing] = useState(false);
  const [blockCategorySelected, setBlockCategorySelected] = useState(new Set());
  const [blockCategorySelectedTrack, setBlockCategorySelectedTrack] = useState(new Set());
  const [blockCategoryNormalizeKey, setBlockCategoryNormalizeKey] = useState(0);

  function onChangePublisher(event) {

    reset_prebid()

    const selectedPublisher = publisherList?.find(
      (publisher) => publisher.value === event
    );

    const selectedGam = selectedPublisher ? selectedPublisher.gam_check : false;
    const selectedAniview = selectedPublisher ? selectedPublisher.aniview_check : false;
    setGamShow(selectedGam)
    setAniviewShow(selectedAniview)

    setBlockCategorySelected(new Set(selectedPublisher?.block_cat) || new Set())
    setBlockCategorySelectedTrack(new Set(selectedPublisher?.block_cat) || new Set())
    setBlockCategoryNormalizeKey(k => k + 1)

    if (selectedPublisher?.isDirect) {
      setHuman_prebid("50");
      setHuman_openrtb("50");
      setHuman_publica("50");
      setHuman_vastzone("50");
    } else {
      setHuman_prebid("0");
      setHuman_openrtb("0");
      setHuman_publica("0");
      setHuman_vastzone("0");
    }



    setPublisherIsRequiredError(false);
    setSelectedPublisher(event);
    setPublisherName(event.split("-").slice(1).join("-"));

    if (formType === "publica") {
      setSid_publica(event.split("-")[0])
    }

    // if (formType === "Prebid" ) {
    setZoneNameIsRequiredError_prebid(false);
    setZoneName_prebid(
      event.split("-").slice(1).join("-") +
      "-" +
      platformType_prebid +
      "-" +
      formatType_prebid?.join(', ')
    );
    // } 
    // else if (formType === "Open RTB") {
    //   setZoneNameIsRequiredError_openrtb(false);
    //   setZoneName_openrtb(
    //     event.split("-").slice(1).join("-") +
    //     "-" +
    //     platformType_openrtb +
    //     "-" +
    //     formatType_openrtb
    //   );
    // }
    // else if (formType === "Vast Zone") {
    //   setZoneNameIsRequiredError_vastzone(false);
    //   setZoneName_vastzone(
    //     event.split("-").slice(1).join("-") +
    //     "-" +
    //     platformType_openrtb
    //   );
    // }
    // else if (formType === "Player Tag") {
    //   setChannelNameIsRequiredError_playertag(false);
    //   setChannelName_playertag(
    //     event.split("-").slice(1).join("-") + "_" + platformType_playertag + "_" + playerMode_playertag?.toLowerCase()
    //   );
    // }
    // else if (formType === "GAM Tag") {
    //   setAccountNameIsRequiredError_gamtag(false);
    //   setAccountName_gamtag(
    //     event.split("-").slice(1).join("-") + "_MI"
    //   );
    // }

    setFormType("Prebid")

  }

  const [formType, setFormType] = useState("Prebid");


  // const handleButtonClick = () => {

  //   setFormTypeOption(prevState =>
  //     prevState.map(option => {
  //       if (option.value === "GAM Tag") {
  //         return {
  //           ...option,
  //           label: (
  //             <div className="add_newbtn_design2 d-flex justify-content-between">
  //               <p> GAM Tag <span><img src={NotIntig} alt="" /></span></p>
  //               <button
  //                 className="w_120_d2 btn btn_primary w_fit_content loader text-capitalize"
  //               >
  //                 <span>Request Activation</span>
  //                 <img
  //                   src={loaderIcon}
  //                   alt="USP"
  //                   className="loader_icon"
  //                 />
  //               </button>
  //             </div>
  //           )
  //         };
  //       }
  //       return option;
  //     })
  //   );

  //   let status = Cookies.get("token_xapads_ssp") ? true : false;
  //   if (status) {
  //     let token = Cookies.get("token_xapads_ssp")
  //     axios
  //       .post(configData.SERVER_URL + "zone/reqGAM", {}, {
  //         headers: {
  //           "Content-Type": "application/json",
  //           "x-access-token": token,
  //         },
  //       })
  //       .then((response) => {
  //         notifysuccess("Request Sent Successfully");
  //         setFormTypeOption(prevState =>
  //           prevState.map(option => {
  //             if (option.value === "GAM Tag") {
  //               return {
  //                 ...option,
  //                 label: (
  //                   <div className="add_newbtn_design2 d-flex justify-content-between">
  //                     <p> GAM Tag <span><img src={NotIntig} alt="" /></span></p>
  //                     <p> <span><img src={IntegrationRrequest} alt="" /></span></p>
  //                   </div>
  //                 )
  //               };
  //             }
  //             return option;
  //           })
  //         );
  //       })
  //       .catch((error) => {
  //         notifyfailure("Failure in raising request");
  //         setFormTypeOption(prevState =>
  //           prevState.map(option => {
  //             if (option.value === "GAM Tag") {
  //               return {
  //                 ...option,
  //                 label: (
  //                   <div className="add_newbtn_design2 d-flex justify-content-between">
  //                     <p> GAM Tag <span><img src={NotIntig} alt="" /></span></p>
  //                     <button className="btn btn_primary w_fit_content text-capitalize" onClick={handleButtonClick}> Request Activation </button>
  //                   </div>
  //                 )
  //               };
  //             }
  //             return option;
  //           })
  //         );
  //       });
  //   }

  // };

  const [gamShow, setGamShow] = useState(null)
  const [aniviewShow, setAniviewShow] = useState(null)

  const [formTypeOption, setFormTypeOption] = useState([
    { label: "Prebid", value: "Prebid" },
    { label: "Open RTB", value: "Open RTB" },
    { label: "GAM", value: "GAM" },
    { label: "Vast Publica", value: "publica" },
    { label: "Vast Adkernel", value: "Vast Zone" },
    {
      label: <div className="add_newbtn_design2 d-flex justify-content-between">
        <p> Vast (Aniview) <span className='not_interested_text'>(Not Supported)</span></p>
      </div>, value: "vast_aniview", disabled: true
    },
    {
      label: <div className="add_newbtn_design2 d-flex justify-content-between">
        <p> Player Tag (Instream) <span className='not_interested_text'>(Not Supported)</span></p>
      </div>, value: "Player Tag", disabled: true
    },
    {
      label: <div className="add_newbtn_design2 d-flex justify-content-between">
        <p> Player Tag (Outstream) <span className='not_interested_text'>(Not Supported)</span></p>
      </div>, value: "tag_outstream", disabled: true
    },
    // {
    //   label:
    //     <div className="add_newbtn_design2 d-flex justify-content-between">
    //       <p> GAM Tag <span><img src={NotIntig} alt="" /></span></p>
    //     </div>
    //   , value: "GAM Tag", disabled: true
    // },
  ]);

  // GAM zone type is only selectable for publishers integrated with GAM (isGam).
  // When the selected publisher is not integrated, the GAM option is disabled and
  // labelled "(Not integrated)". No publisher selected => GAM stays enabled.
  const selectedPublisherIsGam = publisherList?.find(
    (publisher) => publisher.value === selectedPublisher
  )?.isGam;

  const isAdminRole = role === "admin" || role === "u_admin";
  const formTypeOptionResolved = formTypeOption.map((option) => {
    if (option.value !== "GAM") return option;
    // Admin / u_admin: GAM availability comes from the token's isGam key.
    // Other roles: it comes from the selected publisher's isGam flag
    // (no publisher selected => GAM stays enabled).
    const gamNotIntegrated = isAdminRole
      ? tokenIsGam !== true
      : selectedPublisher && selectedPublisherIsGam === false;
    if (gamNotIntegrated) {
      return {
        value: "GAM",
        disabled: true,
        label: (
          <div className="add_newbtn_design2 d-flex justify-content-between">
            <p> GAM <span className='not_interested_text'>(Not integrated)</span></p>
          </div>
        ),
      };
    }
    return { label: "GAM", value: "GAM" };
  });


  useEffect(() => {

    const updatedOptions = [
      { label: "Prebid", value: "Prebid" },
      { label: "Open RTB", value: "Open RTB" },
      { label: "GAM", value: "GAM" },
      { label: "Vast Publica", value: "publica" },
      { label: "Vast Adkernel", value: "Vast Zone" },
      {
        label: <div className="add_newbtn_design2 d-flex justify-content-between">
          <p> Vast (Aniview) <span className='not_interested_text'>(Not Supported)</span></p>
        </div>, value: "vast_aniview", disabled: true
      },
      {
        label: <div className="add_newbtn_design2 d-flex justify-content-between">
          <p> Player Tag (Instream) <span className='not_interested_text'>(Not Supported)</span></p>
        </div>, value: "Player Tag", disabled: true
      },
      {
        label: <div className="add_newbtn_design2 d-flex justify-content-between">
          <p> Player Tag (Outstream) <span className='not_interested_text'>(Not Supported)</span></p>
        </div>, value: "tag_outstream", disabled: true
      },
      // {
      //   label: aniviewShow ? "Vast (Aniview)" :
      //     <div className="add_newbtn_design2 d-flex justify-content-between">
      //       <p> Vast (Aniview) <span><img src={NotIntig} alt="" /></span></p>
      //     </div>, value: "vast_aniview", disabled: aniviewShow ? false : true
      // },
      // {
      //   label: aniviewShow ? "Player Tag (Instream)" :
      //     <div className="add_newbtn_design2 d-flex justify-content-between">
      //       <p> Player Tag (Instream)<span><img src={NotIntig} alt="" /></span></p>
      //     </div>, value: "Player Tag", disabled: aniviewShow ? false : true
      // },
      // {
      //   label: aniviewShow ? "Player Tag (Outstream)" :
      //     <div className="add_newbtn_design2 d-flex justify-content-between">
      //       <p> Player Tag (Outstream)<span><img src={NotIntig} alt="" /></span></p>
      //     </div>, value: "tag_outstream", disabled: aniviewShow ? false : true
      // },


      // {
      //   label: gamShow ? "GAM Tag" : publisherName === "" ?
      //     <div className="add_newbtn_design2 d-flex justify-content-between">
      //       <p> GAM Tag <span><img src={NotIntig} alt="" /></span></p>
      //     </div> :
      //     (role !== "admin" && role !== "u_admin") ?

      //       <div className="add_newbtn_design2 d-flex justify-content-between">
      //         <p> GAM Tag <span><img src={NotIntig} alt="" /></span></p>
      //       </div> :
      //       <div className="add_newbtn_design2 d-flex justify-content-between">
      //         <p> GAM Tag <span><img src={NotIntig} alt="" /></span></p>
      //         <button className="btn btn_primary w_fit_content text-capitalize"
      //           onClick={handleButtonClick}
      //         > Request Activation </button>
      //       </div>
      //   ,
      //   value: "GAM Tag", disabled: gamShow ? false : true
      // },
    ];

    setFormTypeOption(updatedOptions);
  }, [gamShow, aniviewShow]);


  function onChangeFormType(event) {
    setFormType(event);
    setBlockCategorySelected(blockCategorySelectedTrack)
    setBlockCategoryNormalizeKey(k => k + 1)

    if (event === "Prebid") {
      reset_prebid();
      if (publisherName !== "") {
        setZoneName_prebid(
          publisherName + "-" + platformType_prebid + "-" + formatType_prebid?.join(",")
        );

        if ((role !== "admin" && role !== "u_admin")) {
          const selectedPub = publisherList.find(pub => pub.value === selectedPublisher);
          const humanValue = (selectedPublisher !== "" && selectedPub?.isDirect) ? "50" : "0";
          setHuman_prebid(humanValue)
        }
        else {
          if (gamStatusDirect) {
            setHuman_prebid("50");
          } else {
            setHuman_prebid("0");
          }

        }
      }
    } else if (event === "Open RTB") {
      reset_openrtb();
      if (publisherName !== "") {
        setZoneName_openrtb(
          publisherName + "-" + platformType_openrtb + "-" + formatType_openrtb?.join(",")
        );

        if ((role !== "admin" && role !== "u_admin")) {
          const selectedPub = publisherList.find(pub => pub.value === selectedPublisher);
          const humanValue = (selectedPublisher !== "" && selectedPub?.isDirect) ? "50" : "0";
          setHuman_openrtb(humanValue)
        }
        else {
          if (gamStatusDirect) {
            setHuman_openrtb("50");
          } else {
            setHuman_openrtb("0");
          }

        }
      }
    }
    else if (event === "publica") {
      reset_publica();
      if ((role !== "admin" && role !== "u_admin")) {
        const selectedPub = publisherList.find(pub => pub.value === selectedPublisher);
        const humanValue = (selectedPublisher !== "" && selectedPub?.isDirect) ? "50" : "0";
        setHuman_publica(humanValue)
      }
      else {
        if (gamStatusDirect) {
          setHuman_publica("50");
        } else {
          setHuman_publica("0");

        }

      }
    }
    else if (event === "Vast Zone") {
      reset_vastzone();
      if (publisherName !== "") {
        setZoneName_vastzone(publisherName + "-" + platformType_vastzone);
        if ((role !== "admin" && role !== "u_admin")) {
          const selectedPub = publisherList.find(pub => pub.value === selectedPublisher);
          const humanValue = (selectedPublisher !== "" && selectedPub?.isDirect) ? "50" : "0";
          setHuman_vastzone(humanValue)
        }
        else {
          if (gamStatusDirect) {

            setHuman_vastzone("50");
          } else {

            setHuman_vastzone("0");
          }

        }
      }
    }

    else if (event === "vast_aniview") {
      reset_vast_aniview();
      if (publisherName !== "") {
        setChannelName_vast_aniview(
          publisherName + "_" + platformType_vast_aniview
        );
      }
    }


    else if (event === "Player Tag" || event === "tag_outstream") {
      reset_playertag();
      if (event === "tag_outstream") {
        setFloatingPosition_playertag("default")
      }
      if (publisherName !== "") {
        setChannelName_playertag(
          publisherName + "_" + platformType_playertag + "_" + playerMode_playertag?.toLowerCase()
        );
      }
    }

    else if (event === "GAM Tag") {
      reset_gamtag();
      if (publisherName !== "") {
        setAccountName_gamtag(
          publisherName + "_MI"
        );
      }
    }

    else if (event === "GAM") {
      reset_gam();
      if (publisherName !== "") {
        setZoneName_gam(publisherName + "-Website-Video");
      }
    }
  }

  /////////////////////////////////////////////////////prebaid code /////////////////////////////////////////
  const [platformType_prebid, setPlatformType_prebid] = useState("Website");
  const [formatType_prebid, setFormatType_prebid] = useState(["Banner"]);
  const [formatTypeIsRequiredError_prebid, setFormatTypeIsRequiredError_prebid] = useState(false);
  const [integrationType_prebid, setIntegrationType_prebid] =
    useState("OPEN_RTB");
  const [/* integrationTypeOptions_prebid */, setIntegrationTypeOptions_prebid] =
    useState([
      { label: "OpenRTB (Both ADM and nURL)", value: "OPEN_RTB" },
      { label: "ADM (OpenRtb w/o nurl)", value: "OPEN_RTB_WO_NURL" },
      { label: "nURL (OpenRtb nurl only)", value: "OPEN_RTB_NURL_ONLY" },
    ]);
  const [bannerCheckbox_prebid, setBannerCheckbox_prebid] = useState(null);
  const [bannerCheckboxIsRequiredError_prebid, setBannerCheckboxIsRequiredError_prebid] = useState(false);

  const [zoneActiveCheckbox_prebid, setZoneActiveCheckbox_prebid] =
    useState(true);
  const [zoneName_prebid, setZoneName_prebid] = useState("");
  const [zoneNameIsRequiredError_prebid, setZoneNameIsRequiredError_prebid] =
    useState(false);

  const [revSharePercent_prebid, setRevSharePercent_prebid] = useState("100");
  const [revSharePercentIsRequiredError_prebid, setRevSharePercentIsRequiredError_prebid] = useState(false);
  const [revSharePercentValidError_prebid, setRevSharePercentValidError_prebid] = useState(false);
  const [highestBidFloorCheckbox_prebid, setHighestBidFloorCheckbox_prebid] =
    useState(false);
  const [minCpm_prebid, setMinCpm_prebid] = useState("");
  const [minCpmValueError_prebid, setMinCpmValueError_prebid] = useState(false);
  const [maxCpm_prebid, setMaxCpm_prebid] = useState("");
  const [maxCpmValueError_prebid, setMaxCpmValueError_prebid] = useState(false);

  const [request_prebid, setRequest_prebid] = useState("");
  // const [requestIsRequiredError_prebid, setRequestIsRequiredError_prebid] =
  //   useState(false);
  const [requestValueError_prebid, setRequestValueError_prebid] =
    useState(false);
  const [impression_prebid, setImpression_prebid] = useState("");
  // const [
  //   impressionIsRequiredError_prebid,
  //   setImpressionIsRequiredError_prebid,
  // ] = useState(false);
  const [impressionValueError_prebid, setImpressionValueError_prebid] =
    useState(false);

  const [human_prebid, setHuman_prebid] = useState("0");
  const [humanValidError_prebid, setHumanValidError_prebid] = useState(false);
  const [pixalate_prebid, setPixalate_prebid] = useState("25");
  const [pixalateValidError_prebid, setPixalateValidError_prebid] = useState(false);
  const [doubleverify_prebid, setDoubleverify_prebid] = useState("25");
  const [doubleverifyValidError_prebid, setDoubleverifyValidError_prebid] = useState(false);
  const [isAddValueCheckbox_prebid, setIsAddValueCheckbox_prebid] = useState(false);
  const [override_prebid, setOverride_prebid] = useState("");

  function reset_prebid() {
    setPlatformType_prebid("Website");
    setFormatType_prebid(["Banner"]);
    setFormatTypeIsRequiredError_prebid(false)
    // setFormatTypeOptions_prebid([
    //   { label: "Banner", value: "Banner" },
    //   { label: "Video", value: "Video" },
    //   { label: "Native", value: "Native" },
    // ]);
    setIntegrationType_prebid("OPEN_RTB");
    setIntegrationTypeOptions_prebid([
      { label: "OpenRTB (Both ADM and nURL)", value: "OPEN_RTB" },
      { label: "ADM (OpenRtb w/o nurl)", value: "OPEN_RTB_WO_NURL" },
      { label: "nURL (OpenRtb nurl only)", value: "OPEN_RTB_NURL_ONLY" },
    ]);
    setBannerCheckbox_prebid(null);
    setBannerCheckboxIsRequiredError_prebid(false);

    setZoneActiveCheckbox_prebid(true);
    setZoneName_prebid("");
    setZoneNameIsRequiredError_prebid(false);

    setRevSharePercent_prebid("100")
    setRevSharePercentIsRequiredError_prebid(false)
    setRevSharePercentValidError_prebid(false)
    setHighestBidFloorCheckbox_prebid(false)
    setMinCpm_prebid("")
    setMinCpmValueError_prebid(false)
    setMaxCpm_prebid("")
    setMaxCpmValueError_prebid(false)

    setRequest_prebid("");
    //setRequestIsRequiredError_prebid(false);
    setRequestValueError_prebid(false);
    setImpression_prebid("");
    // setImpressionIsRequiredError_prebid(false);
    setImpressionValueError_prebid(false);
    setHuman_prebid("0");
    setHumanValidError_prebid(false);
    setPixalate_prebid("25");
    setPixalateValidError_prebid(false);
    setDoubleverify_prebid("25");
    setDoubleverifyValidError_prebid(false);

    setIsAddValueCheckbox_prebid(false)
    setOverride_prebid("")
  }

  function onChangePlatformType_prebid(event) {
    setPlatformType_prebid(event.target.value);
    if (publisherName !== "") {
      setZoneName_prebid(
        publisherName + "-" + event.target.value + "-" + formatType_prebid?.join(",")
      );
    }
    setZoneNameIsRequiredError_prebid(false);
  }

  function onChangeFormatType_prebid(event) {

    if (event?.length === 0) {
      setFormatTypeIsRequiredError_prebid(true)
    }
    else {
      setFormatTypeIsRequiredError_prebid(false)
    }


    if (!event?.includes("Banner")) {
      setBannerCheckbox_prebid(null);
      setBannerCheckboxIsRequiredError_prebid(false)
    }
    setFormatType_prebid(event);
    if (publisherName !== "") {
      setZoneName_prebid(
        publisherName + "-" + platformType_prebid + "-" + event?.join(",")
      );
    }
    setZoneNameIsRequiredError_prebid(false);
  }

  // function onChangeIntegrationType_prebid(event) {
  //   setIntegrationType_prebid(event);
  // }

  function onChangeBannerCheckbox_prebid(event) {
    setBannerCheckboxIsRequiredError_prebid(false)
    setBannerCheckbox_prebid(event.target.value);
  }

  function onChangeZoneActiveCheckbox_prebid(event) {
    setZoneActiveCheckbox_prebid(event.target.checked);
  }

  function onChangeZoneName_prebid(event) {
    setZoneNameIsRequiredError_prebid(false);
    setZoneName_prebid(event.target.value);
    setNameExists((p) => ({ ...p, prebid: false }));
    debouncedCheckZoneName("prebid", event.target.value);
  }

  function onBlurZoneName_prebid(event) {
    if (event.target.value.trim().length === 0) {
      setZoneNameIsRequiredError_prebid(true);
    }
    setZoneName_prebid(event.target.value.trim());
    if (nameCheckTimers.current.prebid) clearTimeout(nameCheckTimers.current.prebid);
    checkZoneNameUnique("prebid", event.target.value.trim());
  }

  function onChangeRevSharePercent_prebid(event) {
    if (/^\d*\.?\d*$/.test(event.target.value.trim())) {
      setRevSharePercent_prebid(event.target.value.trim());
      if (Number(event.target.value.trim()) >= 0.1 && Number(event.target.value.trim()) <= 100) {
        setRevSharePercentValidError_prebid(false)
        setRevSharePercentIsRequiredError_prebid(false)
      }
      else {
        if (event.target.value.trim() === "") {
          setRevSharePercentValidError_prebid(false)
          setRevSharePercentIsRequiredError_prebid(true)
        }
        else {
          setRevSharePercentIsRequiredError_prebid(false)
          setRevSharePercentValidError_prebid(true)
        }
      }
    }
  }

  function onBlurRevSharePercent_prebid(event) {
    if (event.target.value.trim() === "") {
      setRevSharePercentIsRequiredError_prebid(true)
    }

  }

  function onChangeHighestBidFloorCheckbox_prebid(event) {
    setHighestBidFloorCheckbox_prebid(event.target.checked);
  }

  function onChangeMinCpm_prebid(event) {
    if (/^\d*\.?\d*$/.test(event.target.value.trim())) {

      setMinCpm_prebid(event.target.value.trim());

      if (event.target.value.trim().length === 0) {
        setMinCpmValueError_prebid(false);

      } else {
        let minValCheck = 0.00001;
        let maxValCheck = 50;

        if (
          !(
            event.target.value.trim() >= minValCheck && event.target.value.trim() <= maxValCheck
          )
        ) {

          setMinCpmValueError_prebid(true);
        } else {

          setMinCpmValueError_prebid(false);
        }
      }
    }
  }


  function onChangeMaxCpm_prebid(event) {
    if (/^\d*\.?\d*$/.test(event.target.value.trim())) {
      setMaxCpm_prebid(event.target.value.trim());

      if (event.target.value.trim().length === 0) {
        setMaxCpmValueError_prebid(false);

      } else {
        let minValCheck = 0.00001;
        let maxValCheck = 50;

        if (
          !(
            event.target.value.trim() >= minValCheck && event.target.value.trim() <= maxValCheck
          )
        ) {
          setMaxCpmValueError_prebid(true);
        } else {
          setMaxCpmValueError_prebid(false);
        }
      }
    }
  }

  function onChangeRequest_prebid(event) {
    if (event.target.value.trim().length === 0) {
      setRequestValueError_prebid(false);
      setRequest_prebid(event.target.value.trim());
    } else {
      if (/^\d*$/.test(event.target.value.trim())) {
        setRequest_prebid(event.target.value.trim());
        if (Number(event.target.value.trim()) > 0) {
          setRequestValueError_prebid(false);
        } else {
          setRequestValueError_prebid(true);
        }
      }
    }
  }

  function onBlurRequest_prebid(event) {
    if (event.target.value.trim().length === 0) {
      setRequestValueError_prebid(false);
      // setRequestIsRequiredError_prebid(true);
    } else {
      if (Number(event.target.value.trim()) > 0) {
        setRequestValueError_prebid(false);
      } else {
        // setRequestIsRequiredError_prebid(false);
        setRequestValueError_prebid(true);
      }
    }
    setRequest_prebid(event.target.value.trim());
  }

  function onChangeImpression_prebid(event) {
    if (event.target.value.trim().length === 0) {
      setImpressionValueError_prebid(false);
      setImpression_prebid(event.target.value.trim());
    } else {
      if (/^\d*$/.test(event.target.value.trim())) {
        setImpression_prebid(event.target.value.trim());
        if (Number(event.target.value.trim()) > 0) {
          setImpressionValueError_prebid(false);
        } else {
          setImpressionValueError_prebid(true);
        }
      }
    }
  }

  function onBlurImpression_prebid(event) {
    if (event.target.value.trim().length === 0) {
      setImpressionValueError_prebid(false);
      // setImpressionIsRequiredError_prebid(true);
    } else {
      if (Number(event.target.value.trim()) > 0) {
        setImpressionValueError_prebid(false);
      } else {
        // setImpressionIsRequiredError_prebid(false);
        setImpressionValueError_prebid(true);
      }
    }
    setImpression_prebid(event.target.value.trim());
  }

  function onChangeHuman_prebid(event) {
    if (/^\d*$/.test(event.target.value.trim())) {
      setHuman_prebid(event.target.value.trim());
      if (event.target.value.trim() === "" || (Number(event.target.value.trim()) >= 0 && Number(event.target.value.trim()) <= 100)) {
        setHumanValidError_prebid(false);
      } else {
        setHumanValidError_prebid(true);
      }
    }
  }

  function onBlurHuman_prebid(event) {
    setHuman_prebid(event.target.value.trim());
    if (event.target.value.trim() === "" || !(Number(event.target.value.trim()) >= 0 && Number(event.target.value.trim()) <= 100)) {
      setHumanValidError_prebid(true);
    } else {
      setHumanValidError_prebid(false);
    }
  }

  // PIXALATE SUNSET: Pixalate IVT sampling validation disabled (field hidden, not sent in payload).
  /*
  function onChangePixalate_prebid(event) {
    if (/^\d*$/.test(event.target.value.trim())) {
      setPixalate_prebid(event.target.value.trim());
      if (event.target.value.trim() === "" || (Number(event.target.value.trim()) >= 0 && Number(event.target.value.trim()) <= 100)) {
        setPixalateValidError_prebid(false);
      } else {
        setPixalateValidError_prebid(true);
      }
    }
  }

  function onBlurPixalate_prebid(event) {
    setPixalate_prebid(event.target.value.trim());
    if (event.target.value.trim() === "" || !(Number(event.target.value.trim()) >= 0 && Number(event.target.value.trim()) <= 100)) {
      setPixalateValidError_prebid(true);
    } else {
      setPixalateValidError_prebid(false);
    }
  }
  */

  function onChangeDoubleverify_prebid(event) {
    if (/^\d*$/.test(event.target.value.trim())) {
      setDoubleverify_prebid(event.target.value.trim());
      if (event.target.value.trim() === "" || (Number(event.target.value.trim()) >= 0 && Number(event.target.value.trim()) <= 100)) {
        setDoubleverifyValidError_prebid(false);
      } else {
        setDoubleverifyValidError_prebid(true);
      }
    }
  }

  function onBlurDoubleverify_prebid(event) {
    setDoubleverify_prebid(event.target.value.trim());
    if (event.target.value.trim() === "" || !(Number(event.target.value.trim()) >= 0 && Number(event.target.value.trim()) <= 100)) {
      setDoubleverifyValidError_prebid(true);
    } else {
      setDoubleverifyValidError_prebid(false);
    }
  }

  function onChangeIsAddValueCheckbox_prebid(event) {
    setIsAddValueCheckbox_prebid(event.target.checked);
  }

  function onChangeOverride_prebid(event) {
    setOverride_prebid(event.target.value);
  }

  function onBlurOverride_prebid(event) {
    setOverride_prebid(event.target.value.trim());
  }

  ///////////////////////////////////////////////////open rtb code ///////////////////////////////////////////
  const [platformType_openrtb, setPlatformType_openrtb] = useState("Website");
  const [formatType_openrtb, setFormatType_openrtb] = useState(["Banner"]);
  const [formatTypeIsRequiredError_openrtb, setFormatTypeIsRequiredError_openrtb] = useState(false);
  const [integrationType_openrtb, setIntegrationType_openrtb] =
    useState("OPEN_RTB");
  const [integrationTypeOptions_openrtb, setIntegrationTypeOptions_openrtb] =
    useState([]);

  const [bannerCheckbox_openrtb, setBannerCheckbox_openrtb] = useState(null);
  const [bannerCheckboxIsRequiredError_openrtb, setBannerCheckboxIsRequiredError_openrtb] = useState(false);

  const [zoneActiveCheckbox_openrtb, setZoneActiveCheckbox_openrtb] =
    useState(true);
  const [zoneName_openrtb, setZoneName_openrtb] = useState("");
  const [zoneNameIsRequiredError_openrtb, setZoneNameIsRequiredError_openrtb] =
    useState(false);

  const [revSharePercent_openrtb, setRevSharePercent_openrtb] = useState("100");
  const [revSharePercentIsRequiredError_openrtb, setRevSharePercentIsRequiredError_openrtb] = useState(false);
  const [revSharePercentValidError_openrtb, setRevSharePercentValidError_openrtb] = useState(false);
  const [highestBidFloorCheckbox_openrtb, setHighestBidFloorCheckbox_openrtb] =
    useState(false);
  const [minCpm_openrtb, setMinCpm_openrtb] = useState("");
  const [minCpmValueError_openrtb, setMinCpmValueError_openrtb] = useState(false);
  const [maxCpm_openrtb, setMaxCpm_openrtb] = useState("");
  const [maxCpmValueError_openrtb, setMaxCpmValueError_openrtb] = useState(false);


  const [request_openrtb, setRequest_openrtb] = useState("");
  // const [requestIsRequiredError_openrtb, setRequestIsRequiredError_openrtb] =
  //   useState(false);
  const [requestValueError_openrtb, setRequestValueError_openrtb] =
    useState(false);
  const [impression_openrtb, setImpression_openrtb] = useState("");
  // const [
  //   impressionIsRequiredError_openrtb,
  //   setImpressionIsRequiredError_openrtb,
  // ] = useState(false);
  const [impressionValueError_openrtb, setImpressionValueError_openrtb] =
    useState(false);

  const [human_openrtb, setHuman_openrtb] = useState("0");
  const [humanValidError_openrtb, setHumanValidError_openrtb] = useState(false);
  const [pixalate_openrtb, setPixalate_openrtb] = useState("25");
  const [pixalateValidError_openrtb, setPixalateValidError_openrtb] = useState(false);
  const [doubleverify_openrtb, setDoubleverify_openrtb] = useState("25");
  const [doubleverifyValidError_openrtb, setDoubleverifyValidError_openrtb] = useState(false);
  const [isAddValueCheckbox_openrtb, setIsAddValueCheckbox_openrtb] = useState(false);
  const [override_openrtb, setOverride_openrtb] = useState("");

  function reset_openrtb() {
    setPlatformType_openrtb("Website");
    setFormatType_openrtb(["Banner"]);
    setFormatTypeIsRequiredError_openrtb(false)

    setIntegrationType_openrtb("OPEN_RTB");
    // setIntegrationTypeOptions_openrtb([
    //   { label: "OpenRTB (Both ADM and nURL)", value: "OPEN_RTB" },
    //   { label: "ADM (OpenRtb w/o nurl)", value: "OPEN_RTB_WO_NURL" },
    //   { label: "nURL (OpenRtb nurl only)", value: "OPEN_RTB_NURL_ONLY" },
    // ]);
    setBannerCheckbox_openrtb(null);
    setBannerCheckboxIsRequiredError_openrtb(false);
    setZoneActiveCheckbox_openrtb(true);
    setZoneName_openrtb("");
    setZoneNameIsRequiredError_openrtb(false);

    setRevSharePercent_openrtb("100")
    setRevSharePercentIsRequiredError_openrtb(false)
    setRevSharePercentValidError_openrtb(false)
    setHighestBidFloorCheckbox_openrtb(false)
    setMinCpm_openrtb("")
    setMinCpmValueError_openrtb(false)
    setMaxCpm_openrtb("")
    setMaxCpmValueError_openrtb(false)

    setRequest_openrtb("");
    //setRequestIsRequiredError_openrtb(false);
    setRequestValueError_openrtb(false);
    setImpression_openrtb("");
    // setImpressionIsRequiredError_openrtb(false);
    setImpressionValueError_openrtb(false);
    setHuman_openrtb("0");
    setHumanValidError_openrtb(false);
    setPixalate_openrtb("25");
    setPixalateValidError_openrtb(false);
    setDoubleverify_openrtb("25");
    setDoubleverifyValidError_openrtb(false);

    setIsAddValueCheckbox_openrtb(false)
    setOverride_openrtb("")
  }

  function onChangePlatformType_openrtb(event) {

    if (event.target.value === "CTV") {
      setBannerCheckbox_openrtb(null)
      setBannerCheckboxIsRequiredError_openrtb(false)
    }

    setPlatformType_openrtb(event.target.value);
    if (publisherName !== "") {
      if (event.target.value === "CTV") {
        setZoneName_openrtb(
          publisherName + "-" + event.target.value + "-Video"
        );
      }
      else {
        setZoneName_openrtb(
          publisherName + "-" + event.target.value + "-" + formatType_openrtb?.join(",")
        );
      }

    }
    setZoneNameIsRequiredError_openrtb(false);
  }

  function onChangeFormatType_openrtb(event) {
    if (event?.length === 0) {
      setFormatTypeIsRequiredError_openrtb(true)
    }
    else {
      setFormatTypeIsRequiredError_openrtb(false)
    }


    if (!event?.includes("Banner")) {
      setBannerCheckbox_openrtb(null);
      setBannerCheckboxIsRequiredError_openrtb(false)
    }
    setFormatType_openrtb(event);
    if (publisherName !== "") {
      setZoneName_openrtb(
        publisherName + "-" + platformType_openrtb + "-" + event?.join(",")
      );
    }
    setZoneNameIsRequiredError_openrtb(false);
  }

  function onChangeIntegrationType_openrtb(event) {
    setIntegrationType_openrtb(event);
  }

  function onChangeBannerCheckbox_openrtb(event) {
    setBannerCheckboxIsRequiredError_openrtb(false)
    setBannerCheckbox_openrtb(event.target.value);
  }

  function onChangeZoneActiveCheckbox_openrtb(event) {
    setZoneActiveCheckbox_openrtb(event.target.checked);
  }

  function onChangeZoneName_openrtb(event) {
    setZoneNameIsRequiredError_openrtb(false);
    setZoneName_openrtb(event.target.value);
    setNameExists((p) => ({ ...p, openrtb: false }));
    debouncedCheckZoneName("openrtb", event.target.value);
  }

  function onBlurZoneName_openrtb(event) {
    if (event.target.value.trim().length === 0) {
      setZoneNameIsRequiredError_openrtb(true);
    }
    setZoneName_openrtb(event.target.value.trim());
    if (nameCheckTimers.current.openrtb) clearTimeout(nameCheckTimers.current.openrtb);
    checkZoneNameUnique("openrtb", event.target.value.trim());
  }


  function onChangeRevSharePercent_openrtb(event) {
    if (/^\d*\.?\d*$/.test(event.target.value.trim())) {
      setRevSharePercent_openrtb(event.target.value.trim());
      if (Number(event.target.value.trim()) >= 0.1 && Number(event.target.value.trim()) <= 100) {
        setRevSharePercentValidError_openrtb(false)
        setRevSharePercentIsRequiredError_openrtb(false)
      }
      else {
        if (event.target.value.trim() === "") {
          setRevSharePercentValidError_openrtb(false)
          setRevSharePercentIsRequiredError_openrtb(true)
        }
        else {
          setRevSharePercentIsRequiredError_openrtb(false)
          setRevSharePercentValidError_openrtb(true)
        }
      }
    }
  }

  function onBlurRevSharePercent_openrtb(event) {
    if (event.target.value.trim() === "") {
      setRevSharePercentIsRequiredError_openrtb(true)
    }

  }

  function onChangeHighestBidFloorCheckbox_openrtb(event) {
    setHighestBidFloorCheckbox_openrtb(event.target.checked);
  }

  function onChangeMinCpm_openrtb(event) {
    if (/^\d*\.?\d*$/.test(event.target.value.trim())) {

      setMinCpm_openrtb(event.target.value.trim());

      if (event.target.value.trim().length === 0) {
        setMinCpmValueError_openrtb(false);

      } else {
        let minValCheck = 0.00001;
        let maxValCheck = 50;

        if (
          !(
            event.target.value.trim() >= minValCheck && event.target.value.trim() <= maxValCheck
          )
        ) {

          setMinCpmValueError_openrtb(true);
        } else {

          setMinCpmValueError_openrtb(false);
        }
      }
    }
  }


  function onChangeMaxCpm_openrtb(event) {
    if (/^\d*\.?\d*$/.test(event.target.value.trim())) {
      setMaxCpm_openrtb(event.target.value.trim());

      if (event.target.value.trim().length === 0) {
        setMaxCpmValueError_openrtb(false);

      } else {
        let minValCheck = 0.00001;
        let maxValCheck = 50;

        if (
          !(
            event.target.value.trim() >= minValCheck && event.target.value.trim() <= maxValCheck
          )
        ) {
          setMaxCpmValueError_openrtb(true);
        } else {
          setMaxCpmValueError_openrtb(false);
        }
      }
    }
  }

  function onChangeRequest_openrtb(event) {
    if (event.target.value.trim().length === 0) {
      setRequestValueError_openrtb(false);
      setRequest_openrtb(event.target.value.trim());
    } else {
      if (/^\d*$/.test(event.target.value.trim())) {
        setRequest_openrtb(event.target.value.trim());
        if (Number(event.target.value.trim()) > 0) {
          setRequestValueError_openrtb(false);
        } else {
          setRequestValueError_openrtb(true);
        }
      }
    }
  }

  function onBlurRequest_openrtb(event) {
    if (event.target.value.trim().length === 0) {
      setRequestValueError_openrtb(false);
      // setRequestIsRequiredError_openrtb(true);
    } else {
      if (Number(event.target.value.trim()) > 0) {
        setRequestValueError_openrtb(false);
      } else {
        // setRequestIsRequiredError_openrtb(false);
        setRequestValueError_openrtb(true);
      }
    }
    setRequest_openrtb(event.target.value.trim());
  }

  function onChangeImpression_openrtb(event) {
    if (event.target.value.trim().length === 0) {
      setImpressionValueError_openrtb(false);
      setImpression_openrtb(event.target.value.trim());
    } else {
      if (/^\d*$/.test(event.target.value.trim())) {
        setImpression_openrtb(event.target.value.trim());
        if (Number(event.target.value.trim()) > 0) {
          setImpressionValueError_openrtb(false);
        } else {
          setImpressionValueError_openrtb(true);
        }
      }
    }
  }

  function onBlurImpression_openrtb(event) {
    if (event.target.value.trim().length === 0) {
      setImpressionValueError_openrtb(false);
      // setImpressionIsRequiredError_openrtb(true);
    } else {
      if (Number(event.target.value.trim()) > 0) {
        setImpressionValueError_openrtb(false);
      } else {
        // setImpressionIsRequiredError_openrtb(false);
        setImpressionValueError_openrtb(true);
      }
    }
    setImpression_openrtb(event.target.value.trim());
  }

  function onChangeHuman_openrtb(event) {
    if (/^\d*$/.test(event.target.value.trim())) {
      setHuman_openrtb(event.target.value.trim());
      if (event.target.value.trim() === "" || (Number(event.target.value.trim()) >= 0 && Number(event.target.value.trim()) <= 100)) {
        setHumanValidError_openrtb(false);
      } else {
        setHumanValidError_openrtb(true);
      }
    }
  }

  function onBlurHuman_openrtb(event) {
    setHuman_openrtb(event.target.value.trim());
    if (event.target.value.trim() === "" || !(Number(event.target.value.trim()) >= 0 && Number(event.target.value.trim()) <= 100)) {
      setHumanValidError_openrtb(true);
    } else {
      setHumanValidError_openrtb(false);
    }
  }

  // PIXALATE SUNSET: Pixalate IVT sampling validation disabled (field hidden, not sent in payload).
  /*
  function onChangePixalate_openrtb(event) {
    if (/^\d*$/.test(event.target.value.trim())) {
      setPixalate_openrtb(event.target.value.trim());
      if (event.target.value.trim() === "" || (Number(event.target.value.trim()) >= 0 && Number(event.target.value.trim()) <= 100)) {
        setPixalateValidError_openrtb(false);
      } else {
        setPixalateValidError_openrtb(true);
      }
    }
  }

  function onBlurPixalate_openrtb(event) {
    setPixalate_openrtb(event.target.value.trim());
    if (event.target.value.trim() === "" || !(Number(event.target.value.trim()) >= 0 && Number(event.target.value.trim()) <= 100)) {
      setPixalateValidError_openrtb(true);
    } else {
      setPixalateValidError_openrtb(false);
    }
  }
  */

  function onChangeDoubleverify_openrtb(event) {
    if (/^\d*$/.test(event.target.value.trim())) {
      setDoubleverify_openrtb(event.target.value.trim());
      if (event.target.value.trim() === "" || (Number(event.target.value.trim()) >= 0 && Number(event.target.value.trim()) <= 100)) {
        setDoubleverifyValidError_openrtb(false);
      } else {
        setDoubleverifyValidError_openrtb(true);
      }
    }
  }

  function onBlurDoubleverify_openrtb(event) {
    setDoubleverify_openrtb(event.target.value.trim());
    if (event.target.value.trim() === "" || !(Number(event.target.value.trim()) >= 0 && Number(event.target.value.trim()) <= 100)) {
      setDoubleverifyValidError_openrtb(true);
    } else {
      setDoubleverifyValidError_openrtb(false);
    }
  }

  function onChangeIsAddValueCheckbox_openrtb(event) {
    setIsAddValueCheckbox_openrtb(event.target.checked);
  }

  function onChangeOverride_openrtb(event) {
    setOverride_openrtb(event.target.value);
  }

  function onBlurOverride_openrtb(event) {
    setOverride_openrtb(event.target.value.trim());
  }


  /////////////////////////////////////////////////////publica code ///////////////////////////////////////////

  const [platformType_publica, setPlatformType_publica] = useState("CTV");

  const [vastVersion_publica, setVastVersion_publica] = useState("3");
  const [vastVersionOptions_publica] = useState([
    { label: "2", value: "2" },
    { label: "3", value: "3" },
    { label: "4", value: "4" },
    { label: "4.1", value: "4.1" },
  ]);

  const [channelName_publica, setChannelName_publica] = useState("");
  const [channelNameIsRequiredError_publica, setChannelNameIsRequiredError_publica] =
    useState(false);

  const [region_publica, setRegion_publica] = useState("");
  const [regionIsRequiredError_publica, setRegionIsRequiredError_publica] = useState(false);
  const [regionOptions_publica] = useState([
    { label: "APAC", value: "ap-southeast-2" },
    { label: "Europe", value: "eu-west-1" },
    { label: "Japan", value: "ap-northeast-1" },
    { label: "USA", value: "us-east-1" },
  ]);

  const [eCpm_publica, setECpm_publica] = useState("");
  const [eCpmIsRequiredError_publica, setECpmIsRequiredError_publica] = useState(false);
  const [eCpmValidError_publica, setECpmValidError_publica] = useState(false);


  const [bidAdjustment_publica, setBidAdjustment_publica] = useState("");
  const [bidAdjustmentIsRequiredError_publica, setBidAdjustmentIsRequiredError_publica] = useState(false);
  const [bidAdjustmentValidError_publica, setBidAdjustmentValidError_publica] = useState(false);

  const [bidValue_publica, setBidValue_publica] = useState("0");
  const [bidValueValidError_publica, setBidValueValidError_publica] = useState(false);

  const [asi_publica, setAsi_publica] = useState("xapads.com");
  const [asiIsRequiredError_publica, setAsiIsRequiredError_publica] =
    useState(false);

  const [sid_publica, setSid_publica] = useState("");
  const [sidIsRequiredError_publica, setSidIsRequiredError_publica] =
    useState(false);

  const [name_publica, setName_publica] = useState("Xapads");
  const [nameIsRequiredError_publica, setNameIsRequiredError_publica] =
    useState(false);

  const [domain_publica, setDomain_publica] = useState("xapads.com");
  const [domainIsRequiredError_publica, setDomainIsRequiredError_publica] =
    useState(false);


  const [isAddValueCheckbox_publica, setIsAddValueCheckbox_publica] =
    useState(false);
  const [override_publica, setOverride_publica] = useState("");


  function reset_publica() {
    setPlatformType_publica("CTV")
    setVastVersion_publica("3")
    setChannelName_publica("")
    setChannelNameIsRequiredError_publica(false)
    setRegion_publica("")
    setRegionIsRequiredError_publica(false)
    setECpm_publica("")
    setECpmIsRequiredError_publica(false)
    setECpmValidError_publica(false)
    setBidAdjustment_publica("")
    setBidAdjustmentIsRequiredError_publica(false)
    setBidAdjustmentValidError_publica(false)
    setBidValue_publica("0")
    setBidValueValidError_publica(false)
    setAsi_publica("xapads.com")
    setAsiIsRequiredError_publica(false)
    if (selectedPublisher !== "") {
      setSid_publica(selectedPublisher.split("-")[0])
    }
    else {
      setSid_publica("")
    }

    setSidIsRequiredError_publica(false)
    setName_publica("Xapads")
    setNameIsRequiredError_publica(false)
    setDomain_publica("xapads.com")
    setDomainIsRequiredError_publica(false)
    setIsAddValueCheckbox_publica(false)
    setOverride_publica("")
    setTemplate_publica("")
    setTemplateIsRequiredError_publica(false)
    setTemplateText_publica("")
    setHuman_publica("0");
    setHumanValidError_publica(false);
    setPixalate_publica("25");
    setPixalateValidError_publica(false);
    setDoubleverify_publica("25");
    setDoubleverifyValidError_publica(false);
  }


  function onChangePlatformType_publica(event) {
    setPlatformType_publica(event.target.value);
  }

  function onChangeVastVersion_publica(event) {
    setVastVersion_publica(event);
  }

  function onChangeChannelName_publica(event) {
    setChannelNameIsRequiredError_publica(false);
    setChannelName_publica(event.target.value);
    setNameExists((p) => ({ ...p, publica: false }));
    debouncedCheckZoneName("publica", event.target.value);
  }

  function onBlurChannelName_publica(event) {
    if (event.target.value.trim().length === 0) {
      setChannelNameIsRequiredError_publica(true);
    }
    setChannelName_publica(event.target.value.trim());
    if (nameCheckTimers.current.publica) clearTimeout(nameCheckTimers.current.publica);
    checkZoneNameUnique("publica", event.target.value.trim());
  }

  function onChangeRegion_publica(event) {
    setRegionIsRequiredError_publica(false)
    setRegion_publica(event);
  }

  function onChangeECpm_publica(event) {
    setECpmIsRequiredError_publica(false);
    if (/^\d*\.?\d{0,2}$/.test(event.target.value.trim())) {
      setECpm_publica(event.target.value.trim());
      if (Number(event.target.value.trim()) >= 0) {
        setECpmValidError_publica(false)
      }
      else {
        setECpmValidError_publica(true)
      }
    }
  }

  function onBlurECpm_publica(event) {
    if (event.target.value.trim().length === 0) {
      setECpmValidError_publica(false);
      setECpmIsRequiredError_publica(true);
    } else {
      if (Number(event.target.value.trim()) >= 0) {
        setECpmValidError_publica(false);
      } else {
        setECpmIsRequiredError_publica(false);
        setECpmValidError_publica(true);
      }
    }
    setECpm_publica(event.target.value.trim());
    if (event.target.value.trim().length > 0) {
      setBidAdjustment_publica(Math.round((Number(event.target.value.trim()) * 100) / (Number(event.target.value.trim()) + 2.5)))
      setBidAdjustmentIsRequiredError_publica(false)
      setBidAdjustmentValidError_publica(false)
    }
    else {
      setBidAdjustment_publica("")
      setBidAdjustmentValidError_publica(false)
      setBidAdjustmentIsRequiredError_publica(true)

    }

  }

  function onChangeBidAdjustment_publica(event) {
    setBidAdjustmentIsRequiredError_publica(false);
    if (/^\d*\.?\d{0,2}$/.test(event.target.value.trim())) {
      setBidAdjustment_publica(event.target.value.trim());
      if (Number(event.target.value.trim()) >= 0 && Number(event.target.value.trim()) <= 100) {
        setBidAdjustmentValidError_publica(false)
      }
      else {
        setBidAdjustmentValidError_publica(true)
      }
    }
  }

  function onBlurBidAdjustment_publica(event) {
    if (event.target.value.trim().length === 0) {
      setBidAdjustmentValidError_publica(false);
      setBidAdjustmentIsRequiredError_publica(true);
    } else {
      if (Number(event.target.value.trim()) >= 0 && Number(event.target.value.trim()) <= 100) {
        setBidAdjustmentValidError_publica(false);
      } else {
        setBidAdjustmentIsRequiredError_publica(false);
        setBidAdjustmentValidError_publica(true);
      }
    }
    setBidAdjustment_publica(event.target.value.trim());
  }

  function onChangeBidValue_publica(event) {
    if (/^\d*\.?\d{0,2}$/.test(event.target.value.trim())) {
      setBidValue_publica(event.target.value.trim());
      if (Number(event.target.value.trim()) >= 0) {
        setBidValueValidError_publica(false)
      }
      else {
        setBidValueValidError_publica(true)
      }
    }
  }

  function onBlurBidValue_publica(event) {
    if (event.target.value.trim().length === 0) {
      setBidValueValidError_publica(false);
    } else {
      if (Number(event.target.value.trim()) >= 0) {
        setBidValueValidError_publica(false);
      } else {
        setBidValueValidError_publica(true);
      }
    }
    setBidValue_publica(event.target.value.trim());
  }


  function onChangeAsi_publica(event) {

    setAsiIsRequiredError_publica(false);
    setAsi_publica(event.target.value);
  }

  function onBlurAsi_publica(event) {
    if (event.target.value.trim().length === 0) {
      setAsiIsRequiredError_publica(true);
    }
    setAsi_publica(event.target.value.trim());
  }

  function onChangeSid_publica(event) {

    setSidIsRequiredError_publica(false);
    setSid_publica(event.target.value);
  }

  function onBlurSid_publica(event) {
    if (event.target.value.trim().length === 0) {
      setSidIsRequiredError_publica(true);
    }
    setSid_publica(event.target.value.trim());
  }

  function onChangeName_publica(event) {

    setNameIsRequiredError_publica(false);
    setName_publica(event.target.value);
  }

  function onBlurName_publica(event) {
    if (event.target.value.trim().length === 0) {
      setNameIsRequiredError_publica(true);
    }
    setName_publica(event.target.value.trim());
  }

  function onChangeDomain_publica(event) {

    setDomainIsRequiredError_publica(false);
    setDomain_publica(event.target.value);
  }

  function onBlurDomain_publica(event) {
    if (event.target.value.trim().length === 0) {
      setDomainIsRequiredError_publica(true);
    }
    setDomain_publica(event.target.value.trim());
  }


  function onChangeIsAddValueCheckbox_publica(event) {
    setIsAddValueCheckbox_publica(event.target.checked);
  }

  function onChangeOverride_publica(event) {

    setOverride_publica(event.target.value);
  }

  function onBlurOverride_publica(event) {
    setOverride_publica(event.target.value.trim());
  }


  //--------------------------------------------------------------------------------------------------------
  const [template_publica, setTemplate_publica] = useState("");
  const [templateIsRequiredError_publica, setTemplateIsRequiredError_publica] = useState(false);
  const [templateOptions_publica, setTemplateOptions_publica] = useState([]);

  const [templateText_publica, setTemplateText_publica] = useState("");

  const [human_publica, setHuman_publica] = useState("0");
  const [humanValidError_publica, setHumanValidError_publica] = useState(false);
  const [pixalate_publica, setPixalate_publica] = useState("25");
  const [pixalateValidError_publica, setPixalateValidError_publica] = useState(false);
  const [doubleverify_publica, setDoubleverify_publica] = useState("25");
  // eslint-disable-next-line 
  const [doubleverifyValidError_publica, setDoubleverifyValidError_publica] = useState(false);

  function onChangeTemplate_publica(event) {
    setTemplateIsRequiredError_publica(false)
    setTemplate_publica(event);

    let selectedTemplate = templateOptions_publica?.find(
      (template) => template.value === event
    );

    setTemplateText_publica(selectedTemplate?.template)
  }

  // function onChangeHuman_publica(event) {
  //   if (/^\d*$/.test(event.target.value.trim())) {
  //     setHuman_publica(event.target.value.trim());
  //     if (event.target.value.trim() === "" || (Number(event.target.value.trim()) >= 0 && Number(event.target.value.trim()) <= 100)) {
  //       setHumanValidError_publica(false);
  //     } else {
  //       setHumanValidError_publica(true);
  //     }
  //   }
  // }

  // function onBlurHuman_publica(event) {
  //   setHuman_publica(event.target.value.trim());
  //   if (event.target.value.trim() === "" || !(Number(event.target.value.trim()) >= 0 && Number(event.target.value.trim()) <= 100)) {
  //     setHumanValidError_publica(true);
  //   } else {
  //     setHumanValidError_publica(false);
  //   }
  // }

  // function onChangePixalate_publica(event) {
  //   if (/^\d*$/.test(event.target.value.trim())) {
  //     setPixalate_publica(event.target.value.trim());
  //     if (event.target.value.trim() === "" || (Number(event.target.value.trim()) >= 0 && Number(event.target.value.trim()) <= 100)) {
  //       setPixalateValidError_publica(false);
  //     } else {
  //       setPixalateValidError_publica(true);
  //     }
  //   }
  // }

  // function onBlurPixalate_publica(event) {
  //   setPixalate_publica(event.target.value.trim());
  //   if (event.target.value.trim() === "" || !(Number(event.target.value.trim()) >= 0 && Number(event.target.value.trim()) <= 100)) {
  //     setPixalateValidError_publica(true);
  //   } else {
  //     setPixalateValidError_publica(false);
  //   }
  // }


  //modal opening template  ------
  const [isTemplateModalOpen, setTemplateModalOpen] = useState(false);
  const [isDropdownOpenTemplate, setIsDropdownOpenTemplate] = useState(false); // Control dropdown open state
  const [templateModalContext, setTemplateModalContext] = useState("publica"); // "publica" or "vastzone"

  const openTemplateModal = (context = "publica") => {
    setTemplateModalContext(context);
    setTemplateModalOpen(true);
    setIsDropdownOpenTemplate(false); // Close the Select dropdown
    setIsDropdownOpenTemplate_vastzone(false);
  };

  const closeTemplateModal = () => {
    setTemplateModalOpen(false);
    setNameTemplate_html("")
    setNameTemplate_htmlIsRequiredError(false)
    setTagTemplate_html("")
    setTagTemplate_htmlIsRequiredError(false)
  };



  const [nameTemplate_html, setNameTemplate_html] = useState("");
  const [nameTemplate_htmlIsRequiredError, setNameTemplate_htmlIsRequiredError] =
    useState(false);

  function onChangeNameTemplate_html(event) {
    setNameTemplate_htmlIsRequiredError(false);
    setNameTemplate_html(event.target.value);
  }

  function onBlurNameTemplate_html(event) {
    if (event.target.value.trim().length === 0) {
      setNameTemplate_htmlIsRequiredError(true);
    }
    setNameTemplate_html(event.target.value.trim());
  }

  const [tagTemplate_html, setTagTemplate_html] = useState("");
  const [tagTemplate_htmlIsRequiredError, setTagTemplate_htmlIsRequiredError] =
    useState(false);

  function onChangeTagTemplate_html(event) {
    setTagTemplate_htmlIsRequiredError(false);
    setTagTemplate_html(event.target.value);
  }

  function onBlurTagTemplate_html(event) {
    if (event.target.value.trim().length === 0) {
      setTagTemplate_htmlIsRequiredError(true);
    }
    setTagTemplate_html(event.target.value.trim());
  }

  function handleTemplateCreationValidation() {

    if (
      nameTemplate_html.trim().length !== 0 &&
      tagTemplate_html.trim().length !== 0
    ) {
      if (
        nameTemplate_htmlIsRequiredError === false &&
        tagTemplate_htmlIsRequiredError === false
      ) {

        let payload = {
          label: nameTemplate_html.trim(),
          value: tagTemplate_html.trim(),
          zone_type: templateModalContext
        }

        if (templateModalContext === "vastzone") {
          payload.invent_type = platformType_vastzone;
        }

        const token = Cookies.get("token_xapads_ssp");

        axios
          .post(`${configData.SERVER_URL}${templateModalContext === "vastzone"
            ? "zone/createAdkTemp"
            : "publica/createTemp"
            }`, payload, {
            headers: {
              'Content-Type': 'application/json',
              "x-access-token": token
            },
          })
          .then((response) => {
            notifysuccess(response.data.message);

            const fetchEndpoint = templateModalContext === "vastzone" ? "zone/getAdKTempList" : "publica/templates";
            axios
              .get(configData.SERVER_URL + fetchEndpoint, {
                headers: {
                  "Content-Type": "application/json",
                  "x-access-token": token
                },
              })
              .then((response) => {
                if (templateModalContext === "vastzone") {
                  setTemplateOptions_vastzone(response.data);
                } else {
                  setTemplateOptions_publica(response.data.data);
                }
              })
              .catch((error) => {
                if (error?.response) {
                  if (error.response.data.message?.length !== 0) {
                    notifyfailure(error.response.data.message);
                  }
                } else {
                  notifycatch();
                }
              });

            closeTemplateModal()
          })
          .catch((error) => {
            if (error?.response) {
              if (error.response.data.message?.length !== 0) {
                notifyfailure(error.response.data.message);
                // setButtonProcessing(false)
              }
            } else {
              notifycatch();
              // setButtonProcessing(false)
            }

          });


      }

    }
    else {

      if (nameTemplate_html.trim().length === 0) {
        setNameTemplate_htmlIsRequiredError(true);
      }

      if (tagTemplate_html.trim().length === 0) {
        setTagTemplate_htmlIsRequiredError(true);
      }

    }

  }

  ///////////////////////////////////////////////////vast zone code ///////////////////////////////////////////

  const [platformType_vastzone, setPlatformType_vastzone] = useState("Website");

  const [streamPosition_vastzone, setStreamPosition_vastzone] = useState("Outstream");
  const [streamPositionOptions_vastzone, setStreamPositionOptions_vastzone] = useState([
    { label: "Outstream", value: "Outstream" },
    { label: "Instream", value: "Instream" },
  ]);

  const [zoneActiveCheckbox_vastzone, setZoneActiveCheckbox_vastzone] =
    useState(true);
  const [zoneName_vastzone, setZoneName_vastzone] = useState("");
  const [zoneNameIsRequiredError_vastzone, setZoneNameIsRequiredError_vastzone] =
    useState(false);


  const [revenueType_vastzone, setRevenueType_vastzone] = useState("Fixed_Price");
  const [revenueTypeOptions_vastzone, setRevenueTypeOptions_vastzone] = useState([
    { label: "Fixed Price", value: "Fixed_Price" },
    // { label: "Revshare", value: "Revshare" },
  ]);

  const [eCpm_vastzone, setECpm_vastzone] = useState("");
  const [eCpmIsRequiredError_vastzone, setECpmIsRequiredError_vastzone] = useState("");
  const [eCpmValidError_vastzone, setECpmValidError_vastzone] = useState("");


  const [revSharePercent_vastzone, setRevSharePercent_vastzone] = useState("");
  const [revSharePercentIsRequiredError_vastzone, setRevSharePercentIsRequiredError_vastzone] = useState("");
  const [revSharePercentValidError_vastzone, setRevSharePercentValidError_vastzone] = useState("");



  const [request_vastzone, setRequest_vastzone] = useState("");
  // const [requestIsRequiredError_vastzone, setRequestIsRequiredError_vastzone] =
  //   useState(false);
  const [requestValueError_vastzone, setRequestValueError_vastzone] =
    useState(false);
  const [impression_vastzone, setImpression_vastzone] = useState("");
  // const [
  //   impressionIsRequiredError_vastzone,
  //   setImpressionIsRequiredError_vastzone,
  // ] = useState(false);
  const [impressionValueError_vastzone, setImpressionValueError_vastzone] =
    useState(false);

  const [human_vastzone, setHuman_vastzone] = useState("0");
  const [humanValidError_vastzone, setHumanValidError_vastzone] = useState(false);
  const [pixalate_vastzone, setPixalate_vastzone] = useState("25");
  const [pixalateValidError_vastzone, setPixalateValidError_vastzone] = useState(false);
  const [doubleverify_vastzone, setDoubleverify_vastzone] = useState("25");
  const [doubleverifyValidError_vastzone, setDoubleverifyValidError_vastzone] = useState(false);
  const [isAddValueCheckbox_vastzone, setIsAddValueCheckbox_vastzone] = useState(false);
  const [override_vastzone, setOverride_vastzone] = useState("");
  const [template_vastzone, setTemplate_vastzone] = useState("");
  const [templateIsRequiredError_vastzone, setTemplateIsRequiredError_vastzone] = useState(false);
  const [templateOptions_vastzone, setTemplateOptions_vastzone] = useState({});
  const [templateText_vastzone, setTemplateText_vastzone] = useState("");
  const [isDropdownOpenTemplate_vastzone, setIsDropdownOpenTemplate_vastzone] = useState(false);

  function reset_vastzone() {
    setPlatformType_vastzone("Website");
    setStreamPosition_vastzone("Outstream");
    setStreamPositionOptions_vastzone([
      { label: "Outstream", value: "Outstream" },
      { label: "Instream", value: "Instream" },
    ]);

    setZoneActiveCheckbox_vastzone(true);
    setZoneName_vastzone("");
    setZoneNameIsRequiredError_vastzone(false);
    setRevenueType_vastzone("Fixed_Price");
    setRevenueTypeOptions_vastzone([
      { label: "Fixed Price", value: "Fixed_Price" },
      { label: "Revshare", value: "Revshare" },
    ]);
    setECpm_vastzone("");
    setECpmIsRequiredError_vastzone("");
    setECpmValidError_vastzone("");
    setRevSharePercent_vastzone("");
    setRevSharePercentIsRequiredError_vastzone("");
    setRevSharePercentValidError_vastzone("");
    setRequest_vastzone("");
    // setRequestIsRequiredError_vastzone(false);
    setRequestValueError_vastzone(false);
    setImpression_vastzone("");
    // setImpressionIsRequiredError_vastzone(false);
    setImpressionValueError_vastzone(false);
    setHuman_vastzone("0");
    setHumanValidError_vastzone(false);
    setPixalate_vastzone("25");
    setPixalateValidError_vastzone(false);
    setDoubleverify_vastzone("25");
    setDoubleverifyValidError_vastzone(false);

    setIsAddValueCheckbox_vastzone(false)
    setOverride_vastzone("")
    setTemplate_vastzone("")
    setTemplateIsRequiredError_vastzone(false)
    setTemplateText_vastzone("")
  }

  function onChangePlatformType_vastzone(event) {
    setPlatformType_vastzone(event.target.value);
    if (publisherName !== "") {
      setZoneName_vastzone(
        publisherName + "-" + event.target.value
      );
    }
    setZoneNameIsRequiredError_vastzone(false);
    setTemplate_vastzone("");
    setTemplateText_vastzone("");
    setTemplateIsRequiredError_vastzone(false);
  }

  function onChangeStreamPosition_vastzone(event) {
    setStreamPosition_vastzone(event);
  }



  function onChangeZoneActiveCheckbox_vastzone(event) {
    setZoneActiveCheckbox_vastzone(event.target.checked);
  }

  function onChangeZoneName_vastzone(event) {
    setZoneNameIsRequiredError_vastzone(false);
    setZoneName_vastzone(event.target.value);
    setNameExists((p) => ({ ...p, vastzone: false }));
    debouncedCheckZoneName("vastzone", event.target.value);
  }

  function onBlurZoneName_vastzone(event) {
    if (event.target.value.trim().length === 0) {
      setZoneNameIsRequiredError_vastzone(true);
    }
    setZoneName_vastzone(event.target.value.trim());
    if (nameCheckTimers.current.vastzone) clearTimeout(nameCheckTimers.current.vastzone);
    checkZoneNameUnique("vastzone", event.target.value.trim());
  }

  function onChangeRevenueType_vastzone(event) {
    setRevenueType_vastzone(event);
    setECpm_vastzone("");
    setECpmIsRequiredError_vastzone(false);
    setECpmValidError_vastzone(false);
    setRevSharePercent_vastzone("");
    setRevSharePercentIsRequiredError_vastzone(false);
    setRevSharePercentValidError_vastzone(false);
  }


  function onChangeECpm_vastzone(event) {
    setECpmIsRequiredError_vastzone(false);
    if (/^\d*\.?\d*$/.test(event.target.value.trim())) {
      setECpm_vastzone(event.target.value.trim());
      if (Number(event.target.value.trim()) > 0 && Number(event.target.value.trim()) < 100) {
        setECpmValidError_vastzone(false)
      }
      else {
        setECpmValidError_vastzone(true)
      }
    }
  }

  function onBlurECpm_vastzone(event) {
    if (event.target.value.trim().length === 0) {
      setECpmValidError_vastzone(false);
      setECpmIsRequiredError_vastzone(true);
    } else {
      if (Number(event.target.value.trim()) > 0 && Number(event.target.value.trim()) < 100) {
        setECpmValidError_vastzone(false);
      } else {
        setECpmIsRequiredError_vastzone(false);
        setECpmValidError_vastzone(true);
      }
    }
    setECpm_vastzone(event.target.value.trim());
  }

  function onChangeRevSharePercent_vastzone(event) {
    setRevSharePercentIsRequiredError_vastzone(false);
    if (/^\d*\.?\d*$/.test(event.target.value.trim())) {
      setRevSharePercent_vastzone(event.target.value.trim());
      if (Number(event.target.value.trim()) > 0 && Number(event.target.value.trim()) <= 80) {
        setRevSharePercentValidError_vastzone(false)
      }
      else {
        setRevSharePercentValidError_vastzone(true)
      }
    }
  }

  function onBlurRevSharePercent_vastzone(event) {
    if (event.target.value.trim().length === 0) {
      setRevSharePercentValidError_vastzone(false);
      setRevSharePercentIsRequiredError_vastzone(true);
    } else {
      if (Number(event.target.value.trim()) > 0 && Number(event.target.value.trim()) <= 80) {
        setRevSharePercentValidError_vastzone(false);
      } else {
        setRevSharePercentIsRequiredError_vastzone(false);
        setRevSharePercentValidError_vastzone(true);
      }
    }
    setRevSharePercent_vastzone(event.target.value.trim());
  }


  function onChangeRequest_vastzone(event) {
    if (event.target.value.trim().length === 0) {
      setRequestValueError_vastzone(false);
      setRequest_vastzone(event.target.value.trim());
    } else {
      if (/^\d*$/.test(event.target.value.trim())) {
        setRequest_vastzone(event.target.value.trim());
        if (Number(event.target.value.trim()) > 0) {
          setRequestValueError_vastzone(false);
        } else {
          setRequestValueError_vastzone(true);
        }
      }
    }
  }

  function onBlurRequest_vastzone(event) {
    if (event.target.value.trim().length === 0) {
      setRequestValueError_vastzone(false);
      // setRequestIsRequiredError_vastzone(true);
    } else {
      if (Number(event.target.value.trim()) > 0) {
        setRequestValueError_vastzone(false);
      } else {
        // setRequestIsRequiredError_vastzone(false);
        setRequestValueError_vastzone(true);
      }
    }
    setRequest_vastzone(event.target.value.trim());
  }

  function onChangeImpression_vastzone(event) {
    if (event.target.value.trim().length === 0) {
      setImpressionValueError_vastzone(false);
      setImpression_vastzone(event.target.value.trim());
    } else {
      if (/^\d*$/.test(event.target.value.trim())) {
        setImpression_vastzone(event.target.value.trim());
        if (Number(event.target.value.trim()) > 0) {
          setImpressionValueError_vastzone(false);
        } else {
          setImpressionValueError_vastzone(true);
        }
      }
    }
  }

  function onBlurImpression_vastzone(event) {
    if (event.target.value.trim().length === 0) {
      setImpressionValueError_vastzone(false);
      // setImpressionIsRequiredError_vastzone(true);
    } else {
      if (Number(event.target.value.trim()) > 0) {
        setImpressionValueError_vastzone(false);
      } else {
        // setImpressionIsRequiredError_vastzone(false);
        setImpressionValueError_vastzone(true);
      }
    }
    setImpression_vastzone(event.target.value.trim());
  }

  function onChangeHuman_vastzone(event) {
    if (/^\d*$/.test(event.target.value.trim())) {
      setHuman_vastzone(event.target.value.trim());
      if (event.target.value.trim() === "" || (Number(event.target.value.trim()) >= 0 && Number(event.target.value.trim()) <= 100)) {
        setHumanValidError_vastzone(false);
      } else {
        setHumanValidError_vastzone(true);
      }
    }
  }

  function onBlurHuman_vastzone(event) {
    setHuman_vastzone(event.target.value.trim());
    if (event.target.value.trim() === "" || !(Number(event.target.value.trim()) >= 0 && Number(event.target.value.trim()) <= 100)) {
      setHumanValidError_vastzone(true);
    } else {
      setHumanValidError_vastzone(false);
    }
  }

  // PIXALATE SUNSET: Pixalate IVT sampling validation disabled (field hidden, not sent in payload).
  /*
  function onChangePixalate_vastzone(event) {
    if (/^\d*$/.test(event.target.value.trim())) {
      setPixalate_vastzone(event.target.value.trim());
      if (event.target.value.trim() === "" || (Number(event.target.value.trim()) >= 0 && Number(event.target.value.trim()) <= 100)) {
        setPixalateValidError_vastzone(false);
      } else {
        setPixalateValidError_vastzone(true);
      }
    }
  }

  function onBlurPixalate_vastzone(event) {
    setPixalate_vastzone(event.target.value.trim());
    if (event.target.value.trim() === "" || !(Number(event.target.value.trim()) >= 0 && Number(event.target.value.trim()) <= 100)) {
      setPixalateValidError_vastzone(true);
    } else {
      setPixalateValidError_vastzone(false);
    }
  }
  */

  function onChangeDoubleverify_vastzone(event) {
    if (/^\d*$/.test(event.target.value.trim())) {
      setDoubleverify_vastzone(event.target.value.trim());
      if (event.target.value.trim() === "" || (Number(event.target.value.trim()) >= 0 && Number(event.target.value.trim()) <= 100)) {
        setDoubleverifyValidError_vastzone(false);
      } else {
        setDoubleverifyValidError_vastzone(true);
      }
    }
  }

  function onBlurDoubleverify_vastzone(event) {
    setDoubleverify_vastzone(event.target.value.trim());
    if (event.target.value.trim() === "" || !(Number(event.target.value.trim()) >= 0 && Number(event.target.value.trim()) <= 100)) {
      setDoubleverifyValidError_vastzone(true);
    } else {
      setDoubleverifyValidError_vastzone(false);
    }
  }

  function onChangeIsAddValueCheckbox_vastzone(event) {
    setIsAddValueCheckbox_vastzone(event.target.checked);
  }

  function onChangeOverride_vastzone(event) {
    setOverride_vastzone(event.target.value);
  }

  function onBlurOverride_vastzone(event) {
    setOverride_vastzone(event.target.value.trim());
  }

  function onChangeTemplate_vastzone(event) {
    setTemplateIsRequiredError_vastzone(false);
    setTemplate_vastzone(event);
    let selectedTemplate = (templateOptions_vastzone[platformType_vastzone] || [])?.find(
      (template) => template.value === event
    );
    setTemplateText_vastzone(selectedTemplate?.template);
  }

  ///////////////////////////////////////////////////vast aniview tag code ///////////////////////////////////////////

  const [platformType_vast_aniview, setPlatformType_vast_aniview] = useState("Website");

  const [channelName_vast_aniview, setChannelName_vast_aniview] = useState("");
  const [channelNameIsRequiredError_vast_aniview, setChannelNameIsRequiredError_vast_aniview] =
    useState(false);

  const [eCpm_vast_aniview, setECpm_vast_aniview] = useState("");
  const [eCpmIsRequiredError_vast_aniview, setECpmIsRequiredError_vast_aniview] = useState(false);
  const [eCpmValidError_vast_aniview, setECpmValidError_vast_aniview] = useState(false);

  function reset_vast_aniview() {
    setPlatformType_vast_aniview("Website");
    setChannelName_vast_aniview("");
    setChannelNameIsRequiredError_vast_aniview(false);
    setECpm_vast_aniview("");
    setECpmIsRequiredError_vast_aniview(false);
    setECpmValidError_vast_aniview(false);
  }

  function onChangePlatformType_vast_aniview(event) {
    setPlatformType_vast_aniview(event.target.value);

    if (publisherName !== "") {
      setChannelName_vast_aniview(
        publisherName + "_" + event.target.value
      );
    }
    setChannelNameIsRequiredError_vast_aniview(false);
  }

  function onChangeChannelName_vast_aniview(event) {
    setChannelNameIsRequiredError_vast_aniview(false);
    setChannelName_vast_aniview(event.target.value);
  }

  function onBlurChannelName_vast_aniview(event) {
    if (event.target.value.trim().length === 0) {
      setChannelNameIsRequiredError_vast_aniview(true);
    }
    setChannelName_vast_aniview(event.target.value.trim());
  }



  function onChangeECpm_vast_aniview(event) {
    setECpmIsRequiredError_vast_aniview(false);
    if (/^\d*\.?\d{0,2}$/.test(event.target.value.trim())) {
      setECpm_vast_aniview(event.target.value.trim());
      if (Number(event.target.value.trim()) > 0 && Number(event.target.value.trim()) < 100) {
        setECpmValidError_vast_aniview(false)
      }
      else {
        setECpmValidError_vast_aniview(true)
      }
    }
  }

  function onBlurECpm_vast_aniview(event) {
    if (event.target.value.trim().length === 0) {
      setECpmValidError_vast_aniview(false);
      setECpmIsRequiredError_vast_aniview(true);
    } else {
      if (Number(event.target.value.trim()) > 0 && Number(event.target.value.trim()) < 100) {
        setECpmValidError_vast_aniview(false);
      } else {
        setECpmIsRequiredError_vast_aniview(false);
        setECpmValidError_vast_aniview(true);
      }
    }
    setECpm_vast_aniview(event.target.value.trim());
  }

  ///////////////////////////////////////////////////player tag code ///////////////////////////////////////////

  const [platformType_playertag, setPlatformType_playertag] = useState("Website");

  const [playerMode_playertag, setPlayerMode_playertag] = useState("articleVideo");
  const [playerModeOptions_playertag, setPlayerModeOptions_playertag] = useState([
    { label: "Article Video", value: "articleVideo" },
    { label: "Banner Video", value: "bannerVideo" },
  ]);

  const [floatingPosition_playertag, setFloatingPosition_playertag] = useState("bottomRight");
  const [floatingPositionOptions_playertag/*, setFloatingPositionOptions_playertag*/] = useState([
    { label: "Bottom Right", value: "bottomRight" },
    { label: "Bottom Left", value: "bottomLeft" },
    { label: "Top Right", value: "topRight" },
    { label: "Top Left", value: "topLeft" },
    { label: "Top Center", value: "topCenter" },
    { label: "Bottom Center", value: "bottomCenter" },
  ]);
  const [floatingPositionOptions_tag_outstream/*, setFloatingPositionOptions_tag_outstream*/] = useState([
    { label: "Default", value: "default" },
    { label: "Top Right", value: "topRight" },
    { label: "Top Left", value: "topLeft" },
  ]);

  const [channelName_playertag, setChannelName_playertag] = useState("");
  const [channelNameIsRequiredError_playertag, setChannelNameIsRequiredError_playertag] =
    useState(false);


  const [eCpm_playertag, setECpm_playertag] = useState("");
  const [eCpmIsRequiredError_playertag, setECpmIsRequiredError_playertag] = useState("");
  const [eCpmValidError_playertag, setECpmValidError_playertag] = useState("");

  function reset_playertag() {

    setPlatformType_playertag("Website");

    setPlayerMode_playertag("articleVideo");
    setPlayerModeOptions_playertag([
      { label: "Article Video", value: "articleVideo" },
      { label: "Banner Video", value: "bannerVideo" },
    ]);

    setFloatingPosition_playertag("bottomRight");
    setChannelName_playertag("");
    setChannelNameIsRequiredError_playertag(false);
    setECpm_playertag("");
    setECpmIsRequiredError_playertag("");
    setECpmValidError_playertag("");

    setMainTableVideo_playertag([])

  }



  function onChangePlatformType_playertag(event) {
    setPlatformType_playertag(event.target.value);

    if (publisherName !== "") {
      setChannelName_playertag(
        publisherName + "_" + event.target.value + "_" + playerMode_playertag?.toLowerCase()
      );
    }
    setChannelNameIsRequiredError_playertag(false);
  }


  function onChangePlayerMode_playertag(event) {
    setPlayerMode_playertag(event);
    // if (event === "articleVideo") {
    //   setFloatingPosition_playertag("bottomRight")
    // }

    if (publisherName !== "") {
      setChannelName_playertag(
        publisherName + "_" + platformType_playertag + "_" + event?.toLowerCase()
      );
    }
    setChannelNameIsRequiredError_playertag(false);
  }

  function onChangeFloatingPosition_playertag(event) {
    setFloatingPosition_playertag(event);
  }

  function onChangeChannelName_playertag(event) {
    setChannelNameIsRequiredError_playertag(false);
    setChannelName_playertag(event.target.value);
  }

  function onBlurChannelName_playertag(event) {
    if (event.target.value.trim().length === 0) {
      setChannelNameIsRequiredError_playertag(true);
    }
    setChannelName_playertag(event.target.value.trim());
  }



  function onChangeECpm_playertag(event) {
    setECpmIsRequiredError_playertag(false);
    if (/^\d*\.?\d{0,2}$/.test(event.target.value.trim())) {
      setECpm_playertag(event.target.value.trim());
      if (Number(event.target.value.trim()) > 0 && Number(event.target.value.trim()) < 100) {
        setECpmValidError_playertag(false)
      }
      else {
        setECpmValidError_playertag(true)
      }
    }
  }

  function onBlurECpm_playertag(event) {
    if (event.target.value.trim().length === 0) {
      setECpmValidError_playertag(false);
      setECpmIsRequiredError_playertag(true);
    } else {
      if (Number(event.target.value.trim()) > 0 && Number(event.target.value.trim()) < 100) {
        setECpmValidError_playertag(false);
      } else {
        setECpmIsRequiredError_playertag(false);
        setECpmValidError_playertag(true);
      }
    }
    setECpm_playertag(event.target.value.trim());
  }



  // ///////////////////////////////Player tag modal related code ////////////////////////////////

  const [mainTableVideo_playertag, setMainTableVideo_playertag] = useState([])

  const [tempTableUploadVideo_playertag, setTempTableUploadVideo_playertag] = useState([])
  const [tempTableLinkVideo_playertag, setTempTableLinkVideo_playertag] = useState([])


  const [tempTableSuggestedMainVideo_playertag, setTempTableSuggestedMainVideo_playertag] = useState([])
  const [tempTableSuggestedMainVideoChecked_playertag, setTempTableSuggestedMainVideoChecked_playertag] = useState([])

  const [tempTableSuggestedSubVideo_playertag, setTempTableSuggestedSubVideo_playertag] = useState([])
  const [tempTableSuggestedSubVideoChecked_playertag, setTempTableSuggestedSubVideoChecked_playertag] = useState([])

  const [modalVideoLinkInput, setModalVideoLinkInput] = useState('');
  const [modalVideoLinkInputError, setModalVideoLinkInputError] = useState(false);
  const [modalVideoLinkInputLoader, setModalVideoLinkInputLoader] = useState(false);
  const [modalVideoLinkInputErrorMsg, setModalVideoLinkInputErrorMsg] = useState("");


  const [isModalVisibleVideo, setIsModalVisibleVideo] = useState(false)
  const videoRef1 = useRef([]);
  const videoRef2 = useRef([]);
  const videoRef3 = useRef([]);
  const videoRef4 = useRef([]);
  const videoRef5 = useRef([]);

  const [activeKeyVideoTab, setActiveKeyVideoTab] = useState('1');
  const [activeKeyVideoTabName, setActiveKeyVideoTabName] = useState('Suggested');


  const [/* dragging */, setDragging] = useState(false);

  const handleDragEnter = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragging(false);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragging(false);

    let count = 0;

    const droppedFiles = Array.from(e.dataTransfer.files);
    if (droppedFiles.length > 0) {
      let tempMediaKit = [...tempTableUploadVideo_playertag];
      for (let file of droppedFiles) {

        if (file.size / (1024 * 1024) < 100 && (file.type.includes("video"))) {

          tempMediaKit.push({
            aniviewId: "",
            data: file,
            url: URL.createObjectURL(file),
            filename: file.name,
            size: file.size
          });
        }
        else {
          count++;

        }
      }
      setTempTableUploadVideo_playertag(tempMediaKit);
      const fileInput00 = document.getElementById("file001");
      fileInput00.value = "";
      if (count !== 0) {
        notifyfailure(`${count} files are rejected as they are failing validation (File should be Less than 100mb && video format`)
      }
    }
  };

  function onChangeMediakit(e) {
    let count = 0;

    if (e.target.files.length > 0) {
      let tempMediaKit = [...tempTableUploadVideo_playertag];

      for (let file of e.target.files) {

        if (file.size / (1024 * 1024) < 100 && (file.type.includes("video"))) {
          tempMediaKit.push({
            aniviewId: "",
            data: file,
            url: URL.createObjectURL(file),
            filename: file.name,
            size: file.size
          });
        }
        else {
          count++;

        }
      }

      setTempTableUploadVideo_playertag(tempMediaKit);
      const fileInput00 = document.getElementById("file001");
      fileInput00.value = "";

      if (count !== 0) {
        notifyfailure(`${count} files are rejected as they are failing validation (File should be Less than 100mb && video format`)
      }

      //   } else {
      //     setMediakit({
      //       data: "",
      //       preview: "",
      //     });
      //     setMediakitFilename("");
      //     notifyfailure("File Size Should be less than 100 MB");
      //   }
    }
  }


  const handleMouseEnter = (e) => {
    try {
      // Check if the media element is currently paused before playing
      if (e?.target?.paused) {
        e.target.play()
          .catch(error => {
            // Handle potential play errors (e.g., autoplay policy)
            console.error('Failed to start playing:', error);
          });
      }
    } catch (error) {
      // Handle any other potential errors
      console.error('An error occurred:', error);
    }
  };

  const handleMouseLeave = (e) => {
    try {
      // Check if the media element is currently paused before playing
      if (e?.target?.play) {
        e.target.pause()
          .catch(error => {
            // Handle potential play errors (e.g., autoplay policy)
            console.error('Failed to start playing:', error);
          });
      }
    } catch (error) {
      // Handle any other potential errors
      console.error('An error occurred:', error);
    }
  };


  const handleFullscreen1 = (index) => {
    const videoElement = videoRef1.current[index];
    if (videoElement) {
      videoElement.currentTime = 0;

      if (videoElement.requestFullscreen) {
        videoElement.requestFullscreen();
      } else if (videoElement.mozRequestFullScreen) { /* Firefox */
        videoElement.mozRequestFullScreen();
      } else if (videoElement.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
        videoElement.webkitRequestFullscreen();
      } else if (videoElement.msRequestFullscreen) { /* IE/Edge */
        videoElement.msRequestFullscreen();
      }
    }
  };

  const handleFullscreen2 = (index) => {
    const videoElement = videoRef2.current[index];
    if (videoElement) {
      videoElement.currentTime = 0;

      if (videoElement.requestFullscreen) {
        videoElement.requestFullscreen();
      } else if (videoElement.mozRequestFullScreen) { /* Firefox */
        videoElement.mozRequestFullScreen();
      } else if (videoElement.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
        videoElement.webkitRequestFullscreen();
      } else if (videoElement.msRequestFullscreen) { /* IE/Edge */
        videoElement.msRequestFullscreen();
      }
    }
  };

  const handleFullscreen3 = (index) => {
    const videoElement = videoRef3.current[index];
    if (videoElement) {
      videoElement.currentTime = 0;

      if (videoElement.requestFullscreen) {
        videoElement.requestFullscreen();
      } else if (videoElement.mozRequestFullScreen) { /* Firefox */
        videoElement.mozRequestFullScreen();
      } else if (videoElement.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
        videoElement.webkitRequestFullscreen();
      } else if (videoElement.msRequestFullscreen) { /* IE/Edge */
        videoElement.msRequestFullscreen();
      }
    }
  };

  const handleFullscreen4 = (index) => {
    const videoElement = videoRef4.current[index];
    if (videoElement) {
      videoElement.currentTime = 0;

      if (videoElement.requestFullscreen) {
        videoElement.requestFullscreen();
      } else if (videoElement.mozRequestFullScreen) { /* Firefox */
        videoElement.mozRequestFullScreen();
      } else if (videoElement.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
        videoElement.webkitRequestFullscreen();
      } else if (videoElement.msRequestFullscreen) { /* IE/Edge */
        videoElement.msRequestFullscreen();
      }
    }
  };

  const handleFullscreen5 = (index) => {
    const videoElement = videoRef5.current[index];
    if (videoElement) {
      videoElement.currentTime = 0;

      if (videoElement.requestFullscreen) {
        videoElement.requestFullscreen();
      } else if (videoElement.mozRequestFullScreen) { /* Firefox */
        videoElement.mozRequestFullScreen();
      } else if (videoElement.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
        videoElement.webkitRequestFullscreen();
      } else if (videoElement.msRequestFullscreen) { /* IE/Edge */
        videoElement.msRequestFullscreen();
      }
    }
  };


  useEffect(() => {
    let status = Cookies.get("token_xapads_ssp") ? true : false;
    if (status) {
      let token = Cookies.get("token_xapads_ssp")

      if (role === 'admin' || role === "u_admin") {
        axios
          .get(configData.SERVER_URL + "zone/videoList",
            {
              headers: {
                "Content-Type": "application/json",
                "x-access-token": token,
              },
            }
          )
          .then((response) => {
            setTempTableSuggestedMainVideo_playertag(response.data.data.suggested)
            if ((role === "admin" || role === "u_admin")) {
              setTempTableSuggestedSubVideo_playertag(response.data.data.myvideos)
            }

          })
          .catch((error) => { });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])


  const onTabChangeVideo = (key, name) => {
    setActiveKeyVideoTab(key);
    setActiveKeyVideoTabName(name)
    resetModalVideo_playertag_tabChange()
  };



  function resetModalVideo_playertag() {
    setTempTableUploadVideo_playertag([])

    setTempTableLinkVideo_playertag([])
    setModalVideoLinkInput('')
    setModalVideoLinkInputError(false)
    setModalVideoLinkInputLoader(false)
    setModalVideoLinkInputErrorMsg("")

    setTempTableSuggestedMainVideoChecked_playertag([])
    setTempTableSuggestedSubVideoChecked_playertag([])

    setIsModalVisibleVideo(false)
    setActiveKeyVideoTab('1');
    setActiveKeyVideoTabName('Suggested');

  }

  function resetModalVideo_playertag_tabChange() {
    setTempTableUploadVideo_playertag([])

    setTempTableLinkVideo_playertag([])
    setModalVideoLinkInput('')
    setModalVideoLinkInputError(false)
    setModalVideoLinkInputLoader(false)
    setModalVideoLinkInputErrorMsg("")

    setTempTableSuggestedMainVideoChecked_playertag([])
    setTempTableSuggestedSubVideoChecked_playertag([])

  }

  // const validateVideoUrl = async () => {
  //   // Basic URL format validation
  //   const urlPattern = /^(http|https):\/\/[^ "]+$/;
  //   if (!urlPattern.test(modalVideoLinkInput)) {
  //     // setIsValid(false);
  //     // notifyfailure("Provided url is not a video")

  //     setModalVideoLinkInputErrorMsg("Provided url is not a video")
  //     setModalVideoLinkInputError(true)
  //     return;
  //   }

  //   // Fetch request to check if the URL responds with a valid video MIME type
  //   try {
  //     const response = await fetch(modalVideoLinkInput, { method: 'HEAD' });
  //     const contentType = response.headers.get('content-type');
  //     if (contentType && contentType.includes('video')) {
  //       let temp = [...tempTableLinkVideo_playertag]
  //       temp.push({
  //         "aniViewVideoId": "",
  //         "url": modalVideoLinkInput
  //       })

  //       setTempTableLinkVideo_playertag(temp)
  //       setModalVideoLinkInput("")


  //     } else {
  //       // notifyfailure("Provided url is not a video")

  //       setModalVideoLinkInputErrorMsg("Provided url is not a video")
  //       setModalVideoLinkInputError(true)
  //     }
  //   } catch (error) {
  //     // notifyfailure("Unable to fetch video from the url / CORS error")

  //     setModalVideoLinkInputErrorMsg("Unable to fetch video from the url / CORS error")
  //     setModalVideoLinkInputError(true)
  //   }
  // };

  const validateVideoUrl = async () => {
    // Basic URL format validation
    const urlPattern = /^(http|https):\/\/[^ "]+$/;
    if (!urlPattern.test(modalVideoLinkInput)) {
      // setIsValid(false);
      // notifyfailure("Provided url is not a video")

      setModalVideoLinkInputErrorMsg("Provided url is not a video")
      setModalVideoLinkInputError(true)
      return;
    }


    setModalVideoLinkInputLoader(true)
    axios
      .post(configData.SERVER_URL + "zone/getContentType", { url: modalVideoLinkInput })
      .then((response) => {
        if (response.data.videoCheck) {

          let temp = [...tempTableLinkVideo_playertag]
          temp.push({
            "aniViewVideoId": "",
            "url": modalVideoLinkInput
          })

          setTempTableLinkVideo_playertag(temp)
          setModalVideoLinkInput("")
          setModalVideoLinkInputLoader(false)
        }
        else {

          setModalVideoLinkInputErrorMsg("Unable to fetch video from the url")
          setModalVideoLinkInputError(true)
          setModalVideoLinkInputLoader(false)
        }


      })
      .catch((error) => {

        setModalVideoLinkInputErrorMsg("Unable to fetch video from the url")
        setModalVideoLinkInputError(true)
        setModalVideoLinkInputLoader(false)

      });

  };




  const items_notAdmin_playertag = [
    {
      key: '1',
      tab: 'Suggested',
      content: (
        <>
          <div className="after_upload_videos_scroll_d2 suggested">
            <Row gutter={16}>

              {tempTableSuggestedMainVideo_playertag.map((video, index) => (
                <Col span={6}>
                  <div
                    className={tempTableSuggestedMainVideoChecked_playertag.findIndex(videoCheck => videoCheck.aniViewVideoId === video.aniViewVideoId) !== -1 ? 'item_selectbox primary_checkbox checked' : 'item_selectbox primary_checkbox'}
                  >
                    <div className='item_selectbox--video'>
                      <video
                        ref={el => videoRef1.current[index] = el}
                        width="600"
                        controls={false}
                        onMouseEnter={handleMouseEnter}
                        onMouseLeave={handleMouseLeave}
                        muted
                      >
                        <source src={video.url} />
                        Your browser does not support the video tag.
                      </video>
                      <img src={playIcon} alt='USP' className='play_icon' />
                      <button onClick={() => { handleFullscreen1(index) }} className='expand_icon'><img src={zoomIcon} alt='USP' /></button>
                      {/* <span className='item_selectbox--video-size'>4.34 MB</span> */}
                    </div>
                    <Checkbox className='item_selectbox--checkbox'
                      checked={tempTableSuggestedMainVideoChecked_playertag.findIndex(videoCheck => videoCheck.aniViewVideoId === video.aniViewVideoId) !== -1}

                      onClick={() => {
                        let tempVideo = [...tempTableSuggestedMainVideoChecked_playertag]
                        const index = tempVideo.findIndex(videoCheck => videoCheck.aniViewVideoId === video.aniViewVideoId);
                        if (index === -1) {
                          tempVideo.push(video);
                        } else {
                          tempVideo.splice(index, 1);
                        }

                        setTempTableSuggestedMainVideoChecked_playertag(tempVideo)
                      }}
                    ><span className='form_label'>{video.url.substring(video.url.lastIndexOf('/') + 1)}</span></Checkbox>
                  </div>
                </Col>
              ))}
            </Row>
          </div>
        </>
      )
    },
    {
      key: '2', tab: 'Upload',
      content: (
        <>
          <div className="form_content_block--group upload_modal">
            <label for='file001'
              // className={dragging ? 'ant_upload_drag border_none drag_css_color' : 'ant_upload_drag border_none'}
              className={tempTableUploadVideo_playertag.length > 0 ? 'ant_upload_drag ' : 'ant_upload_drag border_none'}

            >
              <p className="upload_drag_icon">
                <img src={uploadIcon} alt='USP' />
              </p>
              <p className="ant_upload_text"><b className="primary">Click to upload</b> the video</p>
              <p className="ant_upload_hint">
                Video (max. 100 MB)
              </p>
            </label>
            <input className='form_upload d-none' type="file"
              name="file001"
              id="file001"
              accept="video/*"
              multiple
              onChange={onChangeMediakit}
            />

            <div className="after_upload_videos_scroll_d2">
              {tempTableUploadVideo_playertag.length > 0 &&
                <>      {tempTableUploadVideo_playertag.map((video, index) => (
                  <div className="ant_upload_list--item">
                    <div className="ant_upload_list--content gap_12">
                      <div className="thumbnail_content--video position-relative">
                        <button onClick={() => { handleFullscreen2(index) }} className='thumbnail_content--play'><img src={playIcon} alt='USP' /></button>
                        <video
                          ref={el => videoRef2.current[index] = el}
                          width="138"
                          height="79"
                          controls={false}
                          // onMouseEnter={handleMouseEnter}
                          // onMouseLeave={handleMouseLeave}
                          className='video_thumb'
                          muted
                        >
                          <source src={video.url} />
                          Your browser does not support the video tag.
                        </video>
                      </div>
                      <div className="ant_upload_list--info">
                        <span className="ant_upload_list--info-name">{video.filename}</span>
                        <span className="ant_upload_list--info-size">{video.size / 1024 > 100 ? `${(video.size / (1024 * 1024)).toFixed(2)} MB` : `${(video.size / (1024)).toFixed(2)} KB`}</span>
                      </div>
                    </div>
                    <button type="link" className="download_icon download_icon_d2"
                      onClick={() => {
                        const newArray = [...tempTableUploadVideo_playertag];
                        newArray.splice(index, 1);
                        setTempTableUploadVideo_playertag(newArray);
                      }}
                    >
                      <img src={deleteIcon} alt="USP" />
                    </button>
                  </div>
                ))}
                </>}
            </div>

          </div>

        </>
      )
    },
    {
      key: '3', tab: 'Link', content: (
        <>
          <div className="form_content_block--group mt_65 mb_40">
            <div className="w_70 d_flex m-auto justify-content-center">
              <Input
                className='form_control basic pe-4'
                placeholder="Paste URL of Image"
                value={modalVideoLinkInput}
                onChange={(e) => { setModalVideoLinkInputError(false); setModalVideoLinkInputErrorMsg(""); setModalVideoLinkInput(e.target.value) }}
              />
              {modalVideoLinkInputLoader ?
                <button
                  className="btn btn_primary mt-0 ms-3 w_fit_content loader"

                >
                  <span>Submit</span>

                  <img
                    src={loaderIcon}
                    alt="USP"
                    className="loader_icon"
                  />
                </button>
                :
                <button type="submit" className='btn btn_primary mt-0 ms-3 w_fit_content'
                  disabled={modalVideoLinkInput.trim().length === 0}
                  onClick={validateVideoUrl}
                >Submit</button>
              }
            </div>
            <div className="w_70 ms-4">
              <span className="error_content ms-2">
                {modalVideoLinkInputError && (
                  <> {modalVideoLinkInputErrorMsg}</>
                )}
              </span>
            </div>

          </div>

          <div className="after_upload_videos_scroll_d2 link">
            <div className="form_content_block--group">
              {tempTableLinkVideo_playertag.length > 0 &&
                <>      {tempTableLinkVideo_playertag.map((video, index) => (
                  <div className="ant_upload_list--item">
                    <div className="ant_upload_list--content gap_12">
                      <div className="thumbnail_content--video position-relative">
                        <button onClick={() => { handleFullscreen3(index) }} className='thumbnail_content--play'><img src={playIcon} alt='USP' /></button>
                        <video
                          ref={el => videoRef3.current[index] = el}
                          width="138"
                          height="79"
                          controls={false}
                          // onMouseEnter={handleMouseEnter}
                          // onMouseLeave={handleMouseLeave}
                          className='video_thumb'
                          muted
                        >
                          <source src={video?.url} />
                          Your browser does not support the video tag.
                        </video>
                      </div>
                      <div className="ant_upload_list--info">
                        <span className="ant_upload_list--info-name">{video?.url?.includes("http") ? video?.url?.substring(video?.url?.lastIndexOf('/') + 1) : video?.url}</span>
                        {/* <span className="ant_upload_list--info-size">4 MB | 12:56</span> */}
                      </div>
                    </div>
                    <button type="link" className="download_icon download_icon_d2"
                      onClick={() => {
                        const newArray = [...tempTableLinkVideo_playertag];
                        newArray.splice(index, 1);
                        setTempTableLinkVideo_playertag(newArray);
                      }}
                    >
                      <img src={deleteIcon} alt="USP" />
                    </button>
                  </div>
                ))}
                </>}

            </div>
          </div>
        </>)
    },
  ];

  const items_admin_playertag = [
    {
      key: '1',
      tab: 'Suggested',
      content: (
        <>
          <div className="after_upload_videos_scroll_d2 suggested">
            <Row gutter={16}>

              {/* {tempTableSuggestedMainVideo_playertag.filter(
              video2 => !mainTableVideo_playertag.some(video1 => video1.aniViewVideoId === video2.aniViewVideoId)
            ).map((video, index) => ( */}
              {tempTableSuggestedMainVideo_playertag.map((video, index) => (
                <Col span={6}>
                  <div
                    className={tempTableSuggestedMainVideoChecked_playertag.findIndex(videoCheck => videoCheck.aniViewVideoId === video.aniViewVideoId) !== -1 ? 'item_selectbox primary_checkbox checked' : 'item_selectbox primary_checkbox'}
                  >
                    <div className='item_selectbox--video'>
                      <video
                        ref={el => videoRef1.current[index] = el}
                        width="600"
                        controls={false}
                        onMouseEnter={handleMouseEnter}
                        onMouseLeave={handleMouseLeave}
                        muted
                      >
                        <source src={video.url} />
                        Your browser does not support the video tag.
                      </video>
                      <img src={playIcon} alt='USP' className='play_icon' />
                      <button onClick={() => { handleFullscreen1(index) }} className='expand_icon'><img src={zoomIcon} alt='USP' /></button>
                      {/* <span className='item_selectbox--video-size'>4.34 MB</span> */}
                    </div>
                    <Checkbox className='item_selectbox--checkbox'
                      checked={tempTableSuggestedMainVideoChecked_playertag.findIndex(videoCheck => videoCheck.aniViewVideoId === video.aniViewVideoId) !== -1}

                      onClick={() => {
                        let tempVideo = [...tempTableSuggestedMainVideoChecked_playertag]
                        const index = tempVideo.findIndex(videoCheck => videoCheck.aniViewVideoId === video.aniViewVideoId);
                        if (index === -1) {
                          tempVideo.push(video);
                        } else {
                          tempVideo.splice(index, 1);
                        }
                        setTempTableSuggestedMainVideoChecked_playertag(tempVideo)
                      }}
                    ><span className='form_label'>{video.url.substring(video.url.lastIndexOf('/') + 1)}</span></Checkbox>
                  </div>
                </Col>
              ))}

            </Row>
          </div>
        </>
      )
    },
    {
      key: '2',
      tab: 'My Video',
      content: (
        <>
          <div className="after_upload_videos_scroll_d2 suggested">
            <Row gutter={16}>

              {tempTableSuggestedSubVideo_playertag.map((video, index) => (
                <Col span={6}>
                  <div
                    className={tempTableSuggestedSubVideoChecked_playertag.findIndex(videoCheck => videoCheck.aniViewVideoId === video.aniViewVideoId) !== -1 ? 'item_selectbox primary_checkbox checked' : 'item_selectbox primary_checkbox'}
                  >
                    <div className='item_selectbox--video'>
                      <div className="thumbnail_content--video position-relative">
                        <button onClick={() => { handleFullscreen2(index) }} className='thumbnail_content--play'><img src={playIcon} alt='USP' /></button>
                        <video
                          ref={el => videoRef2.current[index] = el}
                          width="600"
                          controls={false}
                          // onMouseEnter={handleMouseEnter}
                          // onMouseLeave={handleMouseLeave}
                          muted
                        >
                          <source src={video.url} />
                          Your browser does not support the video tag.
                        </video>

                      </div>

                      {/* <img src={playIcon} alt='USP' className='play_icon' /> */}
                      {/* <span className='item_selectbox--video-size'>4.34 MB</span> */}
                    </div>
                    <Checkbox className='item_selectbox--checkbox'
                      checked={tempTableSuggestedSubVideoChecked_playertag.findIndex(videoCheck => videoCheck.aniViewVideoId === video.aniViewVideoId) !== -1}

                      onClick={() => {
                        let tempVideo = [...tempTableSuggestedSubVideoChecked_playertag]
                        const index = tempVideo.findIndex(videoCheck => videoCheck.aniViewVideoId === video.aniViewVideoId);
                        if (index === -1) {
                          tempVideo.push(video);
                        } else {
                          tempVideo.splice(index, 1);
                        }

                        setTempTableSuggestedSubVideoChecked_playertag(tempVideo)
                      }}
                    ><span className='form_label'>{video.url.substring(video.url.lastIndexOf('/') + 1)}</span></Checkbox>
                  </div>
                </Col>
              ))}
            </Row>
          </div>
        </>
      )
    },
    {
      key: '3', tab: 'Upload',
      content: (
        <>
          <div className="form_content_block--group upload_modal">
            <label for='file001'

              // className={dragging ? 'ant_upload_drag border_none drag_css_color' : 'ant_upload_drag border_none'}
              className={tempTableUploadVideo_playertag.length > 0 ? 'ant_upload_drag ' : 'ant_upload_drag border_none'}

              onDragEnter={handleDragEnter}
              onDragOver={handleDragOver}
              onDragLeave={handleDragLeave}
              onDrop={handleDrop}
            >
              <p className="upload_drag_icon">
                <img src={uploadIcon} alt='USP' />
              </p>
              <p className="ant_upload_text"><b className="primary">Click to upload</b> the video</p>
              <p className="ant_upload_hint">
                Video (max. 100 MB)
              </p>
            </label>
            <input className='form_upload d-none' type="file"
              name="file001"
              id="file001"
              accept="video/*"
              multiple
              onChange={onChangeMediakit}
            />

            <div className="after_upload_videos_scroll_d2">
              {tempTableUploadVideo_playertag.length > 0 &&
                <>      {tempTableUploadVideo_playertag.map((video, index) => (
                  <div className="ant_upload_list--item">
                    <div className="ant_upload_list--content gap_12">
                      <div className="thumbnail_content--video position-relative">
                        <button onClick={() => { handleFullscreen3(index) }} className='thumbnail_content--play'><img src={playIcon} alt='USP' /></button>
                        <video
                          ref={el => videoRef3.current[index] = el}
                          width="138"
                          height="79"
                          controls={false}
                          // onMouseEnter={handleMouseEnter}
                          // onMouseLeave={handleMouseLeave}
                          className='video_thumb'
                          muted
                        >
                          <source src={video.url} />
                          Your browser does not support the video tag.
                        </video>
                      </div>
                      <div className="ant_upload_list--info">
                        <span className="ant_upload_list--info-name">{video.filename}</span>
                        <span className="ant_upload_list--info-size">{video.size / 1024 > 100 ? `${(video.size / (1024 * 1024)).toFixed(2)} MB` : `${(video.size / (1024)).toFixed(2)} KB`}</span>
                      </div>
                    </div>
                    <button type="link" className="download_icon download_icon_d2"
                      onClick={() => {
                        const newArray = [...tempTableUploadVideo_playertag];
                        newArray.splice(index, 1);
                        setTempTableUploadVideo_playertag(newArray);
                      }}
                    >
                      <img src={deleteIcon} alt="USP" />
                    </button>
                  </div>
                ))}
                </>
              }
            </div>


          </div>

        </>
      )
    },
    {
      key: '4', tab: 'Link', content: (
        <>
          <div className="form_content_block--group mt_65 mb_40">
            <div className="w_70 d_flex m-auto justify-content-center">
              <Input
                className='form_control basic pe-4'
                placeholder="Paste URL of Image"
                value={modalVideoLinkInput}
                onChange={(e) => { setModalVideoLinkInputError(false); setModalVideoLinkInputErrorMsg(""); setModalVideoLinkInput(e.target.value) }}
              />
              {modalVideoLinkInputLoader ?
                <button
                  className="btn btn_primary mt-0 ms-3 w_fit_content loader"

                >
                  <span>Submit</span>

                  <img
                    src={loaderIcon}
                    alt="USP"
                    className="loader_icon"
                  />
                </button>
                :
                <button type="submit" className='btn btn_primary mt-0 ms-3 w_fit_content'
                  disabled={modalVideoLinkInput.trim().length === 0}
                  onClick={validateVideoUrl}
                >Submit</button>
              }
            </div>
            <div className="w_70 ms-4">
              <span className="error_content ms-2">
                {modalVideoLinkInputError && (
                  <> {modalVideoLinkInputErrorMsg}</>
                )}
              </span>
            </div>
          </div>

          <div className="after_upload_videos_scroll_d2 link">
            <div className="form_content_block--group">
              {tempTableLinkVideo_playertag.length > 0 &&
                <>      {tempTableLinkVideo_playertag.map((video, index) => (
                  <div className="ant_upload_list--item">
                    <div className="ant_upload_list--content gap_12">
                      <button style={{ border: "none" }} onClick={() => { handleFullscreen4(index) }} className='expand_icon'><img src={zoomIcon} alt='USP' /></button>
                      <video
                        ref={el => videoRef4.current[index] = el}
                        width="138"
                        height="79"
                        controls={false}
                        // onMouseEnter={handleMouseEnter}
                        // onMouseLeave={handleMouseLeave}
                        className='video_thumb'
                        muted
                      >
                        <source src={video?.url} />
                        Your browser does not support the video tag.
                      </video>

                      <div className="ant_upload_list--info">
                        <span className="ant_upload_list--info-name">{video?.url?.includes("http") ? video?.url?.substring(video?.url?.lastIndexOf('/') + 1) : video?.url}</span>
                        {/* <span className="ant_upload_list--info-size">4 MB | 12:56</span> */}
                      </div>
                    </div>
                    <button type="link" className="download_icon download_icon_d2"
                      onClick={() => {
                        const newArray = [...tempTableLinkVideo_playertag];
                        newArray.splice(index, 1);
                        setTempTableLinkVideo_playertag(newArray);
                      }}
                    >
                      <img src={deleteIcon} alt="USP" />
                    </button>
                  </div>
                ))}
                </>}

            </div>
          </div>
        </>)
    },
  ];


  ///////////////////////////////////////////////////gam tag code ///////////////////////////////////////////

  const [accountName_gamtag, setAccountName_gamtag] = useState("");
  const [accountNameIsRequiredError_gamtag, setAccountNameIsRequiredError_gamtag] =
    useState(false);
  const [platformType_gamtag, setPlatformType_gamtag] = useState("Website");
  const [ownership_gamtag, setOwnership_gamtag] = useState("Own");
  const [ownershipOptions_gamtag, setOwnershipOptions_gamtag] = useState([
    { label: "Own", value: "Own" },
    { label: "Re-seller", value: "Re-seller" },
  ]);

  const [vastVersion_gamtag, setVastVersion_gamtag] = useState("VAST 4");
  const [vastVersionOptions_gamtag, setVastVersionOptions_gamtag] = useState([
    { label: "VAST 2", value: "VAST 2" },
    { label: "VAST 3", value: "VAST 3" },
    { label: "VAST 4", value: "VAST 4" },
  ]);

  const [eCPM_gamtag, seteCPM_gamtag] = useState(0.20);
  const [eCPMOptions_gamtag, seteCPMOptions_gamtag] = useState([
    { label: "0.20", value: 0.20 },
    { label: "0.40", value: 0.40 },
    { label: "0.80", value: 0.80 },
    { label: "1.00", value: 1.00 },
    { label: "1.20", value: 1.20 }
  ]);

  function reset_gamtag() {
    setAccountName_gamtag("");
    setAccountNameIsRequiredError_gamtag(false);
    setPlatformType_gamtag("Website");
    setOwnership_gamtag("Own");
    setOwnershipOptions_gamtag([
      { label: "Own", value: "Own" },
      { label: "Re-seller", value: "Re-seller" },
    ]);
    setVastVersion_gamtag("VAST 4");
    setVastVersionOptions_gamtag([
      { label: "VAST 2", value: "VAST 2" },
      { label: "VAST 3", value: "VAST 3" },
      { label: "VAST 4", value: "VAST 4" },
    ]);
    seteCPM_gamtag(0.20);
    seteCPMOptions_gamtag([
      { label: 0.20, value: 0.20 },
      { label: 0.40, value: 0.40 },
      { label: 0.80, value: 0.80 },
      { label: 1.00, value: 1.00 },
      { label: 1.20, value: 1.20 }
    ]);
  }


  function onChangeAccountName_gamtag(event) {
    setAccountNameIsRequiredError_gamtag(false);
    setAccountName_gamtag(event.target.value);
  }

  function onBlurAccountName_gamtag(event) {
    if (event.target.value.trim().length === 0) {
      setAccountNameIsRequiredError_gamtag(true);
    }
    setAccountName_gamtag(event.target.value.trim());
  }


  function onChangePlatformType_gamtag(event) {
    setPlatformType_gamtag(event.target.value);
  }


  function onChangeOwnership_gamtag(event) {
    setOwnership_gamtag(event);
  }

  function onChangeVastVersion_gamtag(event) {
    setVastVersion_gamtag(event);
  }

  function onChangeeCPM_gamtag(event) {
    seteCPM_gamtag(event);
  }


  ///////////////////////////////////////////////////gam zone code ///////////////////////////////////////////

  // Multi-select dropdown open-state infra (mirrors PublisherReport)
  const [openSelectState_gam, setOpenSelectState_gam] = useState({});
  const refsMap_gam = useRef({});
  function getRef_gam(key) {
    if (!refsMap_gam.current[key]) {
      refsMap_gam.current[key] = React.createRef();
    }
    return refsMap_gam.current[key];
  }
  const toggleSelectOpen_gam = (key, open) => {
    setOpenSelectState_gam((prevState) => {
      if (prevState[key] === open) return prevState;
      return { ...prevState, [key]: open };
    });
    if (open) {
      setTimeout(() => {
        refsMap_gam.current[key]?.current?.focus();
      }, 500);
    } else {
      // clear the search input when the dropdown closes
      if (key === `sizes-gam`) setSearchSizesList_gam("");
      if (key === `companion-gam`) setSearchCompanionList_gam("");
    }
  };

  // Traffic Type -> Website | Inapp | CTV
  const [platformType_gam, setPlatformType_gam] = useState("Website");
  // Format Type -> Banner | Video (CTV is forced to Video)
  const [formatType_gam, setFormatType_gam] = useState("Video");
  const [formatTypeOptions_gam] = useState([
    { label: "Video", value: "Video" },
    { label: "Banner", value: "Banner" },
    // { label: "Native", value: "Native" },
  ]);
  // ── Zone-name uniqueness check (all non-GAM zone types) ────────────────────
  // Keyed by a field id (prebid/openrtb/publica/vastzone/aniview/playertag/gamtag).
  // Hits gam-new/zone-name/check; response.data.nameExists === true => name already exists.
  const [nameExists, setNameExists] = useState({});
  const [nameChecking, setNameChecking] = useState({});
  const nameCheckSeq = useRef({});
  const nameCheckAbort = useRef({});
  const nameCheckTimers = useRef({});

  function checkZoneNameUnique(key, rawName) {
    const name = (rawName || "").trim();
    if (name === "" || name.length > 90) {
      setNameExists((p) => ({ ...p, [key]: false }));
      setNameChecking((p) => ({ ...p, [key]: false }));
      return;
    }
    const token = Cookies.get("token_xapads_ssp");
    if (!token) return;
    // cancel any in-flight check for this field so only the latest request resolves
    if (nameCheckAbort.current[key]) nameCheckAbort.current[key].abort();
    const controller = new AbortController();
    nameCheckAbort.current[key] = controller;
    const seq = (nameCheckSeq.current[key] || 0) + 1;
    nameCheckSeq.current[key] = seq;
    setNameChecking((p) => ({ ...p, [key]: true }));
    axios
      .get(configData.SERVER_URL + "zone/zone-name/check", {
        params: { name },
        headers: { "x-access-token": token },
        signal: controller.signal,
      })
      .then((response) => {
        if (nameCheckSeq.current[key] !== seq) return;
        setNameExists((p) => ({ ...p, [key]: response.data?.nameExists === true }));
        setNameChecking((p) => ({ ...p, [key]: false }));
      })
      .catch((error) => {
        if (axios.isCancel(error)) return;
        if (nameCheckSeq.current[key] !== seq) return;
        setNameExists((p) => ({ ...p, [key]: false }));
        setNameChecking((p) => ({ ...p, [key]: false }));
      });
  }

  function debouncedCheckZoneName(key, name) {
    if (nameCheckTimers.current[key]) clearTimeout(nameCheckTimers.current[key]);
    nameCheckTimers.current[key] = setTimeout(() => checkZoneNameUnique(key, name), 500);
  }

  // Re-run the uniqueness check whenever the auto-built name changes for the active form type
  // (traffic type / format type / publisher / form-type switch / admin autofill on load).
  useEffect(() => {
    if (formType !== "Prebid") return;
    setNameExists((p) => ({ ...p, prebid: false }));
    debouncedCheckZoneName("prebid", zoneName_prebid);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [zoneName_prebid, formType]);

  useEffect(() => {
    if (formType !== "Open RTB") return;
    setNameExists((p) => ({ ...p, openrtb: false }));
    debouncedCheckZoneName("openrtb", zoneName_openrtb);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [zoneName_openrtb, formType]);

  useEffect(() => {
    if (formType !== "Vast Zone") return;
    setNameExists((p) => ({ ...p, vastzone: false }));
    debouncedCheckZoneName("vastzone", zoneName_vastzone);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [zoneName_vastzone, formType]);

  const [zoneName_gam, setZoneName_gam] = useState("");
  const [zoneNameIsRequiredError_gam, setZoneNameIsRequiredError_gam] = useState(false);
  const [zoneNameMaxError_gam, setZoneNameMaxError_gam] = useState(false);

  // GAM auto-builds its name from traffic/format type -> re-check on any change,
  // handled like the other zone types via the generic "gam" key.
  useEffect(() => {
    if (formType !== "GAM") return;
    setNameExists((p) => ({ ...p, gam: false }));
    debouncedCheckZoneName("gam", zoneName_gam);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [zoneName_gam, formType]);

  // Sizes (multi-select) -> Banner uses sizes.json, Video uses vastMasterSizes.json
  const [sizesList_gam, setSizesList_gam] = useState([]);
  const [sizesIsRequiredError_gam, setSizesIsRequiredError_gam] = useState(false);
  const [searchSizesList_gam, setSearchSizesList_gam] = useState("");
  const sizesListOptions_gam = formatType_gam === "Video" ? gamVastMasterSizesData : gamSizesData;
  const filterSizesList_gam = sizesListOptions_gam?.filter((option) =>
    option.label.toLowerCase()?.includes(searchSizesList_gam.toLowerCase())
  );

  // Companion (multi-select, Video only) -> companionSizes.json
  const [companionList_gam, setCompanionList_gam] = useState([]);
  const [searchCompanionList_gam, setSearchCompanionList_gam] = useState("");
  const companionListOptions_gam = gamCompanionSizesData;
  const filterCompanionList_gam = companionListOptions_gam?.filter((option) =>
    option.label.toLowerCase()?.includes(searchCompanionList_gam.toLowerCase())
  );

  // TV app fields (CTV only) -> options fetched from /gam/ctv-applications
  const [tvAppNameCheckbox_gam, setTvAppNameCheckbox_gam] = useState(false);
  const [tvApplication_gam, setTvApplication_gam] = useState("");
  const [tvApplicationIsRequiredError_gam, setTvApplicationIsRequiredError_gam] = useState(false);
  const [tvApplicationOptions_gam, setTvApplicationOptions_gam] = useState([]);

  // Pricing
  const [fixedPrice_gam, setFixedPrice_gam] = useState("");
  const [fixedPriceIsRequiredError_gam, setFixedPriceIsRequiredError_gam] = useState(false);
  const [fixedPriceValidError_gam, setFixedPriceValidError_gam] = useState(false);
  // Set UPR is always disabled and auto = Fixed Price / (1 - 0.2)
  const [upr_gam, setUpr_gam] = useState("");
  // Override UPR -> when checked, an "Override Set UPR" input appears; its value drives the UPR Category auto-select
  const [overrideUpr_gam, setOverrideUpr_gam] = useState(false);
  const [overrideSetUpr_gam, setOverrideSetUpr_gam] = useState("");
  const [overrideSetUprIsRequiredError_gam, setOverrideSetUprIsRequiredError_gam] = useState(false);
  const [overrideSetUprValidError_gam, setOverrideSetUprValidError_gam] = useState(false);
  const [uprCategory_gam, setUprCategory_gam] = useState("");
  const [uprCategoryIsRequiredError_gam, setUprCategoryIsRequiredError_gam] = useState(false);
  // true when the Set UPR value is greater than every category's expected_amount_usd (no match)
  const [uprCategoryNotFoundError_gam, setUprCategoryNotFoundError_gam] = useState(false);
  // true when a category (exact or nearest greater) was successfully matched -> show "matched" message
  const [uprCategoryMatched_gam, setUprCategoryMatched_gam] = useState(false);
  // the pricing-expected category, committed only when the auto-select logic runs (fixed price blur / override / Set now)
  // -> comparing against this (not a live calc) keeps the mismatch banner from flickering while typing
  const [expectedUprCategory_gam, setExpectedUprCategory_gam] = useState(null);
  const [uprCategoryOptions_gam, setUprCategoryOptions_gam] = useState([]);
  const [zoneActiveCheckbox_gam, setZoneActiveCheckbox_gam] = useState(true);

  // Fetch CTV applications once (label: "displayName (appStoreId)", value: id)
  useEffect(() => {
    let status = Cookies.get("token_xapads_ssp") ? true : false;
    if (status) {
      let token = Cookies.get("token_xapads_ssp");
      axios
        .get(configData.SERVER_URL + "gam-new/ctv-applications", {
          headers: {
            "Content-Type": "application/json",
            "x-access-token": token,
          },
        })
        .then((response) => {
          const apps = response.data?.data || [];
          setTvApplicationOptions_gam(
            apps.map((app) => ({
              label: `${app.displayName} (${app.appStoreId})`,
              value: app.id,
            }))
          );
        })
        .catch((error) => { });
    }
  }, []);

  // Fetch UPR placements once (label: upr_name, value: upr_id)
  useEffect(() => {
    let status = Cookies.get("token_xapads_ssp") ? true : false;
    if (status) {
      let token = Cookies.get("token_xapads_ssp");
      axios
        .get(configData.SERVER_URL + "upr-placement/", {
          headers: {
            "Content-Type": "application/json",
            "x-access-token": token,
          },
        })
        .then((response) => {
          const uprs = response.data?.data || [];
          setUprCategoryOptions_gam(
            uprs.map((upr) => ({
              label: upr.upr_name,
              value: upr.upr_id,
              expected: upr.expected_amount_usd,
            }))
          );
        })
        .catch((error) => { });
    }
  }, []);

  function buildZoneName_gam(platform, format) {
    if (publisherName === "") return "";
    // Zone Name format: PublisherName-TrafficType-FormatType
    return publisherName + "-" + platform + "-" + format;
  }

  function reset_gam() {
    setPlatformType_gam("Website");
    setFormatType_gam("Video");
    setZoneName_gam("");
    setZoneNameIsRequiredError_gam(false);
    setZoneNameMaxError_gam(false);
    setNameExists((p) => ({ ...p, gam: false }));
    setSizesList_gam([]);
    setSizesIsRequiredError_gam(false);
    setSearchSizesList_gam("");
    setCompanionList_gam([]);
    setSearchCompanionList_gam("");
    setTvAppNameCheckbox_gam(false);
    setTvApplication_gam("");
    setTvApplicationIsRequiredError_gam(false);
    setFixedPrice_gam("");
    setFixedPriceIsRequiredError_gam(false);
    setFixedPriceValidError_gam(false);
    setUpr_gam("");
    setOverrideUpr_gam(false);
    setOverrideSetUpr_gam("");
    setOverrideSetUprIsRequiredError_gam(false);
    setOverrideSetUprValidError_gam(false);
    setUprCategory_gam("");
    setExpectedUprCategory_gam(null);
    setUprCategoryIsRequiredError_gam(false);
    setUprCategoryNotFoundError_gam(false);
    setUprCategoryMatched_gam(false);
    setZoneActiveCheckbox_gam(true);
  }

  function onChangePlatformType_gam(event) {
    const value = event.target.value;
    setPlatformType_gam(value);
    // For CTV, video is selected by default. For Web/Inapp default to Banner.
    const nextFormat = value === "CTV" ? "Video" : formatType_gam;
    // switching format resets sizes and companion dropdowns

    if (value === "CTV") {
      setFormatType_gam("Video")
      if (formatType_gam !== "Video") {

        setSizesList_gam([]);
        setSizesIsRequiredError_gam(false);
        setCompanionList_gam([]);
      }
    }

    if (value !== "CTV") {
      // TV app fields are relevant to CTV only
      setTvAppNameCheckbox_gam(false);
      setTvApplication_gam("");
      setTvApplicationIsRequiredError_gam(false);
    }
    setZoneNameIsRequiredError_gam(false);
    setZoneName_gam(buildZoneName_gam(value, nextFormat));
  }

  function onChangeFormatType_gam(event) {
    const value = event.target.value;
    setFormatType_gam(value);
    // switching format resets sizes and companion dropdowns
    setSizesList_gam([]);
    setSizesIsRequiredError_gam(false);
    setCompanionList_gam([]);
    setZoneNameIsRequiredError_gam(false);
    setZoneName_gam(buildZoneName_gam(platformType_gam, value));
  }

  function onChangeZoneName_gam(event) {
    const value = event.target.value;
    setZoneNameIsRequiredError_gam(false);
    setZoneNameMaxError_gam(value.length > 90);
    setNameExists((p) => ({ ...p, gam: false }));
    setZoneName_gam(value);
    debouncedCheckZoneName("gam", value);
  }

  function onBlurZoneName_gam(event) {
    const value = event.target.value.trim();
    if (value.length === 0) {
      setZoneNameIsRequiredError_gam(true);
    }
    setZoneNameMaxError_gam(value.length > 90);
    setZoneName_gam(value);
    if (nameCheckTimers.current.gam) clearTimeout(nameCheckTimers.current.gam);
    checkZoneNameUnique("gam", value);
  }

  // Sizes multi-select handlers (mandatory: at least one selection)
  const handleSearchSizesList_gam = (e) => {
    setSearchSizesList_gam(e.target.value);
  };
  function handleSelectAllSizesList_gam() {
    const allValues = sizesListOptions_gam.map((option) => option.value);
    if (sizesList_gam?.length !== sizesListOptions_gam?.length) {
      setSizesList_gam([...allValues]);
      setSizesIsRequiredError_gam(false);
    } else {
      setSizesList_gam([]);
    }
  }
  function handleSizesList_gam(value) {
    let temp = [...sizesList_gam];
    if (temp?.includes(value)) {
      temp = temp.filter((item) => item !== value);
    } else {
      temp = [...temp, value];
    }
    setSizesList_gam(temp);
    if (temp.length > 0) setSizesIsRequiredError_gam(false);
  }

  // Companion multi-select handlers
  const handleSearchCompanionList_gam = (e) => {
    setSearchCompanionList_gam(e.target.value);
  };
  function handleSelectAllCompanionList_gam() {
    const allValues = companionListOptions_gam.map((option) => option.value);
    if (companionList_gam?.length !== companionListOptions_gam?.length) {
      setCompanionList_gam([...allValues]);
    } else {
      setCompanionList_gam([]);
    }
  }
  function handleCompanionList_gam(value) {
    let temp = [...companionList_gam];
    if (temp?.includes(value)) {
      temp = temp.filter((item) => item !== value);
    } else {
      temp = [...temp, value];
    }
    setCompanionList_gam(temp);
  }

  function onChangeTvAppNameCheckbox_gam(event) {
    setTvAppNameCheckbox_gam(event.target.checked);
    if (!event.target.checked) {
      setTvApplication_gam("");
      setTvApplicationIsRequiredError_gam(false);
    }
  }

  function onChangeTvApplication_gam(event) {
    setTvApplication_gam(event);
    setTvApplicationIsRequiredError_gam(false);
  }

  // Match the given Set UPR value against the UPR Category options' expected_amount_usd:
  //  - exact match -> select that category
  //  - else nearest greater (ceiling) expected -> select that category (Set UPR is left unchanged)
  //  - if every expected is less than the value -> clear the category and show "match not found"
  function autoSelectUprCategory_gam(rawValue) {
    const num = parseFloat(rawValue);
    const candidates = (uprCategoryOptions_gam || [])
      .filter((o) => typeof o.expected === "number" && !isNaN(o.expected))
      .sort((a, b) => a.expected - b.expected);
    if (isNaN(num) || candidates.length === 0) return;
    // smallest expected value that is >= the given value (exact match or nearest greater)
    const chosen = candidates.find((o) => o.expected >= num);
    if (!chosen) {
      // every expected_amount_usd is less than the Set UPR value -> no match
      setUprCategory_gam("");
      setExpectedUprCategory_gam(null);
      setUprCategoryMatched_gam(false);
      setUprCategoryNotFoundError_gam(true);
      setUprCategoryIsRequiredError_gam(false);
      return;
    }
    setUprCategory_gam(chosen.value);
    setExpectedUprCategory_gam(chosen.value);
    // Set UPR keeps its computed/entered value; only the category reflects the nearest-ceiling match
    setUprCategoryIsRequiredError_gam(false);
    setUprCategoryNotFoundError_gam(false);
    setUprCategoryMatched_gam(true);
  }

  function onChangeFixedPrice_gam(event) {
    const value = event.target.value;
    setFixedPriceIsRequiredError_gam(false);
    setFixedPriceValidError_gam(false);
    // the Set UPR is about to change -> drop any stale category match/not-found state
    setUprCategoryNotFoundError_gam(false);
    setUprCategoryMatched_gam(false);
    // number only (allow decimals)
    if (value === "" || /^\d*\.?\d*$/.test(value)) {
      setFixedPrice_gam(value);
      // Set UPR is auto = Fixed Price / (1 - 0.2) (always disabled), fixed to 2 decimals
      const num = parseFloat(value);
      setUpr_gam(!isNaN(num) ? (num / (1 - 0.2)).toFixed(2) : "");
    }
  }

  function onBlurFixedPrice_gam(event) {
    const value = event.target.value.trim();
    if (value === "") {
      setFixedPriceIsRequiredError_gam(true);
      return;
    }
    const num = parseFloat(value);
    // must be greater than 0
    if (isNaN(num) || num <= 0) {
      setFixedPriceValidError_gam(true);
      return;
    }
    const uprValue = (num / (1 - 0.2)).toFixed(2);
    setUpr_gam(uprValue);
    // Trigger 1: on fixed price blur -> auto-select category from the Set UPR value
    // (override value drives it instead while override is enabled)
    if (!overrideUpr_gam) {
      autoSelectUprCategory_gam(uprValue);
    }
  }

  function onChangeOverrideUpr_gam(event) {
    const checked = event.target.checked;
    setOverrideUpr_gam(checked);
    // Trigger 2: override checkbox toggle
    if (checked) {
      // if no value in Override Set UPR, default it to the Set UPR value
      let valueForCategory = overrideSetUpr_gam;
      if (overrideSetUpr_gam === "" || isNaN(parseFloat(overrideSetUpr_gam))) {
        if (upr_gam !== "" && !isNaN(parseFloat(upr_gam))) {
          setOverrideSetUpr_gam(upr_gam);
          setOverrideSetUprIsRequiredError_gam(false);
          setOverrideSetUprValidError_gam(false);
          valueForCategory = upr_gam;
        }
      }
      if (valueForCategory !== "" && !isNaN(parseFloat(valueForCategory))) {
        autoSelectUprCategory_gam(valueForCategory);
      }
    } else {
      // unchecked -> clear override errors and auto-select based on the Set UPR value
      setOverrideSetUprIsRequiredError_gam(false);
      setOverrideSetUprValidError_gam(false);
      autoSelectUprCategory_gam(upr_gam);
    }
  }

  function onChangeOverrideSetUpr_gam(event) {
    const value = event.target.value;
    setOverrideSetUprIsRequiredError_gam(false);
    setOverrideSetUprValidError_gam(false);
    // the value driving the category is about to change -> drop stale match/not-found state
    setUprCategoryNotFoundError_gam(false);
    setUprCategoryMatched_gam(false);
    // number only (allow decimals)
    if (value === "" || /^\d*\.?\d*$/.test(value)) {
      setOverrideSetUpr_gam(value);
    }
  }

  function onBlurOverrideSetUpr_gam(event) {
    // mandatory & same validation as fixed price (must be > 0)
    const value = event.target.value.trim();
    if (value === "") {
      setOverrideSetUprIsRequiredError_gam(true);
      return;
    }
    const num = parseFloat(value);
    if (isNaN(num) || num <= 0) {
      setOverrideSetUprValidError_gam(true);
      return;
    }
    // Trigger 3: override set upr blur (relevant while override is checked)
    autoSelectUprCategory_gam(value);
  }

  function onChangeUprCategory_gam(event) {
    setUprCategoryIsRequiredError_gam(false);
    setUprCategoryNotFoundError_gam(false);
    setUprCategory_gam(event);
    // manual selection -> copy the selected category's expected_amount_usd into Set UPR
    const selected = (uprCategoryOptions_gam || []).find((o) => o.value === event);
    if (selected && typeof selected.expected === "number" && !isNaN(selected.expected)) {
      setUpr_gam(Number(selected.expected).toFixed(2));
    }
    setUprCategoryMatched_gam(!!event);
  }

  // true when a (non-empty) category is selected that differs from the pricing-expected one.
  // Compares against expectedUprCategory_gam (committed on blur) so it doesn't flicker while typing the Fixed Price.
  function isUprCategoryMismatch_gam() {
    if (!uprCategory_gam) return false;
    if (!expectedUprCategory_gam) return false;
    return uprCategory_gam !== expectedUprCategory_gam;
  }

  // "Set now" -> re-apply the pricing logic (same as Fixed Price blur): set the UPR and auto-select the correct category
  function handleSetNowUprCategory_gam() {
    if (overrideUpr_gam) {
      if (overrideSetUpr_gam !== "" && !isNaN(parseFloat(overrideSetUpr_gam))) {
        autoSelectUprCategory_gam(overrideSetUpr_gam);
      }
      return;
    }
    const num = parseFloat(fixedPrice_gam);
    if (!isNaN(num) && num > 0) {
      const uprValue = (num / (1 - 0.2)).toFixed(2);
      setUpr_gam(uprValue);
      autoSelectUprCategory_gam(uprValue);
    }
  }

  function onChangeZoneActiveCheckbox_gam(event) {
    setZoneActiveCheckbox_gam(event.target.checked);
  }


  ///////////////////////////////////////submit //////////////////////////////////////////////////////////////////

  const publishersRef = useRef(null)
  const channelDetailsRef = useRef(null)
  const supplyDetailsRef = useRef(null)

  const errorDetect = () => {

    if ((role !== "admin" && role !== "u_admin")) {
      if (publisherName === "" || publisherIsRequiredError) {
        scrollToItem(publishersRef);
        return
      }

      if (channelName_publica.trim() === "" || channelNameIsRequiredError_publica || region_publica === "" || regionIsRequiredError_publica || eCpm_publica === "" || eCpmIsRequiredError_publica || eCpmValidError_publica || bidAdjustment_publica === "" || bidAdjustmentIsRequiredError_publica || bidAdjustmentValidError_publica || bidValueValidError_publica) {
        scrollToItem(channelDetailsRef);
        return
      }

      if (asi_publica.trim() === "" || asiIsRequiredError_publica || sid_publica.trim() === "" || sidIsRequiredError_publica || name_publica.trim() === "" || nameIsRequiredError_publica || domain_publica.trim() === "" || domainIsRequiredError_publica) {
        scrollToItem(supplyDetailsRef);
        return
      }
    }


  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    // block submit if the active zone/channel name is a known duplicate
    const nameCheckKeyByFormType = {
      "Prebid": "prebid",
      "Open RTB": "openrtb",
      "publica": "publica",
      "Vast Zone": "vastzone",
      "GAM": "gam",
    };
    const activeNameKey = nameCheckKeyByFormType[formType];
    if (activeNameKey && nameExists[activeNameKey]) {
      notifyfailure("Zone name already exists");
      return;
    }

    if (formType === "Prebid") {
      if ((role === "admin" || role === "u_admin")) {
        if (zoneName_prebid !== "" &&
          formatType_prebid.length > 0 &&
          !formatType_prebid?.includes("Banner") ? true : bannerCheckbox_prebid !== null
        ) {
          if (zoneNameIsRequiredError_prebid === false && humanValidError_prebid === false && /* PIXALATE SUNSET: pixalateValidError_prebid === false && */ doubleverifyValidError_prebid === false) {
            let payload =
              formatType_prebid?.includes("Banner")
                ? {
                  formType: formType,
                  invent_type: platformType_prebid,
                  exchange_type: integrationType_prebid,
                  traffic_type: formatType_prebid?.join(","),
                  bannerCheckbox: bannerCheckbox_prebid,
                  name: zoneName_prebid,
                  is_active: zoneActiveCheckbox_prebid,
                  sampling_human: Number(human_prebid),
                  // PIXALATE SUNSET: not sent in payload
                  // sampling_pixalate: Number(pixalate_prebid),
                  sampling_dv: Number(doubleverify_prebid),
                }
                : {
                  formType: formType,
                  invent_type: platformType_prebid,
                  exchange_type: integrationType_prebid,
                  traffic_type: formatType_prebid?.join(","),
                  name: zoneName_prebid,
                  is_active: zoneActiveCheckbox_prebid,
                  sampling_human: Number(human_prebid),
                  // PIXALATE SUNSET: not sent in payload
                  // sampling_pixalate: Number(pixalate_prebid),
                  sampling_dv: Number(doubleverify_prebid),
                };
            payload.blockCategory = [...blockCategorySelected];            // if (isAddValueCheckbox_prebid) {
            //   payload.ipd_bool = isAddValueCheckbox_prebid;
            // }

            // if (override_prebid?.trim()?.length > 0) {
            //   payload.ipd_value = override_prebid;
            // }


            setButtonProcessing(true)

            let status = Cookies.get("token_xapads_ssp") ? true : false;
            if (status) {
              // setButtonValue(true);
              let token = Cookies.get("token_xapads_ssp");
              // let id = jwtDecode(token)._id;

              axios
                .post(configData.SERVER_URL + `zone/createPrebidZone`, payload, {
                  headers: {
                    'Content-Type': 'application/json',
                    "x-access-token": token,
                  },
                })
                .then((response) => {
                  notifysuccess(response.data.message);
                  setDataModal_prebid(response.data.data)
                  setIsModalVisible(true)

                  setButtonProcessing(false)
                  // setStep(2)
                  // setTimeout(() => {
                  //   window.location.replace("/login");
                  // }, 1500);
                })
                .catch((error) => {
                  if (error?.response) {
                    if (error.response.data.message?.length !== 0) {
                      notifyfailure(error.response.data.message);
                      setButtonProcessing(false)
                    }
                  } else {
                    notifycatch();
                    setButtonProcessing(false)
                  }
                  // setButtonValue(false);
                });
            }
          }
        } else {
          if (zoneName_prebid === "") {
            setZoneNameIsRequiredError_prebid(true);
          }
          if (formatType_prebid?.includes("Banner") && bannerCheckbox_prebid === null) {
            setBannerCheckboxIsRequiredError_prebid(true)
          }
          if (formatType_prebid.length === 0) {
            setFormatTypeIsRequiredError_prebid(true)
          }
        }

      }
      else {
        if (zoneName_prebid !== "" && publisherName !== ""
          &&
          formatType_prebid.length > 0 &&
          revSharePercent_prebid !== "" &&
          !formatType_prebid.includes("Banner") ? true : bannerCheckbox_prebid !== null
        ) {
          if (
            zoneNameIsRequiredError_prebid === false &&
            publisherIsRequiredError === false &&
            impressionValueError_prebid === false &&
            requestValueError_prebid === false &&
            revSharePercentIsRequiredError_prebid === false &&
            revSharePercentValidError_prebid === false &&
            minCpmValueError_prebid === false &&
            maxCpmValueError_prebid === false &&
            humanValidError_prebid === false &&
            // PIXALATE SUNSET: pixalateValidError_prebid === false &&
            doubleverifyValidError_prebid === false

          ) {
            let payload =
              formatType_prebid.includes("Banner")
                ? {

                  formType: formType,
                  invent_type: platformType_prebid,
                  exchange_type: integrationType_prebid,
                  traffic_type: formatType_prebid?.join(","),
                  bannerCheckbox: bannerCheckbox_prebid,
                  name: zoneName_prebid,
                  is_active: zoneActiveCheckbox_prebid,
                  impressions_daily: impression_prebid !== "" ? Number(impression_prebid) : null,
                  requests_daily: request_prebid !== "" ? Number(request_prebid) : null,
                  publisherId: selectedPublisher,
                  revshare: revSharePercent_prebid,
                  minEcpm: minCpm_prebid,
                  maxEcpm: maxCpm_prebid,
                  isHighestBidFloor: minCpm_prebid === "" ? false : highestBidFloorCheckbox_prebid,
                  sampling_human: Number(human_prebid),
                  // PIXALATE SUNSET: not sent in payload
                  // sampling_pixalate: Number(pixalate_prebid),
                  sampling_dv: Number(doubleverify_prebid),
                }
                : {
                  formType: formType,
                  invent_type: platformType_prebid,
                  exchange_type: integrationType_prebid,
                  traffic_type: formatType_prebid?.join(","),
                  name: zoneName_prebid,
                  is_active: zoneActiveCheckbox_prebid,
                  impressions_daily: impression_prebid !== "" ? Number(impression_prebid) : null,
                  requests_daily: request_prebid !== "" ? Number(request_prebid) : null,
                  publisherId: selectedPublisher,
                  revshare: revSharePercent_prebid,
                  minEcpm: minCpm_prebid,
                  maxEcpm: maxCpm_prebid,
                  isHighestBidFloor: minCpm_prebid === "" ? false : highestBidFloorCheckbox_prebid,
                  sampling_human: Number(human_prebid),
                  // PIXALATE SUNSET: not sent in payload
                  // sampling_pixalate: Number(pixalate_prebid),
                  sampling_dv: Number(doubleverify_prebid),
                };
            payload.blockCategory = [...blockCategorySelected]; if (isAddValueCheckbox_prebid) {
              payload.ipd_bool = isAddValueCheckbox_prebid;
            }

            if (override_prebid?.trim()?.length > 0) {
              payload.ipd_value = override_prebid;
            }

            setButtonProcessing(true)

            let status = Cookies.get("token_xapads_ssp") ? true : false;
            if (status) {
              // setButtonValue(true);
              let token = Cookies.get("token_xapads_ssp");
              // let id = jwtDecode(token)._id;

              axios
                .post(configData.SERVER_URL + `zone/createPrebidZone`, payload, {
                  headers: {
                    'Content-Type': 'application/json',
                    "x-access-token": token,
                  },
                })
                .then((response) => {
                  notifysuccess(response.data.message);
                  setDataModal_prebid(response.data.data)
                  setIsModalVisible(true)

                  setButtonProcessing(false)
                  // setStep(2)
                  // setTimeout(() => {
                  //   window.location.replace("/login");
                  // }, 1500);
                })
                .catch((error) => {
                  if (error?.response) {
                    if (error.response.data.message?.length !== 0) {
                      notifyfailure(error.response.data.message);
                      setButtonProcessing(false)
                    }
                  } else {
                    notifycatch();
                    setButtonProcessing(false)
                  }
                  // setButtonValue(false);
                });
            }
          }
        } else {
          if (zoneName_prebid === "") {
            setZoneNameIsRequiredError_prebid(true);
          }
          if (publisherName === "") {
            setPublisherIsRequiredError(true);
          }
          if (formatType_prebid.includes("Banner") && bannerCheckbox_prebid === null) {
            setBannerCheckboxIsRequiredError_prebid(true)
          }
          if (formatType_prebid.length === 0) {
            setFormatTypeIsRequiredError_prebid(true)
          }
          if (revSharePercent_prebid === "") {
            setRevSharePercentIsRequiredError_prebid(true)
          }
        }
      }
    } else if (formType === "Open RTB") {
      // eslint-disable-next-line no-lone-blocks
      {
        if ((role === "admin" || role === "u_admin")) {
          if (zoneName_openrtb !== "" &&
            (platformType_openrtb === "CTV" ? true : formatType_openrtb?.length > 0) &&
            platformType_openrtb === "CTV" ? true : !formatType_openrtb?.includes("Banner") ? true : bannerCheckbox_openrtb !== null) {
            if (zoneNameIsRequiredError_openrtb === false && humanValidError_openrtb === false && /* PIXALATE SUNSET: pixalateValidError_openrtb === false && */ doubleverifyValidError_openrtb === false) {
              let payload =
                formatType_openrtb?.includes("Banner")
                  ? {
                    formType: formType,
                    invent_type: platformType_openrtb,
                    exchange_type: integrationType_openrtb,
                    traffic_type: platformType_openrtb === "CTV" ? "Video" : formatType_openrtb?.join(","),
                    bannerCheckbox: bannerCheckbox_openrtb,
                    name: zoneName_openrtb,
                    is_active: zoneActiveCheckbox_openrtb,
                    sampling_human: Number(human_openrtb),
                    // PIXALATE SUNSET: not sent in payload
                    // sampling_pixalate: Number(pixalate_openrtb),
                    sampling_dv: Number(doubleverify_openrtb),
                  }
                  : {
                    formType: formType,
                    invent_type: platformType_openrtb,
                    exchange_type: integrationType_openrtb,
                    traffic_type: platformType_openrtb === "CTV" ? "Video" : formatType_openrtb?.join(","),
                    name: zoneName_openrtb,
                    is_active: zoneActiveCheckbox_openrtb,
                    sampling_human: Number(human_openrtb),
                    // PIXALATE SUNSET: not sent in payload
                    // sampling_pixalate: Number(pixalate_openrtb),
                    sampling_dv: Number(doubleverify_openrtb),
                  };
              payload.blockCategory = [...blockCategorySelected];              // if (isAddValueCheckbox_openrtb) {
              //   payload.ipd_bool = isAddValueCheckbox_openrtb;
              // }
              // if (override_openrtb?.trim()?.length > 0) {
              //   payload.ipd_value = override_openrtb;
              // }



              setButtonProcessing(true)

              let status = Cookies.get("token_xapads_ssp") ? true : false;
              if (status) {
                // setButtonValue(true);
                let token = Cookies.get("token_xapads_ssp");
                // let id = jwtDecode(token)._id;

                axios
                  .post(configData.SERVER_URL + `zone/createORTBZone`, payload, {
                    headers: {
                      'Content-Type': 'application/json',
                      "x-access-token": token,
                    },
                  })
                  .then((response) => {
                    notifysuccess(response.data.message);
                    setDataModal_openrtb(response.data.data)
                    setIsModalVisible(true)
                    setButtonProcessing(false)
                    // setStep(2)
                    // setTimeout(() => {
                    //   window.location.replace("/login");
                    // }, 1500);
                  })
                  .catch((error) => {
                    if (error?.response) {
                      if (error.response.data.message?.length !== 0) {
                        notifyfailure(error.response.data.message);
                        setButtonProcessing(false)
                      }
                    } else {
                      notifycatch();
                      setButtonProcessing(false)
                    }
                    // setButtonValue(false);
                  });
              }
            }
          } else {
            if (zoneName_openrtb === "") {
              setZoneNameIsRequiredError_openrtb(true);
            }
            if (formatType_openrtb?.includes("Banner") && bannerCheckbox_openrtb === null && platformType_openrtb !== "CTV") {
              setBannerCheckboxIsRequiredError_openrtb(true)
            }


            if (platformType_openrtb !== "CTV" && formatType_openrtb?.length === 0) {
              setFormatTypeIsRequiredError_openrtb(true)

            }

          }
        } else {
          if (zoneName_openrtb !== "" && publisherName !== "" &&
            revSharePercent_openrtb !== "" &&
            (platformType_openrtb === "CTV" ? true : formatType_openrtb?.length > 0) &&
            platformType_openrtb === "CTV" ? true : !formatType_openrtb?.includes("Banner") ? true : bannerCheckbox_openrtb !== null) {
            if (
              zoneNameIsRequiredError_openrtb === false &&
              publisherIsRequiredError === false &&
              impressionValueError_openrtb === false &&
              requestValueError_openrtb === false &&
              revSharePercentIsRequiredError_openrtb === false &&
              revSharePercentValidError_openrtb === false &&
              minCpmValueError_openrtb === false &&
              maxCpmValueError_openrtb === false &&
              humanValidError_openrtb === false &&
              // PIXALATE SUNSET: pixalateValidError_openrtb === false &&
              doubleverifyValidError_openrtb === false
            ) {
              let payload =
                formatType_openrtb?.includes("Banner")
                  ? {
                    formType: formType,
                    invent_type: platformType_openrtb,
                    exchange_type: integrationType_openrtb,
                    traffic_type: platformType_openrtb === "CTV" ? "Video" : formatType_openrtb?.join(","),
                    bannerCheckbox: bannerCheckbox_openrtb,
                    name: zoneName_openrtb,
                    is_active: zoneActiveCheckbox_openrtb,
                    impressions_daily: impression_openrtb !== "" ? Number(impression_openrtb) : null,
                    requests_daily: request_openrtb !== "" ? Number(request_openrtb) : null,
                    publisherId: selectedPublisher,
                    revshare: revSharePercent_openrtb,
                    minEcpm: minCpm_openrtb,
                    maxEcpm: maxCpm_openrtb,
                    isHighestBidFloor: minCpm_openrtb === "" ? false : highestBidFloorCheckbox_openrtb,
                    sampling_human: Number(human_openrtb),
                    // PIXALATE SUNSET: not sent in payload
                    // sampling_pixalate: Number(pixalate_openrtb),
                    sampling_dv: Number(doubleverify_openrtb),
                  }
                  : {
                    formType: formType,
                    invent_type: platformType_openrtb,
                    exchange_type: integrationType_openrtb,
                    traffic_type: platformType_openrtb === "CTV" ? "Video" : formatType_openrtb?.join(","),
                    name: zoneName_openrtb,
                    is_active: zoneActiveCheckbox_openrtb,
                    impressions_daily: impression_openrtb !== "" ? Number(impression_openrtb) : null,
                    requests_daily: request_openrtb !== "" ? Number(request_openrtb) : null,
                    publisherId: selectedPublisher,
                    revshare: revSharePercent_openrtb,
                    minEcpm: minCpm_openrtb,
                    maxEcpm: maxCpm_openrtb,
                    isHighestBidFloor: minCpm_openrtb === "" ? false : highestBidFloorCheckbox_openrtb,
                    sampling_human: Number(human_openrtb),
                    // PIXALATE SUNSET: not sent in payload
                    // sampling_pixalate: Number(pixalate_openrtb),
                    sampling_dv: Number(doubleverify_openrtb),
                  };
              payload.blockCategory = [...blockCategorySelected]; if (isAddValueCheckbox_openrtb) {
                payload.ipd_bool = isAddValueCheckbox_openrtb;
              }
              if (override_openrtb?.trim()?.length > 0) {
                payload.ipd_value = override_openrtb;
              }


              setButtonProcessing(true)


              let status = Cookies.get("token_xapads_ssp") ? true : false;
              if (status) {
                // setButtonValue(true);
                let token = Cookies.get("token_xapads_ssp");
                // let id = jwtDecode(token)._id;

                axios
                  .post(configData.SERVER_URL + `zone/createORTBZone`, payload, {
                    headers: {
                      'Content-Type': 'application/json',
                      "x-access-token": token,
                    },
                  })
                  .then((response) => {
                    notifysuccess(response.data.message);
                    setDataModal_openrtb(response.data.data)
                    setIsModalVisible(true)
                    setButtonProcessing(false)
                    // setStep(2)
                    // setTimeout(() => {
                    //   window.location.replace("/login");
                    // }, 1500);
                  })
                  .catch((error) => {
                    if (error?.response) {
                      if (error.response.data.message?.length !== 0) {
                        notifyfailure(error.response.data.message);
                        setButtonProcessing(false)
                      }
                    } else {
                      notifycatch();
                      setButtonProcessing(false)
                    }
                    // setButtonValue(false);
                  });
              }
            }
          } else {
            if (zoneName_openrtb === "") {
              setZoneNameIsRequiredError_openrtb(true);
            }
            if (publisherName === "") {
              setPublisherIsRequiredError(true);
            }
            if (formatType_openrtb?.includes("Banner") && bannerCheckbox_openrtb === null && platformType_openrtb !== "CTV") {
              setBannerCheckboxIsRequiredError_openrtb(true)
            }

            if (platformType_openrtb !== "CTV" && formatType_openrtb?.length === 0) {
              setFormatTypeIsRequiredError_openrtb(true)

            }
            if (revSharePercent_openrtb === "") {
              setRevSharePercentIsRequiredError_openrtb(true)
            }
          }
        }
      }
    }

    else if (formType === "publica") {
      errorDetect()
      if ((role === "admin" || role === "u_admin")) {
        if (
          channelName_publica !== "" &&
          region_publica !== "" &&
          eCpm_publica !== "" &&
          template_publica !== ""

        ) {
          if (
            channelNameIsRequiredError_publica === false &&
            regionIsRequiredError_publica === false &&
            eCpmIsRequiredError_publica === false &&
            eCpmValidError_publica === false &&
            templateIsRequiredError_publica === false &&
            humanValidError_publica === false &&
            pixalateValidError_publica === false

          ) {
            let payload = {
              formType: formType,
              invent_type: platformType_publica,
              channel_name: channelName_publica,
              region: region_publica,
              eCpm: eCpm_publica,
              template: template_publica,
              sampling_human: Number(human_publica),
              sampling_pixalate: Number(pixalate_publica),
              sampling_dv: Number(doubleverify_publica),
            }



            setButtonProcessing(true)

            let status = Cookies.get("token_xapads_ssp") ? true : false;
            if (status) {
              // setButtonValue(true);
              let token = Cookies.get("token_xapads_ssp");
              // let id = jwtDecode(token)._id;

              axios
                .post(configData.SERVER_URL + `zone/createPublicaZone`, payload, {
                  headers: {
                    'Content-Type': 'application/json',
                    "x-access-token": token,
                  },
                })
                .then((response) => {
                  notifysuccess(response.data.message);
                  setDataModal_publica(response.data.data)
                  setIsModalVisible(true)
                  setButtonProcessing(false)
                })
                .catch((error) => {
                  if (error?.response) {
                    if (error.response.data.message?.length !== 0) {
                      notifyfailure(error.response.data.message);
                      setButtonProcessing(false)
                    }
                  } else {
                    notifycatch();
                    setButtonProcessing(false)
                  }
                });
            }
          }
        } else {
          if (channelName_publica === "") {
            setChannelNameIsRequiredError_publica(true);
          }
          if (region_publica === "") {
            setRegionIsRequiredError_publica(true)
          }

          if (eCpm_publica === "") {
            setECpmIsRequiredError_publica(true)
          }

          if (template_publica === "") {
            setTemplateIsRequiredError_publica(true)
          }

        }

      }
      else {
        if (
          publisherName !== "" &&
          channelName_publica !== "" &&
          region_publica !== "" &&
          eCpm_publica !== "" &&
          bidAdjustment_publica !== "" &&
          asi_publica !== "" &&
          sid_publica !== "" &&
          name_publica !== "" &&
          domain_publica !== "" &&
          // override_publica !== "" &&
          template_publica !== ""


        ) {
          if (
            publisherIsRequiredError === false &&
            channelNameIsRequiredError_publica === false &&
            regionIsRequiredError_publica === false &&
            eCpmIsRequiredError_publica === false &&
            eCpmValidError_publica === false &&
            bidAdjustmentIsRequiredError_publica === false &&
            bidAdjustmentValidError_publica === false &&
            bidValueValidError_publica === false &&
            asiIsRequiredError_publica === false &&
            sidIsRequiredError_publica === false &&
            nameIsRequiredError_publica === false &&
            domainIsRequiredError_publica === false &&
            // overrideIsRequiredError_publica === false &&
            templateIsRequiredError_publica === false &&
            humanValidError_publica === false &&
            pixalateValidError_publica === false

          ) {
            let payload = {
              publisherId: selectedPublisher,
              formType: formType,
              invent_type: platformType_publica,
              header_bidder_vast_version: vastVersion_publica,
              channel_name: channelName_publica,
              region: region_publica,
              eCpm: eCpm_publica,
              bid_adjustment: bidAdjustment_publica,
              bid_adjustment_value: bidValue_publica,
              asi: asi_publica,
              sid: sid_publica,
              name: name_publica,
              domain: domain_publica,
              isAddValueCheckbox: isAddValueCheckbox_publica,
              override: override_publica,
              template: template_publica,
              sampling_human: Number(human_publica),
              sampling_pixalate: Number(pixalate_publica),
              sampling_dv: Number(doubleverify_publica),
            }



            setButtonProcessing(true)

            let status = Cookies.get("token_xapads_ssp") ? true : false;
            if (status) {
              // setButtonValue(true);
              let token = Cookies.get("token_xapads_ssp");
              // let id = jwtDecode(token)._id;

              axios
                .post(configData.SERVER_URL + `zone/createPublicaZone`, payload, {
                  headers: {
                    'Content-Type': 'application/json',
                    "x-access-token": token,
                  },
                })
                .then((response) => {
                  notifysuccess(response.data.message);
                  setDataModal_publica(response.data.data)
                  setIsModalVisible(true)

                  setButtonProcessing(false)
                })
                .catch((error) => {
                  if (error?.response) {
                    if (error.response.data.message?.length !== 0) {
                      notifyfailure(error.response.data.message);
                      setButtonProcessing(false)
                    }
                  } else {
                    notifycatch();
                    setButtonProcessing(false)
                  }
                  // setButtonValue(false);
                });
            }
          }
        } else {
          if (publisherName === "") {
            setPublisherIsRequiredError(true);
          }

          if (channelName_publica === "") {
            setChannelNameIsRequiredError_publica(true);
          }
          if (region_publica === "") {
            setRegionIsRequiredError_publica(true)
          }

          if (eCpm_publica === "") {
            setECpmIsRequiredError_publica(true)
          }

          if (bidAdjustment_publica === "") {
            setBidAdjustmentIsRequiredError_publica(true)
          }

          if (asi_publica === "") {
            setAsiIsRequiredError_publica(true)
          }

          if (sid_publica === "") {
            setSidIsRequiredError_publica(true)
          }

          if (name_publica === "") {
            setNameIsRequiredError_publica(true)
          }

          if (domain_publica === "") {
            setDomainIsRequiredError_publica(true)
          }

          if (template_publica === "") {
            setTemplateIsRequiredError_publica(true)
          }

        }
      }
    }
    else if (formType === "Vast Zone") {
      // eslint-disable-next-line no-lone-blocks
      {
        if ((role === "admin" || role === "u_admin")) {
          if (zoneName_vastzone !== "" &&
            template_vastzone !== "" &&
            (revenueType_vastzone === "Fixed_Price" ? eCpm_vastzone !== "" : true) &&
            (revenueType_vastzone === "Revshare" ? revSharePercent_vastzone !== "" : true)
          ) {
            if (
              zoneNameIsRequiredError_vastzone === false &&
              templateIsRequiredError_vastzone === false &&
              (revenueType_vastzone === "Fixed_Price" ? eCpmIsRequiredError_vastzone === false : true) &&
              (revenueType_vastzone === "Fixed_Price" ? eCpmValidError_vastzone === false : true) &&
              (revenueType_vastzone === "Revshare" ? revSharePercentIsRequiredError_vastzone === false : true) &&
              (revenueType_vastzone === "Revshare" ? revSharePercentValidError_vastzone === false : true) &&
              humanValidError_vastzone === false &&
              // PIXALATE SUNSET: pixalateValidError_vastzone === false &&
              doubleverifyValidError_vastzone === false
            ) {

              let payload =
                revenueType_vastzone === "Fixed_Price"
                  ? {
                    formType: formType,
                    invent_type: platformType_vastzone,
                    stream_position: platformType_vastzone === "CTV" ? "Instream" : streamPosition_vastzone,
                    name: zoneName_vastzone,
                    is_active: zoneActiveCheckbox_vastzone,
                    revenue_type: revenueType_vastzone,
                    fixed_cpm: Number(eCpm_vastzone),
                    sampling_human: Number(human_vastzone),
                    // PIXALATE SUNSET: not sent in payload
                    // sampling_pixalate: Number(pixalate_vastzone),
                    sampling_dv: Number(doubleverify_vastzone),
                  }
                  : {
                    formType: formType,
                    invent_type: platformType_vastzone,
                    stream_position: platformType_vastzone === "CTV" ? "Instream" : streamPosition_vastzone,
                    name: zoneName_vastzone,
                    is_active: zoneActiveCheckbox_vastzone,
                    revenue_type: revenueType_vastzone,
                    revshare: Number(revSharePercent_vastzone),
                    sampling_human: Number(human_vastzone),
                    // PIXALATE SUNSET: not sent in payload
                    // sampling_pixalate: Number(pixalate_vastzone),
                    sampling_dv: Number(doubleverify_vastzone),
                  };
              payload.blockCategory = [...blockCategorySelected];
              payload.template = template_vastzone;
              // if (isAddValueCheckbox_vastzone) {
              //   payload.ipd_bool = isAddValueCheckbox_vastzone;
              // }
              // if (override_vastzone?.trim()?.length > 0) {
              //   payload.ipd_value = override_vastzone;
              // }

              setButtonProcessing(true)


              let status = Cookies.get("token_xapads_ssp") ? true : false;
              if (status) {
                // setButtonValue(true);
                let token = Cookies.get("token_xapads_ssp");
                // let id = jwtDecode(token)._id;

                axios
                  .post(configData.SERVER_URL + `zone/createVastZone`, payload, {
                    headers: {
                      'Content-Type': 'application/json',
                      "x-access-token": token,
                    },
                  })
                  .then((response) => {
                    notifysuccess(response.data.message);
                    setDataModal_vastzone(response.data.data)
                    setIsModalVisible(true)
                    setButtonProcessing(false)
                    // setStep(2)
                    // setTimeout(() => {
                    //   window.location.replace("/login");
                    // }, 1500);
                  })
                  .catch((error) => {
                    if (error?.response) {
                      if (error.response.data.message?.length !== 0) {
                        notifyfailure(error.response.data.message);
                        setButtonProcessing(false)
                      }
                    } else {
                      notifycatch();
                      setButtonProcessing(false)
                    }
                    // setButtonValue(false);
                  });
              }
            }
          } else {
            if (zoneName_vastzone === "") {
              setZoneNameIsRequiredError_vastzone(true);
            }
            if (revenueType_vastzone === "Fixed_Price" && eCpm_vastzone === "") {
              setECpmIsRequiredError_vastzone(true);
            }
            if (revenueType_vastzone === "Revshare" && revSharePercent_vastzone === "") {
              setRevSharePercentIsRequiredError_vastzone(true);
            }
            if (template_vastzone === "") {
              setTemplateIsRequiredError_vastzone(true);
            }
          }
        }
        else {
          if (zoneName_vastzone !== "" &&
            publisherName !== "" &&
            template_vastzone !== "" &&
            (revenueType_vastzone === "Fixed_Price" ? eCpm_vastzone !== "" : true) &&
            (revenueType_vastzone === "Revshare" ? revSharePercent_vastzone !== "" : true)
          ) {
            if (
              zoneNameIsRequiredError_vastzone === false &&
              templateIsRequiredError_vastzone === false &&
              (revenueType_vastzone === "Fixed_Price" ? eCpmIsRequiredError_vastzone === false : true) &&
              (revenueType_vastzone === "Fixed_Price" ? eCpmValidError_vastzone === false : true) &&
              (revenueType_vastzone === "Revshare" ? revSharePercentIsRequiredError_vastzone === false : true) &&
              (revenueType_vastzone === "Revshare" ? revSharePercentValidError_vastzone === false : true) &&
              humanValidError_vastzone === false &&
              // PIXALATE SUNSET: pixalateValidError_vastzone === false &&
              doubleverifyValidError_vastzone === false
            ) {

              let payload =
                revenueType_vastzone === "Fixed_Price"
                  ? {
                    formType: formType,
                    invent_type: platformType_vastzone,
                    stream_position: platformType_vastzone === "CTV" ? "Instream" : streamPosition_vastzone,
                    name: zoneName_vastzone,
                    is_active: zoneActiveCheckbox_vastzone,
                    revenue_type: revenueType_vastzone,
                    fixed_cpm: Number(eCpm_vastzone),
                    publisherId: selectedPublisher,
                    requests_daily: request_vastzone !== "" ? Number(request_vastzone) : null,
                    impressions_daily: impression_vastzone !== "" ? Number(impression_vastzone) : null,
                    sampling_human: Number(human_vastzone),
                    // PIXALATE SUNSET: not sent in payload
                    // sampling_pixalate: Number(pixalate_vastzone),
                    sampling_dv: Number(doubleverify_vastzone),
                  }
                  : {
                    formType: formType,
                    invent_type: platformType_vastzone,
                    stream_position: platformType_vastzone === "CTV" ? "Instream" : streamPosition_vastzone,
                    name: zoneName_vastzone,
                    is_active: zoneActiveCheckbox_vastzone,
                    revenue_type: revenueType_vastzone,
                    revshare: Number(revSharePercent_vastzone),
                    publisherId: selectedPublisher,
                    requests_daily: request_vastzone !== "" ? Number(request_vastzone) : null,
                    impressions_daily: impression_vastzone !== "" ? Number(impression_vastzone) : null,
                    sampling_human: Number(human_vastzone),
                    // PIXALATE SUNSET: not sent in payload
                    // sampling_pixalate: Number(pixalate_vastzone),
                    sampling_dv: Number(doubleverify_vastzone),
                  };
              payload.blockCategory = [...blockCategorySelected];
              payload.template = template_vastzone;
              if (isAddValueCheckbox_vastzone) {
                payload.ipd_bool = isAddValueCheckbox_vastzone;
              }
              if (override_vastzone?.trim()?.length > 0) {
                payload.ipd_value = override_vastzone;
              }

              setButtonProcessing(true)


              let status = Cookies.get("token_xapads_ssp") ? true : false;
              if (status) {
                // setButtonValue(true);
                let token = Cookies.get("token_xapads_ssp");
                // let id = jwtDecode(token)._id;

                axios
                  .post(configData.SERVER_URL + `zone/createVastZone`, payload, {
                    headers: {
                      'Content-Type': 'application/json',
                      "x-access-token": token,
                    },
                  })
                  .then((response) => {
                    notifysuccess(response.data.message);
                    setDataModal_vastzone(response.data.data)
                    setIsModalVisible(true)
                    setButtonProcessing(false)
                    // setStep(2)
                    // setTimeout(() => {
                    //   window.location.replace("/login");
                    // }, 1500);
                  })
                  .catch((error) => {
                    if (error?.response) {
                      if (error.response.data.message?.length !== 0) {
                        notifyfailure(error.response.data.message);
                        setButtonProcessing(false)
                      }
                    } else {
                      notifycatch();
                      setButtonProcessing(false)
                    }
                    // setButtonValue(false);
                  });
              }
            }
          } else {
            if (zoneName_vastzone === "") {
              setZoneNameIsRequiredError_vastzone(true);
            }
            if (revenueType_vastzone === "Fixed_Price" && eCpm_vastzone === "") {
              setECpmIsRequiredError_vastzone(true);
            }
            if (revenueType_vastzone === "Revshare" && revSharePercent_vastzone === "") {
              setRevSharePercentIsRequiredError_vastzone(true);
            }
            if (template_vastzone === "") {
              setTemplateIsRequiredError_vastzone(true);
            }
            if (publisherName === "") {
              setPublisherIsRequiredError(true);
            }
          }
        }


      }
    }
    else if (formType === "vast_aniview") {
      if ((role === "admin" || role === "u_admin")) {
        if (channelName_vast_aniview !== "" &&
          eCpm_vast_aniview !== ""
        ) {
          if (
            channelNameIsRequiredError_vast_aniview === false &&
            eCpmIsRequiredError_vast_aniview === false &&
            eCpmValidError_vast_aniview === false
          ) {

            let payload = {
              formType: formType,
              environment: platformType_vast_aniview,
              channelName: channelName_vast_aniview,
              fixed_ecpm: Number(eCpm_vast_aniview),

            }



            setButtonProcessing(true)

            let status = Cookies.get("token_xapads_ssp") ? true : false;
            if (status) {
              let token = Cookies.get("token_xapads_ssp");
              axios
                .post(configData.SERVER_URL + `zone/createVastZoneAniview`, payload, {
                  headers: {
                    "Content-Type": "application/json",
                    "x-access-token": token,
                  },
                })
                .then((response) => {
                  notifysuccess(response.data.message);
                  setDataModal_vast_aniview(response.data.data)
                  setIsModalVisible(true)
                  setButtonProcessing(false)
                })
                .catch((error) => {
                  if (error?.response) {
                    if (error.response.data.message?.length !== 0) {
                      notifyfailure(error.response.data.message);
                      setButtonProcessing(false)
                    }
                  } else {
                    notifycatch();
                    setButtonProcessing(false)
                  }
                });
            }
          }
        } else {
          if (channelName_vast_aniview === "") {
            setChannelNameIsRequiredError_vast_aniview(true);
          }
          if (eCpm_vast_aniview === "") {
            setECpmIsRequiredError_vast_aniview(true);
          }
        }
      }
      else {
        if (channelName_vast_aniview !== "" &&
          publisherName !== "" &&
          eCpm_vast_aniview !== ""
        ) {
          if (
            channelNameIsRequiredError_vast_aniview === false &&
            eCpmIsRequiredError_vast_aniview === false &&
            eCpmValidError_vast_aniview === false
          ) {

            let payload = {
              formType: formType,
              environment: platformType_vast_aniview,
              channelName: channelName_vast_aniview,
              fixed_ecpm: Number(eCpm_vast_aniview),
              publisherId: selectedPublisher
            }


            setButtonProcessing(true)

            let status = Cookies.get("token_xapads_ssp") ? true : false;
            if (status) {
              let token = Cookies.get("token_xapads_ssp");
              axios
                .post(configData.SERVER_URL + `zone/createVastZoneAniview`, payload, {
                  headers: {
                    "Content-Type": "application/json",
                    "x-access-token": token,
                  },
                })
                .then((response) => {
                  notifysuccess(response.data.message);
                  setDataModal_vast_aniview(response.data.data)
                  setIsModalVisible(true)
                  setButtonProcessing(false)
                })
                .catch((error) => {
                  if (error?.response) {
                    if (error.response.data.message?.length !== 0) {
                      notifyfailure(error.response.data.message);
                      setButtonProcessing(false)
                    }
                  } else {
                    notifycatch();
                    setButtonProcessing(false)
                  }
                });
            }
          }
        } else {
          if (channelName_vast_aniview === "") {
            setChannelNameIsRequiredError_vast_aniview(true);
          }
          if (eCpm_vast_aniview === "") {
            setECpmIsRequiredError_vast_aniview(true);
          }
          if (publisherName === "") {
            setPublisherIsRequiredError(true);
          }

        }
      }
    }
    else if (formType === "Player Tag" || formType === "tag_outstream") {
      // eslint-disable-next-line no-lone-blocks
      {
        if ((role === "admin" || role === "u_admin")) {
          if (channelName_playertag !== "" &&
            eCpm_playertag !== "" &&
            mainTableVideo_playertag.length > 0
          ) {
            if (
              channelNameIsRequiredError_playertag === false &&
              eCpmIsRequiredError_playertag === false &&
              eCpmValidError_playertag === false
            ) {
              let formData = new FormData();

              formData.append("formType", formType);
              formData.append("environment", platformType_playertag);
              formData.append("playerMode", playerMode_playertag);
              formData.append("channelName", channelName_playertag);
              formData.append("fixed_ecpm", Number(eCpm_playertag));
              // if (playerMode_playertag === "bannerVideo") {
              formData.append("floatingPos", floatingPosition_playertag);
              // }

              let arrayWithSize = [];
              let arrayWithoutSize = [];

              mainTableVideo_playertag.forEach(obj => {
                if (obj.hasOwnProperty('size')) {
                  arrayWithSize.push(obj);
                } else {
                  arrayWithoutSize.push(obj);
                }
              });

              formData.append("video_links", JSON.stringify(arrayWithoutSize));
              arrayWithSize.forEach((file) => {
                formData.append('video_files', file.data);
              });


              setButtonProcessing(true)


              let status = Cookies.get("token_xapads_ssp") ? true : false;
              if (status) {
                // setButtonValue(true);
                let token = Cookies.get("token_xapads_ssp");
                // let id = jwtDecode(token)._id;

                axios
                  .post(configData.SERVER_URL + `zone/createAniviewZone`, formData, {
                    headers: {
                      "Content-Type": "multipart/form-data",
                      "x-access-token": token,
                    },
                  })
                  .then((response) => {
                    notifysuccess(response.data.message);
                    setDataModal_playertag(response.data.data)
                    setIsModalVisible(true)
                    setButtonProcessing(false)
                    // setStep(2)
                    // setTimeout(() => {
                    //   window.location.replace("/login");
                    // }, 1500);
                  })
                  .catch((error) => {
                    if (error?.response) {
                      if (error.response.data.message?.length !== 0) {
                        notifyfailure(error.response.data.message);
                        setButtonProcessing(false)
                      }
                    } else {
                      notifycatch();
                      setButtonProcessing(false)
                    }
                    // setButtonValue(false);
                  });
              }
            }
          } else {
            if (channelName_playertag === "") {
              setChannelNameIsRequiredError_playertag(true);
            }
            if (eCpm_playertag === "") {
              setECpmIsRequiredError_playertag(true);
            }
            if (mainTableVideo_playertag.length === 0) {
              notifyfailure("At least 1 video is required")
            }
          }
        }
        else {
          if (channelName_playertag !== "" &&
            publisherName !== "" &&
            eCpm_playertag !== "" &&
            mainTableVideo_playertag.length > 0
          ) {
            if (
              channelNameIsRequiredError_playertag === false &&
              eCpmIsRequiredError_playertag === false &&
              eCpmValidError_playertag === false
            ) {
              let formData = new FormData();
              formData.append("formType", formType);
              formData.append("environment", platformType_playertag);
              formData.append("playerMode", playerMode_playertag);
              formData.append("channelName", channelName_playertag);
              formData.append("fixed_ecpm", Number(eCpm_playertag));
              // if (playerMode_playertag === "bannerVideo") {
              formData.append("floatingPos", floatingPosition_playertag);
              // }
              formData.append("publisherId", selectedPublisher);


              let arrayWithSize = [];
              let arrayWithoutSize = [];

              mainTableVideo_playertag.forEach(obj => {
                if (obj.hasOwnProperty('size')) {
                  arrayWithSize.push(obj);
                } else {
                  arrayWithoutSize.push(obj);
                }
              });

              formData.append("video_links", JSON.stringify(arrayWithoutSize));
              arrayWithSize.forEach((file) => {
                formData.append('video_files', file.data);
              });


              setButtonProcessing(true)


              let status = Cookies.get("token_xapads_ssp") ? true : false;
              if (status) {
                // setButtonValue(true);
                let token = Cookies.get("token_xapads_ssp");
                // let id = jwtDecode(token)._id;

                axios
                  .post(configData.SERVER_URL + `zone/createAniviewZone`, formData, {
                    headers: {
                      "Content-Type": "multipart/form-data",
                      "x-access-token": token,
                    },
                  })
                  .then((response) => {
                    notifysuccess(response.data.message);
                    setDataModal_playertag(response.data.data)
                    setIsModalVisible(true)
                    setButtonProcessing(false)
                    // setStep(2)
                    // setTimeout(() => {
                    //   window.location.replace("/login");
                    // }, 1500);
                  })
                  .catch((error) => {
                    if (error?.response) {
                      if (error.response.data.message?.length !== 0) {
                        notifyfailure(error.response.data.message);
                        setButtonProcessing(false)
                      }
                    } else {
                      notifycatch();
                      setButtonProcessing(false)
                    }
                    // setButtonValue(false);
                  });
              }
            }
          } else {
            if (channelName_playertag === "") {
              setChannelNameIsRequiredError_playertag(true);
            }
            if (eCpm_playertag === "") {
              setECpmIsRequiredError_playertag(true);
            }
            if (publisherName === "") {
              setPublisherIsRequiredError(true);
            }
            if (mainTableVideo_playertag.length === 0) {
              notifyfailure("At least 1 video is required")
            }

          }
        }

      }
    }

    else if (formType === "GAM") {
      const isAdmin = role === "admin" || role === "u_admin";

      // validations
      let hasError = false;
      if (zoneName_gam.trim() === "") {
        setZoneNameIsRequiredError_gam(true);
        hasError = true;
      } else if (zoneName_gam.trim().length > 90) {
        setZoneNameMaxError_gam(true);
        hasError = true;
      }
      // Sizes is mandatory: at least one option must be selected
      if (!sizesList_gam || sizesList_gam.length === 0) {
        setSizesIsRequiredError_gam(true);
        hasError = true;
      }
      if (fixedPrice_gam.toString().trim() === "") {
        setFixedPriceIsRequiredError_gam(true);
        hasError = true;
      } else if (isNaN(parseFloat(fixedPrice_gam)) || parseFloat(fixedPrice_gam) <= 0) {
        setFixedPriceValidError_gam(true);
        hasError = true;
      }
      // These fields are hidden for restricted roles, so skip their validations
      if (!isGamRestricted) {
        // Override Set UPR is mandatory when Override UPR is checked (same rules as fixed price)
        if (overrideUpr_gam) {
          if (overrideSetUpr_gam.toString().trim() === "") {
            setOverrideSetUprIsRequiredError_gam(true);
            hasError = true;
          } else if (isNaN(parseFloat(overrideSetUpr_gam)) || parseFloat(overrideSetUpr_gam) <= 0) {
            setOverrideSetUprValidError_gam(true);
            hasError = true;
          }
        }
        if (uprCategoryNotFoundError_gam) {
          // Set UPR had no matching category -> block submit, keep the "match not found" message
          hasError = true;
        } else if (uprCategory_gam === "") {
          setUprCategoryIsRequiredError_gam(true);
          hasError = true;
        }
        if (platformType_gam === "CTV" && tvAppNameCheckbox_gam && !tvApplication_gam) {
          setTvApplicationIsRequiredError_gam(true);
          hasError = true;
        }
      }
      if (!isAdmin && publisherName === "") {
        setPublisherIsRequiredError(true);
        hasError = true;
      }


      if (!hasError) {
        const isVideo = (platformType_gam === "CTV" ? "Video" : formatType_gam) === "Video";
        let payload = {
          formType: formType,
          invent_type: platformType_gam,
          // inventory_type: platformType_gam === "CTV" ? "Video" : formatType_gam,
          traffic_type: formatType_gam,
          // format_type: platformType_gam === "CTV" ? "Video" : formatType_gam,
          name: zoneName_gam,
          is_active: zoneActiveCheckbox_gam,
          sizes: {
            bannerSizes: !isVideo ? sizesList_gam : [],
            vastSizes: isVideo ? sizesList_gam : [],
            companionSizes: isVideo ? companionList_gam : [],
          },

          is_tv_app_name: isGamRestricted ? false : (platformType_gam === "CTV" ? tvAppNameCheckbox_gam : false),
          applicationId: isGamRestricted ? "" : (platformType_gam === "CTV" && tvAppNameCheckbox_gam ? tvApplication_gam : ""),
          // isTargetEcpm: isGamRestricted ? false : overrideUpr_gam,
          isTargetEcpm: false,
          fixed_cpm: fixedPrice_gam !== "" ? Number(fixedPrice_gam) : 0,
          set_upr: upr_gam !== "" ? Number(upr_gam) : 0,
          // target_ecpm: isGamRestricted
          //   ? (upr_gam !== "" ? Number(upr_gam) : 0)
          //   : (overrideUpr_gam && overrideSetUpr_gam !== "" ? Number(overrideSetUpr_gam) : upr_gam !== "" ? Number(upr_gam) : 0),
          target_ecpm: upr_gam !== "" ? Number(upr_gam) : 0,

        };

        // UPR Category is hidden for restricted roles -> don't send upr_id
        // if (!isGamRestricted) {
        payload.upr_id = uprCategory_gam;
        // }

        if (!isAdmin) {
          payload.publisherId = selectedPublisher.split("-")[0];
        }

        setButtonProcessing(true);

        let status = Cookies.get("token_xapads_ssp") ? true : false;
        if (status) {
          let token = Cookies.get("token_xapads_ssp");

          axios
            .post(configData.SERVER_URL + `gam-new/adunit`, payload, {
              headers: {
                "Content-Type": "application/json",
                "x-access-token": token,
              },
            })
            .then((response) => {
              notifysuccess(response.data.message);
              setTimeout(() => {
                window.location.reload()
                // handlePageViewChange("table");
                setButtonProcessing(false);
                resetFormView();
              }, 1500)


            })
            .catch((error) => {
              if (error?.response) {
                if (error.response.data.message?.length !== 0) {
                  notifyfailure(error.response.data.message);
                  setButtonProcessing(false);
                }
              } else {
                notifycatch();
                setButtonProcessing(false);
              }
            });
        }
      }
    }
  };


  // //////////////////////////////////////////////////Modal related States///////////////////////////////

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [activeKey, setActiveKey] = useState('1');
  const onTabChange = (key) => {
    setActiveKey(key);
  };
  const [dataModal_prebid, setDataModal_prebid] = useState({
    "hostInfo": [],
    "userSyncTag": []
  });
  const [dataModal_openrtb, setDataModal_openrtb] = useState({
    "urlTemplate": [],
    "userSyncTag": []
  });
  const [dataModal_vastzone, setDataModal_vastzone] = useState({
    "userSyncTag": []
  });

  const [dataModal_vast_aniview, setDataModal_vast_aniview] = useState({
    "userSyncTag": []
  });

  const [dataModal_publica, setDataModal_publica] = useState({
    "userSyncTag": []
  });

  const [dataModal_playertag, setDataModal_playertag] = useState({
    "userSyncTag": []
  });

  const [dataModal_gamtag, setDataModal_gamtag] = useState({
    "userSyncTag": []
  });


  const [tooltipContent, setTooltipContent] = useState("Click to copy")

  function copyToClipboard(text) {
    // Check if the Clipboard API is supported
    if (navigator.clipboard && navigator.clipboard.writeText) {
      // Use Clipboard API to copy text to clipboard
      navigator.clipboard.writeText(text)
        .then(() => {
          // console.log("Text copied to clipboard successfully: " + text);
        })
        .catch((error) => {
          // console.error("Unable to copy text to clipboard: ", error);
        });
    } else {
      // Fallback method if Clipboard API is not supported
      var tempInput = document.createElement("input");
      tempInput.setAttribute("value", text);
      document.body.appendChild(tempInput);
      tempInput.select();
      document.execCommand("copy");
      document.body.removeChild(tempInput);
      // console.log("Text copied to clipboard successfully (fallback method): " + text);
    }

    setTooltipContent("Copied");

    setTimeout(() => {
      setTooltipContent("Click to copy");
    }, 1000);

  }



  const items_prebid = [
    {
      key: '1', tab: 'User Sync Tag',
      content: (
        <>
          <div className='d-flex justify-content-between'>
            <label className='form_label'>Iframe</label>
            <Tooltip title={tooltipContent}>
              <Link ><img src={copyIcon}
                onClick={() => { copyToClipboard(Array.isArray(dataModal_prebid.userSyncTag) ? dataModal_prebid.userSyncTag.length === 2 ? dataModal_prebid.userSyncTag[0].value : "" : "") }}
                alt='Copy Icon' /></Link>
            </Tooltip>
          </div>
          <div className="select_item">
            <div className="primary text">
              {Array.isArray(dataModal_prebid.userSyncTag) ? dataModal_prebid.userSyncTag.length === 2 ? dataModal_prebid.userSyncTag[0].value : "" : ""}
            </div>
          </div>
          <div className='d-flex justify-content-between'>
            <label className='form_label'>Image</label>
            <Tooltip title={tooltipContent}>
              <Link ><img src={copyIcon}
                onClick={() => {
                  copyToClipboard(
                    Array.isArray(dataModal_prebid.userSyncTag) ? dataModal_prebid.userSyncTag.length === 2 ? dataModal_prebid.userSyncTag[1].value : "" : ""
                  )
                }
                }
                alt='Copy Icon' /></Link>
            </Tooltip>
          </div>
          <div className="select_item">
            <div className="primary text">
              {Array.isArray(dataModal_prebid.userSyncTag) ? dataModal_prebid.userSyncTag.length === 2 ? dataModal_prebid.userSyncTag[1].value : "" : ""}
            </div>
          </div>

          <div className='adding_new_parameters'>
            <div className='d-flex align-items-start justify-content-between'>
              <label className='form_label'>Parameters</label>

            </div>
          </div>
          <div className='all_parameters--text'>
            <ul className='m-0 p-0'>
              <li>
                <h4 className='parameters_heading'>SSP_REDIR_URL</h4>
                <span className='parameters_text'>Up to 128 alphanumeric and special characters is allowed: [0-9A-Za-z._-]. The zone is allowed to have up to 2,000 distinct subids per day. You will be able to view statistics for each subid.</span>
              </li>
              <li>
                <h4 className='parameters_heading'>gdpr</h4>
                <span className='parameters_text'>specifies if GDPR applies for current user (0 or 1).</span>
              </li>
              <li>
                <h4 className='parameters_heading'>gdpr_consent</h4>
                <span className='parameters_text'>URL-encoded Base64-encoded consent string as per IAB specification.</span>
              </li>
              <li>
                <h4 className='parameters_heading'>us_privacy</h4>
                <span className='parameters_text'>URL-encoded U.S. Privacy string.</span>
              </li>
            </ul>
          </div>
        </>
      )
    },
    {
      key: '2', tab: 'Prebid Details', content: (
        <>

          <div className='d-flex justify-content-between'>
            <label className='form_label'>Zone Id</label>
            <Tooltip title={tooltipContent}>
              <Link ><img src={copyIcon}
                onClick={() => {
                  copyToClipboard(
                    Array.isArray(dataModal_prebid.hostInfo) ? dataModal_prebid.hostInfo.length === 2 ? dataModal_prebid.hostInfo[0].value : "" : ""
                  )
                }
                }
                alt='Copy Icon' /></Link>
            </Tooltip>
          </div>
          <div className="select_item">
            <div className="dark text">
              {Array.isArray(dataModal_prebid.hostInfo) ? dataModal_prebid.hostInfo.length === 2 ? dataModal_prebid.hostInfo[0].value : "" : ""}
            </div>
          </div>

          <div className='d-flex justify-content-between'>
            <label className='form_label'>Host name</label>
            <Tooltip title={tooltipContent}>
              <Link ><img src={copyIcon}
                onClick={() => {
                  copyToClipboard(
                    Array.isArray(dataModal_prebid.hostInfo) ? dataModal_prebid.hostInfo.length === 2 ? dataModal_prebid.hostInfo[1].value : "" : ""
                  )
                }
                }
                alt='Copy Icon' /></Link>
            </Tooltip>
          </div>
          <div className="select_item">
            <div className="dark text">
              {Array.isArray(dataModal_prebid.hostInfo) ? dataModal_prebid.hostInfo.length === 2 ? dataModal_prebid.hostInfo[1].value : "" : ""}
            </div>
          </div>

        </>
      )
    },
  ];


  const items_openrtb = [
    {
      key: '1',
      tab: 'URL Template',
      content: (
        <>
          <div className='d-flex justify-content-between'>
            <label className='form_label'>  {Array.isArray(dataModal_openrtb?.urlTemplate) ? dataModal_openrtb?.urlTemplate.length === 4 ? dataModal_openrtb?.urlTemplate[0].label : "" : ""}</label>
            <Tooltip title={tooltipContent}>
              <Link ><img src={copyIcon}
                onClick={() => {
                  copyToClipboard(
                    Array.isArray(dataModal_openrtb?.urlTemplate) ? dataModal_openrtb?.urlTemplate.length === 4 ? dataModal_openrtb?.urlTemplate[0].value : "" : ""
                  )
                }
                }

                alt='Copy Icon' /></Link>
            </Tooltip>
          </div>
          <div className="select_item">
            <div className="primary text">
              {Array.isArray(dataModal_openrtb?.urlTemplate) ? dataModal_openrtb?.urlTemplate.length === 4 ? dataModal_openrtb?.urlTemplate[0].value : "" : ""}
            </div>
          </div>

          <div className='d-flex justify-content-between'>
            <label className='form_label'>  {Array.isArray(dataModal_openrtb?.urlTemplate) ? dataModal_openrtb?.urlTemplate.length === 4 ? dataModal_openrtb?.urlTemplate[1].label : "" : ""}</label>
            <Tooltip title={tooltipContent}>
              <Link ><img src={copyIcon}
                onClick={() => {
                  copyToClipboard(
                    Array.isArray(dataModal_openrtb?.urlTemplate) ? dataModal_openrtb?.urlTemplate.length === 4 ? dataModal_openrtb?.urlTemplate[1].value : "" : ""
                  )
                }
                }
                alt='Copy Icon' /></Link>
            </Tooltip>
          </div>
          <div className="select_item">
            <div className="primary text">
              {Array.isArray(dataModal_openrtb?.urlTemplate) ? dataModal_openrtb?.urlTemplate.length === 4 ? dataModal_openrtb?.urlTemplate[1].value : "" : ""}
            </div>
          </div>


          <div className='d-flex justify-content-between'>
            <label className='form_label'>  {Array.isArray(dataModal_openrtb?.urlTemplate) ? dataModal_openrtb?.urlTemplate.length === 4 ? dataModal_openrtb?.urlTemplate[2].label : "" : ""}</label>
            <Tooltip title={tooltipContent}>
              <Link ><img src={copyIcon}
                onClick={() => {
                  copyToClipboard(
                    Array.isArray(dataModal_openrtb?.urlTemplate) ? dataModal_openrtb?.urlTemplate.length === 4 ? dataModal_openrtb?.urlTemplate[2].value : "" : ""
                  )
                }
                }
                alt='Copy Icon' /></Link>
            </Tooltip>
          </div>
          <div className="select_item">
            <div className="primary text">
              {Array.isArray(dataModal_openrtb?.urlTemplate) ? dataModal_openrtb?.urlTemplate.length === 4 ? dataModal_openrtb?.urlTemplate[2].value : "" : ""}
            </div>
          </div>


          <div className='d-flex justify-content-between'>
            <label className='form_label'>
              {Array.isArray(dataModal_openrtb?.urlTemplate) ? dataModal_openrtb?.urlTemplate.length === 4 ? dataModal_openrtb?.urlTemplate[3].label : "" : ""}</label>
            <Tooltip title={tooltipContent}>
              <Link ><img src={copyIcon}
                onClick={() => {
                  copyToClipboard(
                    Array.isArray(dataModal_openrtb?.urlTemplate) ? dataModal_openrtb?.urlTemplate.length === 4 ? dataModal_openrtb?.urlTemplate[3].value : "" : ""
                  )
                }
                }
                alt='Copy Icon' /></Link>
            </Tooltip>
          </div>
          <div className="select_item">
            <div className="primary text">
              {Array.isArray(dataModal_openrtb?.urlTemplate) ? dataModal_openrtb?.urlTemplate.length === 4 ? dataModal_openrtb?.urlTemplate[3].value : "" : ""}
            </div>
          </div>


        </>
      )
    },
    {
      key: '2', tab: 'User Sync Tag',
      content: (
        <>
          <div className='d-flex justify-content-between'>
            <label className='form_label'>Iframe</label>
            <Tooltip title={tooltipContent}>
              <Link ><img src={copyIcon}
                onClick={() => {
                  copyToClipboard(
                    Array.isArray(dataModal_openrtb?.userSyncTag) ? dataModal_openrtb?.userSyncTag.length === 2 ? dataModal_openrtb?.userSyncTag[0].value : "" : ""
                  )
                }
                }
                alt='Copy Icon' /></Link>
            </Tooltip>
          </div>
          <div className="select_item">
            <div className="primary text">
              {Array.isArray(dataModal_openrtb?.userSyncTag) ? dataModal_openrtb?.userSyncTag.length === 2 ? dataModal_openrtb?.userSyncTag[0].value : "" : ""}
            </div>
          </div>
          <div className='d-flex justify-content-between'>
            <label className='form_label'>Image</label>
            <Tooltip title={tooltipContent}>
              <Link ><img src={copyIcon}
                onClick={() => {
                  copyToClipboard(
                    Array.isArray(dataModal_openrtb?.userSyncTag) ? dataModal_openrtb?.userSyncTag.length === 2 ? dataModal_openrtb?.userSyncTag[1].value : "" : ""
                  )
                }
                }
                alt='Copy Icon' /></Link>
            </Tooltip>
          </div>
          <div className="select_item">
            <div className="primary text">
              {Array.isArray(dataModal_openrtb?.userSyncTag) ? dataModal_openrtb?.userSyncTag.length === 2 ? dataModal_openrtb?.userSyncTag[1].value : "" : ""}
            </div>
          </div>
          <div className='adding_new_parameters'>
            <div className='d-flex align-items-start justify-content-between'>
              <label className='form_label'>Parameters</label>
              <small className='info_text--d2-orange'>*All parameters should be URL-encoded</small>
            </div>
          </div>
          <div className='all_parameters--text'>
            <ul className='m-0 p-0'>
              <li>
                <h4 className='parameters_heading'>SSP_REDIR_URL</h4>
                <span className='parameters_text'>Up to 128 alphanumeric and special characters is allowed: [0-9A-Za-z._-]. The zone is allowed to have up to 2,000 distinct subids per day. You will be able to view statistics for each subid.</span>
              </li>
              <li>
                <h4 className='parameters_heading'>gdpr</h4>
                <span className='parameters_text'>specifies if GDPR applies for current user (0 or 1).</span>
              </li>
              <li>
                <h4 className='parameters_heading'>gdpr_consent</h4>
                <span className='parameters_text'>URL-encoded Base64-encoded consent string as per IAB specification.</span>
              </li>
              <li>
                <h4 className='parameters_heading'>us_privacy</h4>
                <span className='parameters_text'>URL-encoded U.S. Privacy string.</span>
              </li>
            </ul>
          </div>
        </>
      )
    },
  ];

  const items_vastzone = [
    {
      key: '1', tab: 'URL Template',
      content: (
        <>
          <div className='d-flex justify-content-between'>
            <label className='form_label'>Vast Adkernel Tag</label>
            <Tooltip title={tooltipContent}>
              <Link ><img src={copyIcon}
                onClick={() => {
                  copyToClipboard(
                    Array.isArray(dataModal_vastzone.userSyncTag) ? dataModal_vastzone.userSyncTag.length === 1 ? dataModal_vastzone.userSyncTag[0].value : "" : ""
                  )
                }
                }
                alt='Copy Icon' /></Link>
            </Tooltip>
          </div>
          <div className="select_item">
            <div className="primary text">
              {Array.isArray(dataModal_vastzone.userSyncTag) ? dataModal_vastzone.userSyncTag.length === 1 ? dataModal_vastzone.userSyncTag[0].value : "" : ""}

            </div>
          </div>
          <div className='adding_new_parameters'>
            <div className='d-flex align-items-start justify-content-between'>
              <label className='form_label'>Parameters</label>
              <small className='info_text--d2-orange'>*All parameters should be URL-encoded</small>
            </div>
          </div>
          <div className='all_parameters--text'>
            <ul className='m-0 p-0'>
              <li>
                <h4 className='parameters_heading'>subid</h4>
                <span className='parameters_text'>Up to 128 alphanumeric and special characters is allowed: [0-9A-Za-z._-]. The zone is allowed to have up to 2,000 distinct subids per day. You will be able to view statistics for each subid.</span>
              </li>
              <li>
                <h4 className='parameters_heading'>page_url</h4>
                <span className='parameters_text'>URL of the page where ads will be displayed.</span>
              </li>
              <li>
                <h4 className='parameters_heading'>w</h4>
                <span className='parameters_text'>Video player width.</span>
              </li>
              <li>
                <h4 className='parameters_heading'>h</h4>
                <span className='parameters_text'>Video player height.</span>
              </li>
              <li>
                <h4 className='parameters_heading'>startdelay</h4>
                <span className='parameters_text'>Indicates the start delay in seconds for preroll, midroll, or postroll ad placement. If the start delay value is
                  greater than 0 then the position is mid-roll, and the value represents the number of seconds into the content that
                  the ad will be displayed. If the start delay time is not available, you can report the position of the ad in general terms
                  using negative numbers:
                  <br /> 0 - Pre-roll
                  <br /> -1 - Generic mid-roll
                  <br /> -2 - Generic Post-roll</span>
              </li>
              <li>
                <h4 className='parameters_heading'>linearity</h4>
                <span className='parameters_text'>Indicates the type of an ad impression: “linear”(default) and “overlay”.</span>
              </li>
              <li>
                <h4 className='parameters_heading'>ip</h4>
                <span className='parameters_text'>IP address of the visitor.</span>
              </li>
              <li>
                <h4 className='parameters_heading'>ua</h4>
                <span className='parameters_text'>User-Agent header from visitor's HTTP request.</span>
              </li>
            </ul>
          </div>
        </>
      )
    }
  ];

  const items_vast_aniview = [
    {
      key: '1', tab: 'URL Template',
      content: (
        <>

          <div className='d-flex justify-content-between'>
            <label className='form_label'>Vast Aniview Tag</label>
            <Tooltip title={tooltipContent}>
              <Link ><img src={copyIcon}
                onClick={() => {
                  copyToClipboard(
                    Array.isArray(dataModal_vast_aniview.userSyncTag) ? dataModal_vast_aniview.userSyncTag.length === 1 ? dataModal_vast_aniview.userSyncTag[0].value : "" : ""
                  )
                }
                }

                alt='Copy Icon' /></Link>
            </Tooltip>
          </div>
          <div className="select_item" style={{ height: "auto" }}>
            <div className="primary text">
              {Array.isArray(dataModal_vast_aniview.userSyncTag) ? dataModal_vast_aniview.userSyncTag.length === 1 ? dataModal_vast_aniview.userSyncTag[0].value : "" : ""}
            </div>
          </div>

        </>
      )
    }
  ];

  const items_publica = [
    {
      key: '1', tab: 'URL Template',
      content: (
        <>

          <div className='d-flex justify-content-between'>
            <label className='form_label'>Vast Publica Tag</label>
            <Tooltip title={tooltipContent}>
              <Link ><img src={copyIcon}
                onClick={() => {
                  copyToClipboard(
                    Array.isArray(dataModal_publica.userSyncTag) ? dataModal_publica.userSyncTag.length === 1 ? dataModal_publica.userSyncTag[0].value : "" : ""
                  )
                }
                }

                alt='Copy Icon' /></Link>
            </Tooltip>
          </div>
          <div className="select_item" style={{ height: "auto" }}>
            <div className="primary text">
              {Array.isArray(dataModal_publica.userSyncTag) ? dataModal_publica.userSyncTag.length === 1 ? dataModal_publica.userSyncTag[0].value : "" : ""}
            </div>
          </div>

        </>
      )
    }
  ];

  const items_playertag = [
    {
      key: '1', tab: 'URL Template',
      content: (
        <>

          <div className='d-flex justify-content-between'>
            <label className='form_label'>Player Tag</label>
            <Tooltip title={tooltipContent}>
              <Link ><img src={copyIcon}
                onClick={() => {
                  copyToClipboard(
                    Array.isArray(dataModal_playertag.userSyncTag) ? dataModal_playertag.userSyncTag.length === 1 ? dataModal_playertag.userSyncTag[0].value : "" : ""
                  )
                }
                }

                alt='Copy Icon' /></Link>
            </Tooltip>
          </div>
          <div className="select_item" style={{ height: "auto" }}>
            <div className="primary text">
              {Array.isArray(dataModal_playertag.userSyncTag) ? dataModal_playertag.userSyncTag.length === 1 ? dataModal_playertag.userSyncTag[0].value : "" : ""}
            </div>
          </div>

        </>
      )
    }
  ];

  const items_gamtag = [
    {
      key: '1', tab: 'URL Template',
      content: (
        <>

          <div className='d-flex justify-content-between'>
            <label className='form_label'>Vast Tag</label>
            <Tooltip title={tooltipContent}>
              <Link ><img src={copyIcon}
                onClick={() => {
                  copyToClipboard(
                    Array.isArray(dataModal_gamtag.userSyncTag) ? dataModal_gamtag.userSyncTag.length === 1 ? dataModal_gamtag.userSyncTag[0].value : "" : ""
                  )
                }
                }

                alt='Copy Icon' /></Link>
            </Tooltip>
          </div>
          <div className="select_item" style={{ height: "auto" }}>
            <div className="primary text">
              {Array.isArray(dataModal_gamtag.userSyncTag) ? dataModal_gamtag.userSyncTag.length === 1 ? dataModal_gamtag.userSyncTag[0].value : "" : ""}
            </div>
          </div>

        </>
      )
    }
  ];




  return (
    <>


      <div className="container_box--wrapper pt_header">
        {/* <div className="container_box--wrapper-intro">
          <h1 className="heading">Zone</h1>
        </div> */}
        {/* <div className="container_box--wrapper--title d_flex justify-content-between">
          <h1 className="heading">
            Zones
          </h1>

        </div> */}
        <div className="container_box--breadcrumb">
          <ul className="container_box--breadcrumb-list">
            <li>
              <Link onClick={() => {
                handlePageViewChange("table")
                resetFormView()
              }}>
                <img src={zoneIcon} alt="USP" /> Zones
              </Link>
            </li>
            <li className="primary">Create Zone</li>
          </ul>
        </div>
        <div className="container_box--wrapper--title">
          <div className="back_btn_d2">
            <img src={backButton} className="img-fluid" alt=""
              onClick={() => {
                handlePageViewChange("table")
                resetFormView()
              }}
            />
            <h1 className="heading">
              Create Zone
            </h1>
          </div>
        </div>
        <div className="container_box--content pt_20">
          <div className="container_box--width">
            {(role !== "admin" && role !== "u_admin") && (
              <Row gutter={16}>
                <Col span={8}>
                  <div className="container_box--label-info">
                    <label>Publisher</label>
                    <p className="sub_text">Choose publisher account.</p>
                  </div>
                </Col>

                <Col span={16}>
                  <div className="container_box--form-container"
                    ref={publishersRef}
                  >
                    <Row gutter={16}>
                      <Col span={24}>
                        <div className="form_content_block--group mb_0 hide_caret_after_select_value">
                          <label className="form_label">Publisher * </label>
                          <Select
                            showSearch
                            optionFilterProp="label"
                            className={
                              publisherIsRequiredError
                                ? "form_select basic error"
                                : "form_select basic "
                            }
                            // open={true}
                            value={publisherName}
                            onChange={onChangePublisher}
                            options={publisherList}
                          />
                        </div>
                        <span className="error_content">
                          {publisherIsRequiredError && (
                            <> This field is required</>
                          )}
                        </span>
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>
            )}

            <Row gutter={16}>
              <Col span={8}>
                <div className="container_box--label-info">
                  <label>Zone Type</label>
                  <p className="sub_text">Choose your zone type.</p>
                </div>
              </Col>

              <Col span={16}>
                <div className="container_box--form-container">
                  <Row gutter={16}>
                    <Col span={24}>
                      <div className="form_content_block--group mb_0">
                        <label className="form_label">Zone Type * </label>
                        <Select
                          showSearch={false}
                          optionFilterProp="label"
                          className="form_select basic no_search"
                          // open={true}
                          value={formType}
                          onChange={onChangeFormType}
                          options={formTypeOptionResolved}
                        />
                      </div>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>

            {formType === "Prebid" ? (
              <>
                <Row gutter={16}>
                  <Col span={8}>
                    <div className="container_box--label-info">
                      <label>General details</label>
                      <p className="sub_text">Please enter zone details</p>
                    </div>
                  </Col>

                  <Col span={16}>
                    <div className="container_box--form-container" >
                      <Row gutter={16}>
                        <Col span={24}>
                          <div className="form_content_block--group">
                            <label className="form_label">
                              Traffic Type *
                            </label>
                            <Radio.Group
                              onChange={onChangePlatformType_prebid}
                              value={platformType_prebid}
                              className="form_radio equal_space"
                            >
                              <Radio className="radio_btn" value="Website">
                                Website
                              </Radio>
                              <Radio className="radio_btn" value="Inapp">
                                Inapp
                              </Radio>
                            </Radio.Group>
                          </div>
                          <div className="form_content_block--group">
                            <label className="form_label">Format Type *</label>
                            {/* <Select
                              optionFilterProp="label"
                              className="form_select basic no_search"
                              value={formatType_prebid}
                              onChange={onChangeFormatType_prebid}
                              options={formatTypeOptions_prebid}
                            /> */}
                            <div className='new_cls_for_checkboxgroup_d2 --width_adjusting_css'>
                              <Checkbox.Group className="form_checkbox equal_space" value={formatType_prebid} onChange={onChangeFormatType_prebid}>
                                <Checkbox className="checkbox_btn" value="Banner">
                                  Banner
                                </Checkbox>
                                <Checkbox className="checkbox_btn" value="Video">
                                  Video
                                </Checkbox>
                                <Checkbox className="checkbox_btn" value="Native">
                                  Native
                                </Checkbox>
                              </Checkbox.Group>
                            </div>
                            <span className="error_content">{formatTypeIsRequiredError_prebid && <> Minimum 1 selection is required</>} </span>
                          </div>
                          {formatType_prebid?.includes("Banner") && (
                            <div className="form_content_block--group">
                              <label className="form_label">
                                In Banner Video Allow *
                              </label>
                              <Radio.Group
                                onChange={onChangeBannerCheckbox_prebid}
                                value={bannerCheckbox_prebid}
                                className="form_radio equal_space"
                              >
                                <Radio className="radio_btn" value={true}>
                                  Yes
                                </Radio>
                                <Radio className="radio_btn" value={false}>
                                  No
                                </Radio>
                              </Radio.Group>

                              <span className="error_content">
                                {bannerCheckboxIsRequiredError_prebid && (
                                  <> This field is required</>
                                )}
                              </span>
                            </div>
                          )}
                          <div className="hr_custom my_24"></div>
                          <div className="form_content_block--group">
                            <label className="form_label">Zone Name *</label>
                            <Input
                              className={
                                zoneNameIsRequiredError_prebid || nameExists.prebid
                                  ? "form_control basic error"
                                  : "form_control basic"
                              }
                              value={zoneName_prebid}
                              onBlur={onBlurZoneName_prebid}
                              onChange={onChangeZoneName_prebid}
                              autocomplete="off"
                              suffix={nameChecking.prebid ? <img src={loaderIcon} alt="" style={{ width: 16, height: 16 }} /> : <span />}
                            />
                            <span className="error_content">
                              {zoneNameIsRequiredError_prebid && (
                                <> This field is required</>
                              )}
                              {nameExists.prebid && (
                                <> Zone name already exists</>
                              )}
                            </span>
                          </div>
                          <div className="form_content_block--group">
                            <div className="primary_checkbox">
                              <Checkbox
                                id="zone_checkbox_prebid"
                                name="zone_checkbox_prebid"
                                checked={zoneActiveCheckbox_prebid}
                                onChange={onChangeZoneActiveCheckbox_prebid}
                              >
                                <span className="form_label">
                                  Is Zone Active?
                                </span>
                              </Checkbox>
                            </div>
                          </div>
                          <div className={(role === "admin" || role === "u_admin") ? "form_content_block--group mb_0" : "form_content_block--group "}>
                            <label className="form_label">
                              Integration Type *
                            </label>
                            {/* <Select
                              optionFilterProp="label"
                              className="form_select basic no_search"
                              value={integrationType_prebid}
                              onChange={onChangeIntegrationType_prebid}
                              options={integrationTypeOptions_prebid}
                            /> */}

                            <Input
                              className="form_control basic"
                              value="OpenRTB (Both ADM and nURL)"
                              disabled
                              autocomplete="off"
                            />
                          </div>

                          {(role !== "admin" && role !== "u_admin") &&

                            <Col span={12} style={{ paddingLeft: "0px" }}>
                              <div className="form_content_block--group mb-0">
                                <label className='form_label'>Rev Share *</label>
                                <Input
                                  placeholder='Enter Revshare'
                                  className={
                                    (revSharePercentIsRequiredError_prebid || revSharePercentValidError_prebid)
                                      ? "form_control basic error form_control_with_icon_d2"
                                      : "form_control basic form_control_with_icon_d2"
                                  }
                                  value={revSharePercent_prebid}
                                  onChange={onChangeRevSharePercent_prebid}
                                  onBlur={onBlurRevSharePercent_prebid}
                                  autocomplete="off"
                                  suffix={'%'}
                                />
                                <span className="error_content">
                                  {revSharePercentIsRequiredError_prebid && (
                                    <> This field is required</>
                                  )}

                                  {revSharePercentValidError_prebid && (
                                    <> Value must be between 0.1 and 100</>
                                  )}
                                </span>
                              </div>

                            </Col>
                          }

                        </Col>
                      </Row>
                    </div>
                  </Col>
                </Row>

                <Row gutter={16}>
                  <Col span={8}>
                    <div className="container_box--label-info">
                      <label>Please select all sensitive categories you would like us to block on your supply.</label>
                    </div>
                  </Col>
                  <Col span={16}>
                    <div className="container_box--form-container">
                      <Row gutter={16}>
                        <Col span={24}>
                          <div className="form_content_block--group mb-0">
                            <BlockCategoryTable
                              selected={blockCategorySelected}
                              setSelected={setBlockCategorySelected}
                              normalizeKey={blockCategoryNormalizeKey}
                            />
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </Col>
                </Row>
                {(role !== "admin" && role !== "u_admin") && (
                  <Row gutter={16}>
                    <Col span={8}>
                      <div className="container_box--label-info">
                        <label>Limits</label>
                        <p className="sub_text">Enter your zone limits</p>
                      </div>
                    </Col>

                    <Col span={16}>
                      <div className="container_box--form-container ">

                        <Row gutter={16} >
                          <Col span={12}>
                            <div className="form_content_block--group">
                              <label className="form_label">Min eCPM </label>
                              <Input
                                className={minCpmValueError_prebid ? 'form_control basic  prefix_sign error' : 'form_control basic prefix_sign'}
                                placeholder='Min' autocomplete="off"
                                value={minCpm_prebid}
                                onChange={onChangeMinCpm_prebid}
                                prefix={'$'}
                              />
                              <span className="error_content">

                                {minCpmValueError_prebid && (
                                  <>
                                    Value must be between 0.00001 and 50
                                  </>
                                )}
                              </span>
                            </div>

                            {/* <small className='line_between_cols_d2'>-</small> */}
                          </Col>
                          <Col span={12}>
                            <div className="form_content_block--group ">
                              <label className="form_label ">Max eCPM </label>
                              <Input
                                className={maxCpmValueError_prebid ? 'form_control basic prefix_sign error' : 'form_control basic prefix_sign'}
                                placeholder='Max' autocomplete="off"
                                value={maxCpm_prebid}
                                onChange={onChangeMaxCpm_prebid}
                                prefix={'$'}
                              />
                              <span className="error_content">

                                {maxCpmValueError_prebid && (
                                  <>
                                    Value must be between 0.00001 and 50
                                    <br />
                                  </>
                                )}
                              </span>
                            </div>
                          </Col>
                        </Row>



                        <div className="form_content_block--group">
                          <div className="primary_checkbox">
                            {minCpm_prebid === "" ?
                              <Checkbox
                                id="highestBidFloor_checkbox_prebid"
                                name="highestBidFloor_checkbox_prebid"
                                checked={false}
                                disabled
                              >
                                <span className="form_label">
                                  Use the highest bid floor
                                </span>
                              </Checkbox>
                              :
                              <Checkbox
                                id="highestBidFloor_checkbox_prebid"
                                name="highestBidFloor_checkbox_prebid"
                                checked={highestBidFloorCheckbox_prebid}
                                onChange={onChangeHighestBidFloorCheckbox_prebid}
                              >
                                <span className="form_label">
                                  Use the highest bid floor
                                </span>
                              </Checkbox>
                            }
                          </div>
                        </div>

                        <Row gutter={16}>
                          <Col span={12}>
                            <div className="form_content_block--group mb_0">
                              <label className="form_label">
                                Requests per Day
                              </label>
                              <Input
                                className={
                                  requestValueError_prebid
                                    ? "form_control basic error"
                                    : "form_control basic"
                                }
                                value={request_prebid}
                                onBlur={onBlurRequest_prebid}
                                onChange={onChangeRequest_prebid}
                                autocomplete="off"
                              />
                            </div>
                            <span className="error_content">
                              {/* {requestIsRequiredError_prebid && (
              <> This field is required</>
            )} */}
                              {requestValueError_prebid && (
                                <> Value should be greater than 0</>
                              )}
                            </span>
                          </Col>
                          <Col span={12}>
                            <div className="form_content_block--group mb_0">
                              <label className="form_label">
                                Impressions per Day
                              </label>
                              <Input
                                className={
                                  impressionValueError_prebid
                                    ? "form_control basic error"
                                    : "form_control basic"
                                }
                                value={impression_prebid}
                                onBlur={onBlurImpression_prebid}
                                onChange={onChangeImpression_prebid}
                                autocomplete="off"
                              />
                              <span className="error_content">
                                {/* {impressionIsRequiredError_prebid && (
              <> This field is required</>
            )} */}
                                {impressionValueError_prebid && (
                                  <> Value should be greater than 0</>
                                )}
                              </span>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </Col>
                  </Row>
                )}


                {(role !== "admin" && role !== "u_admin") &&
                  <Row gutter={16}>
                    <Col span={8}>
                      <div className="container_box--label-info">
                        <label>Inventory Partner Domain Override</label>
                      </div>
                    </Col>
                    <Col span={16}>
                      <div className="container_box--form-container  ">
                        <Row gutter={16}>
                          <Col span={24}>
                            <div className="form_content_block--group">
                              <div className="primary_checkbox">
                                <Checkbox
                                  checked={isAddValueCheckbox_prebid}
                                  onChange={onChangeIsAddValueCheckbox_prebid}
                                >
                                  <span className="form_label">
                                    Pass Inventory Partner Domain
                                  </span>
                                </Checkbox>
                              </div>
                            </div>
                            <div className="form_content_block--group mb_0">
                              <label className="form_label">Inventory Partner Domain  </label>
                              <Input
                                className="form_control basic"
                                value={override_prebid}
                                onBlur={onBlurOverride_prebid}
                                onChange={onChangeOverride_prebid}
                                placeholder="Enter Inventory Partner Domain"
                                autocomplete="off"
                              />
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </Col>
                  </Row>
                }


                <Row gutter={16}>
                  <Col span={8}>
                    <div className="container_box--label-info">
                      <label>IVT Sampling</label>
                      <p className="sub_text">Set the sampling percentage</p>
                    </div>
                  </Col>

                  <Col span={16}>
                    <div className="container_box--form-container mb_0">
                      <Row gutter={16}>
                        <Col span={24}>
                          <div className="alert_yellow_div">
                            <span>Changing the percentage impacts the cost, change it as per best practice.</span>
                          </div>
                        </Col>
                        <Col span={12}>
                          <div className="form_content_block--group ">
                            <label className="form_label">Human *</label>
                            <Input
                              className={humanValidError_prebid ? 'form_control basic form_control_with_icon_d2 error' : 'form_control basic form_control_with_icon_d2'}
                              placeholder='0'
                              autocomplete="off"
                              value={human_prebid}
                              onChange={onChangeHuman_prebid}
                              disabled={(role === "admin" || role === "u_admin")}
                              onBlur={onBlurHuman_prebid}
                              suffix={'%'}
                            />
                            <span className="error_content">
                              {humanValidError_prebid && <>Value must be an integer between 0 and 100</>}
                            </span>
                          </div>
                        </Col>
                      </Row>
                      {/* PIXALATE SUNSET: Pixalate IVT sampling field hidden (not sent in payload).
                      <Row gutter={16}>
                        <Col span={12}>
                          <div className="form_content_block--group">
                            <label className="form_label">Pixalate *</label>
                            <Input
                              className={pixalateValidError_prebid ? 'form_control basic form_control_with_icon_d2 error' : 'form_control basic form_control_with_icon_d2'}
                              placeholder='0'
                              autocomplete="off"
                              value={pixalate_prebid}
                              onChange={onChangePixalate_prebid}
                              disabled={(role === "admin" || role === "u_admin")}
                              onBlur={onBlurPixalate_prebid}
                              suffix={'%'}
                            />
                            <span className="error_content">
                              {pixalateValidError_prebid && <>Value must be an integer between 0 and 100</>}
                            </span>
                          </div>
                        </Col>
                      </Row>
                      */}
                      <Row gutter={16}>
                        <Col span={12}>
                          <div className="form_content_block--group mb_0">
                            <label className="form_label">DoubleVerify *</label>
                            <Input
                              className={doubleverifyValidError_prebid ? 'form_control basic form_control_with_icon_d2 error' : 'form_control basic form_control_with_icon_d2'}
                              placeholder='0'
                              autocomplete="off"
                              value={doubleverify_prebid}
                              onChange={onChangeDoubleverify_prebid}
                              disabled={(role === "admin" || role === "u_admin")}
                              onBlur={onBlurDoubleverify_prebid}
                              suffix={'%'}
                            />
                            <span className="error_content">
                              {doubleverifyValidError_prebid && <>Value must be an integer between 0 and 100</>}
                            </span>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </Col>
                </Row>
              </>
            ) : formType === "Open RTB" ? (
              <>
                <Row gutter={16}>
                  <Col span={8}>
                    <div className="container_box--label-info">
                      <label>General details</label>
                      <p className="sub_text">Please enter zone details</p>
                    </div>
                  </Col>

                  <Col span={16}>
                    <div className="container_box--form-container" >
                      <Row gutter={16}>
                        <Col span={24}>
                          <div className="form_content_block--group">
                            <label className="form_label">
                              Traffic Type *
                            </label>
                            <Radio.Group
                              onChange={onChangePlatformType_openrtb}
                              value={platformType_openrtb}
                              className="form_radio equal_space"
                            >
                              <Radio className="radio_btn" value="Website">
                                Website
                              </Radio>
                              <Radio className="radio_btn" value="Inapp">
                                Inapp
                              </Radio>
                              <Radio className="radio_btn" value="CTV">
                                CTV
                              </Radio>
                            </Radio.Group>
                          </div>
                          <div className="form_content_block--group">
                            <label className="form_label">Format Type *</label>
                            {platformType_openrtb === "CTV" ?
                              // <Input
                              //   className="form_control basic"
                              //   value="Video"
                              //   autocomplete="off"
                              //   disabled
                              // />
                              <div className='new_cls_for_checkboxgroup_d2 --width_adjusting_css'>
                                <Checkbox.Group className="form_checkbox equal_space" value={["Video"]} disabled>
                                  <Checkbox className="checkbox_btn" value="Banner">
                                    Banner
                                  </Checkbox>
                                  <Checkbox className="checkbox_btn" value="Video">
                                    Video
                                  </Checkbox>
                                  <Checkbox className="checkbox_btn" value="Native">
                                    Native
                                  </Checkbox>
                                </Checkbox.Group>
                              </div>
                              :
                              <>
                                <div className='new_cls_for_checkboxgroup_d2 --width_adjusting_css'>
                                  <Checkbox.Group className="form_checkbox equal_space" value={formatType_openrtb} onChange={onChangeFormatType_openrtb}>
                                    <Checkbox className="checkbox_btn" value="Banner">
                                      Banner
                                    </Checkbox>
                                    <Checkbox className="checkbox_btn" value="Video">
                                      Video
                                    </Checkbox>
                                    <Checkbox className="checkbox_btn" value="Native">
                                      Native
                                    </Checkbox>
                                  </Checkbox.Group>
                                </div>
                                <span className="error_content">{formatTypeIsRequiredError_openrtb && <> Minimum 1 selection is required</>} </span>
                              </>
                            }

                          </div>
                          {formatType_openrtb?.includes("Banner") && platformType_openrtb !== "CTV" && (
                            <div className="form_content_block--group">
                              <label className="form_label">
                                In Banner Video Allow *
                              </label>
                              <Radio.Group
                                onChange={onChangeBannerCheckbox_openrtb}
                                value={bannerCheckbox_openrtb}
                                className="form_radio equal_space"
                              >
                                <Radio className="radio_btn" value={true}>
                                  Yes
                                </Radio>
                                <Radio className="radio_btn" value={false}>
                                  No
                                </Radio>
                              </Radio.Group>

                              <span className="error_content">
                                {bannerCheckboxIsRequiredError_openrtb && (
                                  <> This field is required</>
                                )}
                              </span>
                            </div>
                          )}
                          <div className="hr_custom my_24"></div>
                          <div className="form_content_block--group">
                            <label className="form_label">Zone Name *</label>
                            <Input
                              className={
                                zoneNameIsRequiredError_openrtb || nameExists.openrtb
                                  ? "form_control basic error"
                                  : "form_control basic"
                              }
                              value={zoneName_openrtb}
                              onBlur={onBlurZoneName_openrtb}
                              onChange={onChangeZoneName_openrtb}
                              autocomplete="off"
                              suffix={nameChecking.openrtb ? <img src={loaderIcon} alt="" style={{ width: 16, height: 16 }} /> : <span />}
                            />
                            <span className="error_content">
                              {zoneNameIsRequiredError_openrtb && (
                                <> This field is required</>
                              )}
                              {nameExists.openrtb && (
                                <> Zone name already exists</>
                              )}
                            </span>
                          </div>
                          <div className="form_content_block--group">
                            <div className="primary_checkbox">
                              <Checkbox
                                id="zone_checkbox_openrtb"
                                name="zone_checkbox_openrtb"
                                checked={zoneActiveCheckbox_openrtb}
                                onChange={onChangeZoneActiveCheckbox_openrtb}
                              >
                                <span className="form_label">
                                  Is Zone Active?
                                </span>
                              </Checkbox>
                            </div>
                          </div>
                          <div className={(role === "admin" || role === "u_admin") ? "form_content_block--group mb_0" : "form_content_block--group "}>
                            <label className="form_label">
                              Integration Type *
                            </label>
                            <Select
                              optionFilterProp="label"
                              className="form_select basic no_search"
                              value={integrationType_openrtb}
                              onChange={onChangeIntegrationType_openrtb}
                              options={integrationTypeOptions_openrtb}
                            />
                          </div>


                          {
                            (role !== "admin" && role !== "u_admin") &&

                            <Col span={12} style={{ paddingLeft: "0px" }}>
                              <div className="form_content_block--group mb-0">
                                <label className='form_label'>Rev Share *</label>
                                <Input
                                  placeholder='Enter Revshare'
                                  className={
                                    (revSharePercentIsRequiredError_openrtb || revSharePercentValidError_openrtb)
                                      ? "form_control basic error form_control_with_icon_d2"
                                      : "form_control basic form_control_with_icon_d2"
                                  }
                                  value={revSharePercent_openrtb}
                                  onChange={onChangeRevSharePercent_openrtb}
                                  onBlur={onBlurRevSharePercent_openrtb}
                                  autocomplete="off"
                                  suffix={'%'}
                                />
                                <span className="error_content">
                                  {revSharePercentIsRequiredError_openrtb && (
                                    <> This field is required</>
                                  )}

                                  {revSharePercentValidError_openrtb && (
                                    <> Value must be between 0.1 and 100</>
                                  )}
                                </span>
                              </div>
                            </Col>

                          }

                        </Col>
                      </Row>
                    </div>
                  </Col>
                </Row>

                <Row gutter={16}>
                  <Col span={8}>
                    <div className="container_box--label-info">
                      <label>Please select all sensitive categories you would like us to block on your supply.</label>
                    </div>
                  </Col>
                  <Col span={16}>
                    <div className="container_box--form-container">
                      <Row gutter={16}>
                        <Col span={24}>
                          <div className="form_content_block--group mb-0">
                            <BlockCategoryTable
                              selected={blockCategorySelected}
                              setSelected={setBlockCategorySelected}
                              normalizeKey={blockCategoryNormalizeKey}
                            />
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </Col>
                </Row>
                {(role !== "admin" && role !== "u_admin") && (
                  <Row gutter={16}>
                    <Col span={8}>
                      <div className="container_box--label-info">
                        <label>Limits</label>
                        <p className="sub_text">Enter your zone limits</p>
                      </div>
                    </Col>



                    <Col span={16}>
                      <div className="container_box--form-container ">


                        <Row gutter={16}
                        //  className='position-relative'
                        >
                          <Col span={12}>
                            <div className="form_content_block--group">
                              <label className="form_label">Min eCPM </label>
                              <Input
                                className={minCpmValueError_openrtb ? 'form_control basic  prefix_sign error' : 'form_control basic prefix_sign'}
                                placeholder='Min' autocomplete="off"
                                value={minCpm_openrtb}
                                onChange={onChangeMinCpm_openrtb}
                                prefix={'$'}
                              />
                              <span className="error_content">

                                {minCpmValueError_openrtb && (
                                  <>
                                    Value must be between 0.00001 and 50
                                  </>
                                )}
                              </span>
                            </div>

                            {/* <small className='line_between_cols_d2'>-</small> */}
                          </Col>
                          <Col span={12}>
                            <div className="form_content_block--group ">
                              <label className="form_label ">Max eCPM </label>
                              <Input
                                className={maxCpmValueError_openrtb ? 'form_control basic prefix_sign error' : 'form_control basic prefix_sign'}
                                placeholder='Max' autocomplete="off"
                                value={maxCpm_openrtb}
                                onChange={onChangeMaxCpm_openrtb}
                                prefix={'$'}
                              />
                              <span className="error_content">

                                {maxCpmValueError_openrtb && (
                                  <>
                                    Value must be between 0.00001 and 50
                                    <br />
                                  </>
                                )}
                              </span>
                            </div>
                          </Col>
                        </Row>

                        <div className="form_content_block--group">
                          <div className="primary_checkbox">
                            {minCpm_openrtb === "" ?
                              <Checkbox
                                id="highestBidFloor_checkbox_openrtb"
                                name="highestBidFloor_checkbox_openrtb"
                                checked={false}
                                disabled
                              >
                                <span className="form_label">
                                  Use the highest bid floor
                                </span>
                              </Checkbox>
                              :
                              <Checkbox
                                id="highestBidFloor_checkbox_openrtb"
                                name="highestBidFloor_checkbox_openrtb"
                                checked={highestBidFloorCheckbox_openrtb}
                                onChange={onChangeHighestBidFloorCheckbox_openrtb}
                              >
                                <span className="form_label">
                                  Use the highest bid floor
                                </span>
                              </Checkbox>
                            }
                          </div>
                        </div>

                        <Row gutter={16}>
                          <Col span={12}>
                            <div className="form_content_block--group mb_0">
                              <label className="form_label">
                                Requests per Day
                              </label>
                              <Input
                                className={
                                  requestValueError_openrtb
                                    ? "form_control basic error"
                                    : "form_control basic"
                                }
                                value={request_openrtb}
                                onBlur={onBlurRequest_openrtb}
                                onChange={onChangeRequest_openrtb}
                                autocomplete="off"
                              />
                            </div>
                            <span className="error_content">
                              {/* {requestIsRequiredError_openrtb && (
              <> This field is required</>
              )} */}
                              {requestValueError_openrtb && (
                                <> Value should be greater than 0</>
                              )}
                            </span>
                          </Col>
                          <Col span={12}>
                            <div className="form_content_block--group mb_0">
                              <label className="form_label">
                                Impressions per Day
                              </label>
                              <Input
                                className={
                                  impressionValueError_openrtb
                                    ? "form_control basic error"
                                    : "form_control basic"
                                }
                                value={impression_openrtb}
                                onBlur={onBlurImpression_openrtb}
                                onChange={onChangeImpression_openrtb}
                                autocomplete="off"
                              />
                              <span className="error_content">
                                {/* {impressionIsRequiredError_openrtb && (
              <> This field is required</>
              )} */}
                                {impressionValueError_openrtb && (
                                  <> Value should be greater than 0</>
                                )}
                              </span>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </Col>
                  </Row>
                )}


                {(role !== "admin" && role !== "u_admin") &&
                  <Row gutter={16}>
                    <Col span={8}>
                      <div className="container_box--label-info">
                        <label>Inventory Partner Domain Override</label>
                      </div>
                    </Col>
                    <Col span={16}>
                      <div className="container_box--form-container  ">
                        <Row gutter={16}>
                          <Col span={24}>
                            <div className="form_content_block--group">
                              <div className="primary_checkbox">
                                <Checkbox
                                  checked={isAddValueCheckbox_openrtb}
                                  onChange={onChangeIsAddValueCheckbox_openrtb}
                                >
                                  <span className="form_label">
                                    Pass Inventory Partner Domain
                                  </span>
                                </Checkbox>
                              </div>
                            </div>
                            <div className="form_content_block--group mb_0">
                              <label className="form_label">Inventory Partner Domain  </label>
                              <Input
                                className="form_control basic"
                                value={override_openrtb}
                                onBlur={onBlurOverride_openrtb}
                                onChange={onChangeOverride_openrtb}
                                placeholder="Enter Inventory Partner Domain"
                                autocomplete="off"
                              />
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </Col>
                  </Row>
                }


                <Row gutter={16}>
                  <Col span={8}>
                    <div className="container_box--label-info">
                      <label>IVT Sampling</label>
                      <p className="sub_text">Set the sampling percentage</p>
                    </div>
                  </Col>
                  <Col span={16}>
                    <div className="container_box--form-container mb_0">
                      <Row gutter={16}>
                        <Col span={24}>
                          <div className="alert_yellow_div">
                            <span>Changing the percentage impacts the cost, change it as per best practice.</span>
                          </div>
                        </Col>
                        <Col span={12}>
                          <div className="form_content_block--group ">
                            <label className="form_label">Human *</label>
                            <Input
                              className={humanValidError_openrtb ? 'form_control basic form_control_with_icon_d2 error' : 'form_control basic form_control_with_icon_d2'}
                              placeholder='0'
                              autocomplete="off"
                              value={human_openrtb}
                              disabled={(role === "admin" || role === "u_admin")}
                              onChange={onChangeHuman_openrtb}
                              onBlur={onBlurHuman_openrtb}
                              suffix={'%'}
                            />
                            <span className="error_content">
                              {humanValidError_openrtb && <>Value must be an integer between 0 and 100</>}
                            </span>
                          </div>
                        </Col>
                      </Row>
                      {/* PIXALATE SUNSET: Pixalate IVT sampling field hidden (not sent in payload).
                      <Row gutter={16}>
                        <Col span={12}>
                          <div className="form_content_block--group">
                            <label className="form_label">Pixalate *</label>
                            <Input
                              className={pixalateValidError_openrtb ? 'form_control basic form_control_with_icon_d2 error' : 'form_control basic form_control_with_icon_d2'}
                              placeholder='0'
                              autocomplete="off"
                              value={pixalate_openrtb}
                              disabled={(role === "admin" || role === "u_admin")}
                              onChange={onChangePixalate_openrtb}
                              onBlur={onBlurPixalate_openrtb}
                              suffix={'%'}
                            />
                            <span className="error_content">
                              {pixalateValidError_openrtb && <>Value must be an integer between 0 and 100</>}
                            </span>
                          </div>
                        </Col>
                      </Row>
                      */}
                      <Row gutter={16}>
                        <Col span={12}>
                          <div className="form_content_block--group mb_0">
                            <label className="form_label">DoubleVerify *</label>
                            <Input
                              className={doubleverifyValidError_openrtb ? 'form_control basic form_control_with_icon_d2 error' : 'form_control basic form_control_with_icon_d2'}
                              placeholder='0'
                              autocomplete="off"
                              value={doubleverify_openrtb}
                              disabled={(role === "admin" || role === "u_admin")}
                              onChange={onChangeDoubleverify_openrtb}
                              onBlur={onBlurDoubleverify_openrtb}
                              suffix={'%'}
                            />
                            <span className="error_content">
                              {doubleverifyValidError_openrtb && <>Value must be an integer between 0 and 100</>}
                            </span>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </Col>
                </Row>
              </>
            ) :
              formType === "publica" ?
                (<>
                  <Row gutter={16}>
                    <Col span={8}>
                      <div className="container_box--label-info">
                        <label>General details</label>
                        <p className="sub_text">Please enter zone details</p>
                      </div>
                    </Col>

                    <Col span={16}>
                      <div
                        className="container_box--form-container "
                      >
                        <Row gutter={16}>
                          <Col span={24}>
                            <div className="form_content_block--group">
                              <label className="form_label">
                                Traffic Type *
                              </label>
                              <Radio.Group
                                onChange={onChangePlatformType_publica}
                                value={platformType_publica}
                                className="form_radio equal_space"
                              >
                                <Radio className="radio_btn" value="Website">
                                  Website
                                </Radio>
                                <Radio className="radio_btn" value="Inapp">
                                  Inapp
                                </Radio>
                                <Radio className="radio_btn" value="CTV">
                                  CTV
                                </Radio>
                              </Radio.Group>
                            </div>

                            <div className={(role === "admin" || role === "u_admin") ? "form_content_block--group mb_0" : "form_content_block--group"}>
                              <label className="form_label">Format Type *</label>
                              <div className='new_cls_for_checkboxgroup_d2 --width_adjusting_css'>
                                <Checkbox.Group className="form_checkbox equal_space" value={["Video"]} disabled>
                                  <Checkbox className="checkbox_btn" value="Banner">
                                    Banner
                                  </Checkbox>
                                  <Checkbox className="checkbox_btn" value="Video">
                                    Video
                                  </Checkbox>
                                  <Checkbox className="checkbox_btn" value="Native">
                                    Native
                                  </Checkbox>
                                </Checkbox.Group>
                              </div>
                            </div>

                            {(role !== "admin" && role !== "u_admin") &&
                              <div className="form_content_block--group mb_0">
                                <label className="form_label">
                                  Header Bidder Vast Version
                                </label>
                                <Select
                                  optionFilterProp="label"
                                  className="form_select basic no_search"
                                  value={vastVersion_publica}
                                  onChange={onChangeVastVersion_publica}
                                  options={vastVersionOptions_publica}
                                />


                              </div>
                            }

                          </Col>
                        </Row>
                      </div>
                    </Col>
                  </Row>

                  <Row gutter={16}>
                    <Col span={8}>
                      <div className="container_box--label-info">
                        <label>Channel details</label>
                        {/* <p className="sub_text">Please enter zone details</p> */}
                      </div>
                    </Col>

                    <Col span={16}>
                      <div
                        className="container_box--form-container "
                        ref={channelDetailsRef}
                      >
                        <Row gutter={16}>
                          <Col span={24}>

                            <div className="form_content_block--group">
                              <label className="form_label">Channel Name *</label>
                              <Input
                                // className="form_control basic"
                                className={
                                  channelNameIsRequiredError_publica || nameExists.publica
                                    ? "form_control basic error"
                                    : "form_control basic"
                                }
                                value={channelName_publica}
                                onBlur={onBlurChannelName_publica}
                                onChange={onChangeChannelName_publica}
                                autocomplete="off"
                                suffix={nameChecking.publica ? <img src={loaderIcon} alt="" style={{ width: 16, height: 16 }} /> : <span />}
                              />
                              <span className="error_content">
                                {channelNameIsRequiredError_publica && (
                                  <> This field is required</>
                                )}
                                {nameExists.publica && (
                                  <> Channel name already exists</>
                                )}
                              </span>
                            </div>




                            <div className="form_content_block--group">
                              <label className="form_label">
                                Region *
                              </label>
                              <Select
                                optionFilterProp="label"
                                className={regionIsRequiredError_publica ? "form_select basic no_search error" : "form_select basic no_search"}
                                value={region_publica}
                                onChange={onChangeRegion_publica}
                                options={regionOptions_publica}
                              />
                              <span className="error_content">
                                {regionIsRequiredError_publica && (
                                  <> This field is required</>
                                )}
                              </span>
                            </div>


                            <Row gutter={16}>
                              <Col span={12}>
                                <div className={(role === "admin" || role === "u_admin") ? "form_content_block--group mb_0" : "form_content_block--group"}>
                                  <label className='form_label'>eCPM *</label>
                                  <Input
                                    placeholder='Enter eCpm'
                                    className={
                                      eCpmIsRequiredError_publica || eCpmValidError_publica
                                        ? "form_control basic error"
                                        : "form_control basic"
                                    }
                                    value={eCpm_publica}
                                    onBlur={onBlurECpm_publica}
                                    onChange={onChangeECpm_publica}
                                    autocomplete="off"
                                  />
                                  <span className="error_content">
                                    {eCpmIsRequiredError_publica && (
                                      <> This field is required</>
                                    )}
                                    {eCpmValidError_publica && (
                                      <> Value should be greater than or equal to 0</>
                                    )}
                                  </span>
                                </div>
                              </Col>
                            </Row>

                            {(role !== "admin" && role !== "u_admin") &&
                              <Row gutter={16} >
                                <Col span={12}>
                                  <div className="form_content_block--group mb_0">
                                    <label className="form_label">Bid Adjustment * </label>
                                    <Input
                                      className={(bidAdjustmentIsRequiredError_publica || bidAdjustmentValidError_publica) ? 'form_control basic form_control_with_icon_d2  error' : 'form_control basic form_control_with_icon_d2 '}
                                      placeholder='0' autocomplete="off"
                                      value={bidAdjustment_publica}
                                      onChange={onChangeBidAdjustment_publica}
                                      onBlur={onBlurBidAdjustment_publica}
                                      suffix={'%'}
                                    />
                                    <span className="error_content">
                                      {bidAdjustmentIsRequiredError_publica && (
                                        <>
                                          This field is required
                                        </>
                                      )}
                                      {bidAdjustmentValidError_publica && (
                                        <>
                                          Value must be between 0 - 100
                                        </>
                                      )}
                                    </span>
                                  </div>
                                </Col>
                                <Col span={12}>
                                  <div className="form_content_block--group mb_0">
                                    <label className="form_label ">Bid Adjustment Value  </label>
                                    <Input
                                      className={bidValueValidError_publica ? 'form_control basic prefix_sign error' : 'form_control basic prefix_sign'}
                                      placeholder='0' autocomplete="off"
                                      value={bidValue_publica}
                                      onChange={onChangeBidValue_publica}
                                      onBlur={onBlurBidValue_publica}
                                      prefix={'$'}
                                    />
                                    <span className="error_content">

                                      {bidValueValidError_publica && (
                                        <> Value should be greater than or equal to 0</>
                                      )}
                                    </span>
                                  </div>
                                </Col>
                              </Row>

                            }

                          </Col>
                        </Row>
                      </div>
                    </Col>
                  </Row>


                  {(role !== "admin" && role !== "u_admin") &&

                    <Row gutter={16}>
                      <Col span={8}>
                        <div className="container_box--label-info">
                          <label>Supply Chain</label>
                          {/* <p className="sub_text">Please enter zone details</p> */}
                        </div>
                      </Col>

                      <Col span={16}>
                        <div
                          className="container_box--form-container"
                          ref={supplyDetailsRef}
                        >
                          <Row gutter={16}>
                            <Col span={24}>

                              <div className="form_content_block--group">
                                <label className="form_label">ASI *</label>
                                <Input

                                  className={
                                    asiIsRequiredError_publica
                                      ? "form_control basic error"
                                      : "form_control basic"
                                  }
                                  value={asi_publica}
                                  onBlur={onBlurAsi_publica}
                                  onChange={onChangeAsi_publica}
                                  autocomplete="off"
                                />
                                <span className="error_content">
                                  {asiIsRequiredError_publica && (
                                    <> This field is required</>
                                  )}
                                </span>
                              </div>

                              <div className="form_content_block--group">
                                <label className="form_label">SID *</label>
                                <Input

                                  className={
                                    sidIsRequiredError_publica
                                      ? "form_control basic error"
                                      : "form_control basic"
                                  }
                                  value={sid_publica}
                                  onBlur={onBlurSid_publica}
                                  onChange={onChangeSid_publica}
                                  autocomplete="off"
                                />
                                <span className="error_content">
                                  {sidIsRequiredError_publica && (
                                    <> This field is required</>
                                  )}
                                </span>
                              </div>

                              <div className="form_content_block--group">
                                <label className="form_label">Name *</label>
                                <Input
                                  className={
                                    nameIsRequiredError_publica
                                      ? "form_control basic error"
                                      : "form_control basic"
                                  }
                                  value={name_publica}
                                  onBlur={onBlurName_publica}
                                  onChange={onChangeName_publica}
                                  autocomplete="off"
                                />
                                <span className="error_content">
                                  {nameIsRequiredError_publica && (
                                    <> This field is required</>
                                  )}
                                </span>
                              </div>

                              <div className="form_content_block--group mb_0">
                                <label className="form_label">Domain *</label>
                                <Input
                                  className={
                                    domainIsRequiredError_publica
                                      ? "form_control basic error"
                                      : "form_control basic"
                                  }
                                  value={domain_publica}
                                  onBlur={onBlurDomain_publica}
                                  onChange={onChangeDomain_publica}
                                  autocomplete="off"
                                />
                                <span className="error_content">
                                  {domainIsRequiredError_publica && (
                                    <> This field is required</>
                                  )}
                                </span>
                              </div>


                            </Col>
                          </Row>
                        </div>
                      </Col>
                    </Row>
                  }

                  <Row gutter={16}>
                    <Col span={8}>
                      <div className="container_box--label-info">
                        <label>Endpoint</label>
                        {/* <p className="sub_text">Please enter zone details</p> */}
                      </div>
                    </Col>

                    <Col span={16}>
                      <div
                        className={(role === "admin" || role === "u_admin") ? "container_box--form-container mb_0" : "container_box--form-container "}
                      >
                        <Row gutter={16}>
                          <Col span={24}>


                            <div className="form_content_block--group  "
                              style={{ marginBottom: "10px" }}
                            >
                              <label className="form_label">
                                Template *
                              </label>

                              <Select
                                open={isDropdownOpenTemplate} // Controlled open state for Select dropdown
                                onDropdownVisibleChange={(open) => setIsDropdownOpenTemplate(open)} // Track dropdown visibility
                                showSearch
                                className={templateIsRequiredError_publica ? "form_select basic  error" : "form_select basic "}
                                // placeholder="-Select-"
                                value={template_publica}
                                onChange={onChangeTemplate_publica}
                                optionFilterProp="label"
                                dropdownRender={(menu) => (
                                  <>
                                    {(role !== "admin" && role !== "u_admin") &&
                                      <div
                                        style={{
                                          padding: '8px',
                                          cursor: 'pointer',
                                          color: '#9254de',
                                          borderBottom: '1px solid #f0f0f0',
                                        }}
                                        onClick={() => openTemplateModal("publica")}
                                      >
                                        + New Template
                                      </div>
                                    }

                                    {menu}
                                  </>
                                )}
                                options={templateOptions_publica}
                              />

                              <span className="error_content">
                                {templateIsRequiredError_publica && (
                                  <> This field is required</>
                                )}
                              </span>


                            </div>

                            <div className="form_content_block--group mb_0">
                              {/* <label className="form_label">Override *</label> */}
                              <TextArea autocomplete="off" placeholder=''
                                className="form_control basic form_control_h textarea_paddingY_d2 --120"
                                disabled
                                //  className={siteIdListIsRequiredError ? 'form_control basic form_control_h textarea_paddingY_d2 error --120' : 'form_control basic form_control_h textarea_paddingY_d2 --120'}
                                value={templateText_publica}
                              // onChange={onChangeSiteIdList}
                              // onBlur={onBlurSiteIdList}
                              />
                              <span className="error_content">
                                {/* {channelNameIsRequiredError_vast_aniview && (
                                  <> This field is required</>
                                )} */}
                              </span>
                            </div>


                          </Col>
                        </Row>
                      </div>
                    </Col>
                  </Row>

                  {(role !== "admin" && role !== "u_admin") &&
                    <Row gutter={16}>
                      <Col span={8}>
                        <div className="container_box--label-info">
                          <label>Inventory Partner Domain Override</label>
                          {/* <p className="sub_text">Please enter zone details</p> */}
                        </div>
                      </Col>

                      <Col span={16}>
                        <div
                          className="container_box--form-container  mb_0"
                        >
                          <Row gutter={16}>
                            <Col span={24}>

                              <div className="form_content_block--group">
                                <div className="primary_checkbox">
                                  <Checkbox
                                    id="zone_checkbox_prebid"
                                    name="zone_checkbox_prebid"
                                    checked={isAddValueCheckbox_publica}
                                    onChange={onChangeIsAddValueCheckbox_publica}
                                  >
                                    <span className="form_label">
                                      Add value only if obj. empty in bid request
                                    </span>
                                  </Checkbox>
                                </div>
                              </div>

                              <div className="form_content_block--group mb_0">
                                <label className="form_label">Override </label>
                                <Input
                                  className="form_control basic"
                                  value={override_publica}
                                  onBlur={onBlurOverride_publica}
                                  onChange={onChangeOverride_publica}
                                  autocomplete="off"
                                />
                                {/* <span className="error_content">
                                  {overrideIsRequiredError_publica && (
                                    <> This field is required</>
                                  )}
                                </span> */}
                              </div>


                            </Col>
                          </Row>
                        </div>
                      </Col>
                    </Row>
                  }

                  {/* <Row gutter={16}>
                    <Col span={8}>
                      <div className="container_box--label-info">
                        <label>IVT Sampling</label>
                        <p className="sub_text">Set the sampling percentage</p>
                      </div>
                    </Col>
                    <Col span={16}>
                      <div className="container_box--form-container mb_0">
                        <Row gutter={16}>
                          <Col span={24}>
                            <div className="alert_yellow_div">
                              <span>Changing the percentage impacts the cost, change it as per best practice.</span>
                            </div>
                          </Col>
                          <Col span={12}>
                            <div className="form_content_block--group">
                              <label className="form_label">Human *</label>
                              <Input
                                className={humanValidError_publica ? 'form_control basic form_control_with_icon_d2 error' : 'form_control basic form_control_with_icon_d2'}
                                placeholder='0'
                                autocomplete="off"
                                value={human_publica}
                                onChange={onChangeHuman_publica}
                                disabled={(role === "admin" || role === "u_admin")}
                                onBlur={onBlurHuman_publica}
                                suffix={'%'}
                              />
                              <span className="error_content">
                                {humanValidError_publica && <>Value must be an integer between 0 and 100</>}
                              </span>
                            </div>
                          </Col>
                        </Row>
                        <Row gutter={16}>
                          <Col span={12}>
                            <div className="form_content_block--group mb_0">
                              <label className="form_label">Pixalate *</label>
                              <Input
                                className={pixalateValidError_publica ? 'form_control basic form_control_with_icon_d2 error' : 'form_control basic form_control_with_icon_d2'}
                                placeholder='0'
                                autocomplete="off"
                                value={pixalate_publica}
                                onChange={onChangePixalate_publica}
                                disabled={(role === "admin" || role === "u_admin")}
                                onBlur={onBlurPixalate_publica}
                                suffix={'%'}
                              />
                              <span className="error_content">
                                {pixalateValidError_publica && <>Value must be an integer between 0 and 100</>}
                              </span>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </Col>
                  </Row> */}

                </>)

                :
                formType === "Vast Zone" ?
                  (
                    <>
                      <Row gutter={16}>
                        <Col span={8}>
                          <div className="container_box--label-info">
                            <label>General details</label>
                            <p className="sub_text">Please enter zone details</p>
                          </div>
                        </Col>

                        <Col span={16}>
                          <div className="container_box--form-container" >
                            <Row gutter={16}>
                              <Col span={24}>
                                <div className="form_content_block--group">
                                  <label className="form_label">
                                    Traffic Type *
                                  </label>
                                  <Radio.Group
                                    onChange={onChangePlatformType_vastzone}
                                    value={platformType_vastzone}
                                    className="form_radio equal_space"
                                  >
                                    <Radio className="radio_btn" value="Website">
                                      Website
                                    </Radio>
                                    <Radio className="radio_btn" value="Inapp">
                                      Inapp
                                    </Radio>
                                    <Radio className="radio_btn" value="CTV">
                                      CTV
                                    </Radio>
                                  </Radio.Group>
                                </div>

                                <div className="form_content_block--group">
                                  <label className="form_label">Format Type *</label>
                                  <div className='new_cls_for_checkboxgroup_d2 --width_adjusting_css'>
                                    <Checkbox.Group className="form_checkbox equal_space" value={["Video"]} disabled>
                                      <Checkbox className="checkbox_btn" value="Banner">
                                        Banner
                                      </Checkbox>
                                      <Checkbox className="checkbox_btn" value="Video">
                                        Video
                                      </Checkbox>
                                      <Checkbox className="checkbox_btn" value="Native">
                                        Native
                                      </Checkbox>
                                    </Checkbox.Group>
                                  </div>
                                </div>

                                <div className="form_content_block--group">
                                  <label className="form_label">Stream Position *</label>
                                  {platformType_vastzone === "CTV" ?
                                    <Input
                                      className="form_control basic"
                                      value="Instream"
                                      autocomplete="off"
                                      disabled
                                    />
                                    :
                                    <Select
                                      optionFilterProp="label"
                                      className="form_select basic no_search"
                                      value={streamPosition_vastzone}
                                      onChange={onChangeStreamPosition_vastzone}
                                      options={streamPositionOptions_vastzone}
                                    />
                                  }
                                </div>


                                <div className="form_content_block--group">
                                  <label className="form_label">Zone Name *</label>
                                  <Input
                                    className={
                                      zoneNameIsRequiredError_vastzone || nameExists.vastzone
                                        ? "form_control basic error"
                                        : "form_control basic"
                                    }
                                    value={zoneName_vastzone}
                                    onBlur={onBlurZoneName_vastzone}
                                    onChange={onChangeZoneName_vastzone}
                                    autocomplete="off"
                                    suffix={nameChecking.vastzone ? <img src={loaderIcon} alt="" style={{ width: 16, height: 16 }} /> : <span />}
                                  />
                                  <span className="error_content">
                                    {zoneNameIsRequiredError_vastzone && (
                                      <> This field is required</>
                                    )}
                                    {nameExists.vastzone && (
                                      <> Zone name already exists</>
                                    )}
                                  </span>
                                </div>
                                <div className="form_content_block--group">
                                  <div className="primary_checkbox">
                                    <Checkbox
                                      id="zone_checkbox_vastzone"
                                      name="zone_checkbox_vastzone"
                                      checked={zoneActiveCheckbox_vastzone}
                                      onChange={onChangeZoneActiveCheckbox_vastzone}
                                    >
                                      <span className="form_label">
                                        Is Zone Active?
                                      </span>
                                    </Checkbox>
                                  </div>
                                </div>
                                <Row gutter={16}>
                                  <Col span={12}>
                                    <div className="form_content_block--group mb_0">
                                      <label className='form_label'>Revenue Type *</label>
                                      <Select
                                        showSearch={false}
                                        optionFilterProp="label"
                                        className='form_select basic no_search'
                                        disabled
                                        value={revenueType_vastzone}
                                        onChange={onChangeRevenueType_vastzone}
                                        options={revenueTypeOptions_vastzone}
                                      />
                                    </div>
                                  </Col>
                                  {revenueType_vastzone === "Fixed_Price" ?
                                    <Col span={12}>
                                      <div className="form_content_block--group mb_0">
                                        <label className='form_label'>&nbsp;</label>
                                        <Input
                                          placeholder='Enter eCpm'
                                          className={
                                            eCpmIsRequiredError_vastzone
                                              ? "form_control basic error"
                                              : "form_control basic"
                                          }
                                          value={eCpm_vastzone}
                                          onBlur={onBlurECpm_vastzone}
                                          onChange={onChangeECpm_vastzone}
                                          autocomplete="off"
                                        />
                                        <span className="error_content">
                                          {eCpmIsRequiredError_vastzone && (
                                            <> This field is required</>
                                          )}
                                          {eCpmValidError_vastzone && (
                                            <> Value should be greater than 0 and less than 100</>
                                          )}
                                        </span>
                                      </div>
                                    </Col>
                                    :
                                    <Col span={12}>
                                      <div className="form_content_block--group mb-0">
                                        <label className='form_label'>&nbsp;</label>
                                        <Input
                                          placeholder='Enter Revshare'
                                          className={
                                            revSharePercentIsRequiredError_vastzone
                                              ? "form_control basic error form_control_with_icon_d2"
                                              : "form_control basic form_control_with_icon_d2"
                                          }
                                          value={revSharePercent_vastzone}
                                          onBlur={onBlurRevSharePercent_vastzone}
                                          onChange={onChangeRevSharePercent_vastzone}
                                          autocomplete="off"
                                          suffix={'%'}
                                        />
                                      </div>
                                      <span className="error_content">
                                        {revSharePercentIsRequiredError_vastzone && (
                                          <> This field is required</>
                                        )}
                                        {revSharePercentValidError_vastzone && (
                                          <> Value should be greater than 0 and less or equal to  80</>
                                        )}
                                      </span>
                                    </Col>
                                  }

                                </Row>

                              </Col>
                            </Row>
                          </div>
                        </Col>
                      </Row>



                      <Row gutter={16}>
                        <Col span={8}>
                          <div className="container_box--label-info">
                            <label>Please select all sensitive categories you would like us to block on your supply.</label>
                          </div>
                        </Col>
                        <Col span={16}>
                          <div className="container_box--form-container">
                            <Row gutter={16}>
                              <Col span={24}>
                                <div className="form_content_block--group mb-0">
                                  <BlockCategoryTable
                                    selected={blockCategorySelected}
                                    setSelected={setBlockCategorySelected}
                                    normalizeKey={blockCategoryNormalizeKey}
                                  />
                                </div>
                              </Col>
                            </Row>
                          </div>
                        </Col>
                      </Row>
                      {(role !== "admin" && role !== "u_admin") && (
                        <Row gutter={16}>
                          <Col span={8}>
                            <div className="container_box--label-info">
                              <label>Limits</label>
                              <p className="sub_text">Enter your zone limits</p>
                            </div>
                          </Col>

                          <Col span={16}>
                            <div className="container_box--form-container ">
                              <Row gutter={16}>
                                <Col span={12}>
                                  <div className="form_content_block--group mb_0">
                                    <label className="form_label">
                                      Requests per Day
                                    </label>
                                    <Input
                                      className={
                                        requestValueError_vastzone
                                          ? "form_control basic error"
                                          : "form_control basic"
                                      }
                                      value={request_vastzone}
                                      onBlur={onBlurRequest_vastzone}
                                      onChange={onChangeRequest_vastzone}
                                      autocomplete="off"
                                    />
                                  </div>
                                  <span className="error_content">
                                    {/* {requestIsRequiredError_vastzone && (
              <> This field is required</>
              )} */}
                                    {requestValueError_vastzone && (
                                      <> Value should be greater than 0</>
                                    )}
                                  </span>
                                </Col>
                                <Col span={12}>
                                  <div className="form_content_block--group mb_0">
                                    <label className="form_label">
                                      Impressions per Day
                                    </label>
                                    <Input
                                      className={
                                        impressionValueError_vastzone
                                          ? "form_control basic error"
                                          : "form_control basic"
                                      }
                                      value={impression_vastzone}
                                      onBlur={onBlurImpression_vastzone}
                                      onChange={onChangeImpression_vastzone}
                                      autocomplete="off"
                                    />
                                    <span className="error_content">
                                      {/* {impressionIsRequiredError_vastzone && (
              <> This field is required</>
              )} */}
                                      {impressionValueError_vastzone && (
                                        <> Value should be greater than 0</>
                                      )}
                                    </span>
                                  </div>
                                </Col>
                              </Row>
                            </div>
                          </Col>
                        </Row>
                      )}

                      {(role !== "admin" && role !== "u_admin") &&
                        <Row gutter={16}>
                          <Col span={8}>
                            <div className="container_box--label-info">
                              <label>Inventory Partner Domain Override</label>
                            </div>
                          </Col>
                          <Col span={16}>
                            <div className="container_box--form-container  ">
                              <Row gutter={16}>
                                <Col span={24}>
                                  <div className="form_content_block--group">
                                    <div className="primary_checkbox">
                                      <Checkbox
                                        checked={isAddValueCheckbox_vastzone}
                                        onChange={onChangeIsAddValueCheckbox_vastzone}
                                      >
                                        <span className="form_label">
                                          Pass Inventory Partner Domain
                                        </span>
                                      </Checkbox>
                                    </div>
                                  </div>
                                  <div className="form_content_block--group mb_0">
                                    <label className="form_label">Inventory Partner Domain  </label>
                                    <Input
                                      className="form_control basic"
                                      value={override_vastzone}
                                      onBlur={onBlurOverride_vastzone}
                                      onChange={onChangeOverride_vastzone}
                                      placeholder="Enter Inventory Partner Domain"
                                      autocomplete="off"
                                    />
                                  </div>
                                </Col>
                              </Row>
                            </div>
                          </Col>
                        </Row>
                      }

                      <Row gutter={16}>
                        <Col span={8}>
                          <div className="container_box--label-info mb_0">
                            <label>IVT Sampling</label>
                            <p className="sub_text">Set the sampling percentage</p>
                          </div>
                        </Col>
                        <Col span={16}>
                          <div className="container_box--form-container ">
                            <Row gutter={16}>
                              <Col span={24}>
                                <div className="alert_yellow_div">
                                  <span>Changing the percentage impacts the cost, change it as per best practice.</span>
                                </div>
                              </Col>
                              <Col span={12}>
                                <div className="form_content_block--group">
                                  <label className="form_label">Human *</label>
                                  <Input
                                    className={humanValidError_vastzone ? 'form_control basic form_control_with_icon_d2 error' : 'form_control basic form_control_with_icon_d2'}
                                    placeholder='0'
                                    autocomplete="off"
                                    value={human_vastzone}
                                    onChange={onChangeHuman_vastzone}
                                    disabled={(role === "admin" || role === "u_admin")}
                                    onBlur={onBlurHuman_vastzone}
                                    suffix={'%'}
                                  />
                                  <span className="error_content">
                                    {humanValidError_vastzone && <>Value must be an integer between 0 and 100</>}
                                  </span>
                                </div>
                              </Col>
                            </Row>
                            {/* PIXALATE SUNSET: Pixalate IVT sampling field hidden (not sent in payload).
                            <Row gutter={16}>
                              <Col span={12}>
                                <div className="form_content_block--group">
                                  <label className="form_label">Pixalate *</label>
                                  <Input
                                    className={pixalateValidError_vastzone ? 'form_control basic form_control_with_icon_d2 error' : 'form_control basic form_control_with_icon_d2'}
                                    placeholder='0'
                                    autocomplete="off"
                                    value={pixalate_vastzone}
                                    onChange={onChangePixalate_vastzone}
                                    disabled={(role === "admin" || role === "u_admin")}
                                    onBlur={onBlurPixalate_vastzone}
                                    suffix={'%'}
                                  />
                                  <span className="error_content">
                                    {pixalateValidError_vastzone && <>Value must be an integer between 0 and 100</>}
                                  </span>
                                </div>
                              </Col>
                            </Row>
                            */}
                            <Row gutter={16}>
                              <Col span={12}>
                                <div className="form_content_block--group mb_0">
                                  <label className="form_label">DoubleVerify *</label>
                                  <Input
                                    className={doubleverifyValidError_vastzone ? 'form_control basic form_control_with_icon_d2 error' : 'form_control basic form_control_with_icon_d2'}
                                    placeholder='0'
                                    autocomplete="off"
                                    value={doubleverify_vastzone}
                                    onChange={onChangeDoubleverify_vastzone}
                                    disabled={(role === "admin" || role === "u_admin")}
                                    onBlur={onBlurDoubleverify_vastzone}
                                    suffix={'%'}
                                  />
                                  <span className="error_content">
                                    {doubleverifyValidError_vastzone && <>Value must be an integer between 0 and 100</>}
                                  </span>
                                </div>
                              </Col>
                            </Row>
                          </div>
                        </Col>
                      </Row>

                      <Row gutter={16}>
                        <Col span={8}>
                          <div className="container_box--label-info">
                            <label>Endpoint</label>
                          </div>
                        </Col>

                        <Col span={16}>
                          <div
                            className={(role === "admin" || role === "u_admin") ? "container_box--form-container mb_0" : "container_box--form-container mb_0 "}
                          >
                            <Row gutter={16}>
                              <Col span={24}>

                                <div className="form_content_block--group  "
                                  style={{ marginBottom: "10px" }}
                                >
                                  <label className="form_label">
                                    Template *
                                  </label>

                                  <Select
                                    open={isDropdownOpenTemplate_vastzone}
                                    onDropdownVisibleChange={(open) => setIsDropdownOpenTemplate_vastzone(open)}
                                    showSearch
                                    className={templateIsRequiredError_vastzone ? "form_select basic  error" : "form_select basic "}
                                    value={template_vastzone}
                                    onChange={onChangeTemplate_vastzone}
                                    optionFilterProp="label"
                                    dropdownRender={(menu) => (
                                      <>
                                        {(role !== "admin" && role !== "u_admin") &&
                                          <div
                                            style={{
                                              padding: '8px',
                                              cursor: 'pointer',
                                              color: '#9254de',
                                              borderBottom: '1px solid #f0f0f0',
                                            }}
                                            onClick={() => openTemplateModal("vastzone")}
                                          >
                                            + New Template
                                          </div>
                                        }
                                        {menu}
                                      </>
                                    )}
                                    options={templateOptions_vastzone[platformType_vastzone] || []}
                                  />

                                  <span className="error_content">
                                    {templateIsRequiredError_vastzone && (
                                      <> This field is required</>
                                    )}
                                  </span>

                                </div>

                                <div className="form_content_block--group mb_0">
                                  <TextArea autocomplete="off" placeholder=''
                                    className="form_control basic form_control_h textarea_paddingY_d2 --120"
                                    disabled
                                    value={templateText_vastzone}
                                  />
                                  <span className="error_content"></span>
                                </div>

                              </Col>
                            </Row>
                          </div>
                        </Col>
                      </Row>

                    </>
                  )
                  :
                  formType === "vast_aniview" ?
                    <>
                      <Row gutter={16}>
                        <Col span={8}>
                          <div className="container_box--label-info">
                            <label>General details</label>
                            <p className="sub_text">Please enter zone details</p>
                          </div>
                        </Col>

                        <Col span={16}>
                          <div className="container_box--form-container">
                            <Row gutter={16}>
                              <Col span={24}>
                                <div className="form_content_block--group">
                                  <label className="form_label">
                                    Traffic Type *
                                  </label>
                                  <Radio.Group
                                    onChange={onChangePlatformType_vast_aniview}
                                    value={platformType_vast_aniview}
                                    className="form_radio equal_space"
                                  >
                                    <Radio className="radio_btn" value="Website">
                                      Website
                                    </Radio>
                                    <Radio className="radio_btn" value="Inapp">
                                      Inapp
                                    </Radio>
                                    <Radio className="radio_btn" value="CTV">
                                      CTV
                                    </Radio>
                                  </Radio.Group>
                                </div>

                                <div className="form_content_block--group">
                                  <label className="form_label">Channel Name *</label>
                                  <Input
                                    className={
                                      channelNameIsRequiredError_vast_aniview
                                        ? "form_control basic error"
                                        : "form_control basic"
                                    }
                                    value={channelName_vast_aniview}
                                    onBlur={onBlurChannelName_vast_aniview}
                                    onChange={onChangeChannelName_vast_aniview}
                                    autocomplete="off"
                                  />
                                  <span className="error_content">
                                    {channelNameIsRequiredError_vast_aniview && (
                                      <> This field is required</>
                                    )}
                                  </span>
                                </div>


                                <div className="form_content_block--group mb_0">
                                  <label className='form_label'>eCPM *</label>
                                  <Input
                                    placeholder='Enter eCpm'
                                    className={
                                      eCpmIsRequiredError_vast_aniview || eCpmValidError_vast_aniview
                                        ? "form_control basic error"
                                        : "form_control basic"
                                    }
                                    value={eCpm_vast_aniview}
                                    onBlur={onBlurECpm_vast_aniview}
                                    onChange={onChangeECpm_vast_aniview}
                                    autocomplete="off"
                                  />
                                  <span className="error_content">
                                    {eCpmIsRequiredError_vast_aniview && (
                                      <> This field is required</>
                                    )}
                                    {eCpmValidError_vast_aniview && (
                                      <> Value should be greater than 0 and less than 100</>
                                    )}
                                  </span>
                                </div>

                              </Col>
                            </Row>
                          </div>
                        </Col>
                      </Row>


                    </>
                    :
                    (formType === "Player Tag" || formType === "tag_outstream") ?
                      <>
                        <Row gutter={16}>
                          <Col span={8}>
                            <div className="container_box--label-info">
                              <label>General details</label>
                              <p className="sub_text">Please enter zone details</p>
                            </div>
                          </Col>

                          <Col span={16}>
                            <div className="container_box--form-container">
                              <Row gutter={16}>
                                <Col span={24}>
                                  <div className="form_content_block--group">
                                    <label className="form_label">
                                      Traffic Type *
                                    </label>
                                    <Radio.Group
                                      onChange={onChangePlatformType_playertag}
                                      value={platformType_playertag}
                                      className="form_radio equal_space"
                                    >
                                      <Radio className="radio_btn" value="Website">
                                        Website
                                      </Radio>
                                      <Radio className="radio_btn" value="Inapp">
                                        Inapp
                                      </Radio>
                                      {/* <Radio className="radio_btn" value="CTV">
                                    CTV
                                  </Radio> */}
                                    </Radio.Group>
                                  </div>
                                  <div className="form_content_block--group">
                                    <label className="form_label">Player Mode *</label>
                                    <Select
                                      optionFilterProp="label"
                                      className="form_select basic no_search"
                                      value={playerMode_playertag}
                                      onChange={onChangePlayerMode_playertag}
                                      options={playerModeOptions_playertag}
                                    />
                                  </div>

                                  {/* {playerMode_playertag === "bannerVideo" && */}
                                  <div className="form_content_block--group">
                                    <label className="form_label">Floating Position *</label>
                                    <Select
                                      optionFilterProp="label"
                                      className="form_select basic no_search"
                                      value={floatingPosition_playertag}
                                      onChange={onChangeFloatingPosition_playertag}
                                      options={formType === "tag_outstream" ? floatingPositionOptions_tag_outstream : floatingPositionOptions_playertag}
                                    />
                                  </div>
                                  {/* } */}


                                  <div className="form_content_block--group">
                                    <label className="form_label">Channel Name *</label>
                                    <Input
                                      className={
                                        channelNameIsRequiredError_playertag
                                          ? "form_control basic error"
                                          : "form_control basic"
                                      }
                                      value={channelName_playertag}
                                      onBlur={onBlurChannelName_playertag}
                                      onChange={onChangeChannelName_playertag}
                                      autocomplete="off"
                                    />
                                    <span className="error_content">
                                      {channelNameIsRequiredError_playertag && (
                                        <> This field is required</>
                                      )}
                                    </span>
                                  </div>


                                  <div className="form_content_block--group mb_0">
                                    <label className='form_label'>eCPM *</label>
                                    <Input
                                      placeholder='Enter eCpm'
                                      className={
                                        eCpmIsRequiredError_playertag || eCpmValidError_playertag
                                          ? "form_control basic error"
                                          : "form_control basic"
                                      }
                                      value={eCpm_playertag}
                                      onBlur={onBlurECpm_playertag}
                                      onChange={onChangeECpm_playertag}
                                      autocomplete="off"
                                    />
                                    <span className="error_content">
                                      {eCpmIsRequiredError_playertag && (
                                        <> This field is required</>
                                      )}
                                      {eCpmValidError_playertag && (
                                        <> Value should be greater than 0 and less than 100</>
                                      )}
                                    </span>
                                  </div>

                                </Col>
                              </Row>
                            </div>
                          </Col>
                        </Row>

                        <Row gutter={16}>
                          <Col span={8}>
                            <div className="container_box--label-info"

                            >
                              <label>CMS</label>
                              <p className='sub_text'>Upload your desired video</p>
                            </div>
                          </Col>

                          <Col span={16}>
                            <div className="form_content_block--group mb_0"

                            >
                              <label
                                // for='fileUploader' 
                                className='ant_upload_drag mb-4'
                                onClick={() => { setIsModalVisibleVideo(true) }}
                              >
                                <p className="upload_drag_icon">
                                  <img src={uploadIcon} alt='USP' />
                                </p>
                                <p className="ant_upload_text"><b className="primary">Click to upload</b> the video</p>
                                <p className="ant_upload_hint">
                                  Video (max. 100 MB)
                                </p>
                              </label>
                              {/* <input className='form_upload d-none' type="file" id="fileUploader" name="fileUploader" /> */}
                              {mainTableVideo_playertag?.length > 0 &&
                                <>
                                  {mainTableVideo_playertag?.map((video, index) => (
                                    <>
                                      <div className="ant_upload_list--item">

                                        <div className="ant_upload_list--content gap_12">
                                          <div className="thumbnail_content--video position-relative">
                                            <button className='thumbnail_content--play'
                                              onClick={() => { handleFullscreen5(index) }}
                                            ><img src={playIcon} alt='USP' /></button>
                                            <video
                                              ref={el => videoRef5.current[index] = el}
                                              width="138"
                                              height="79"
                                              controls={false}
                                              className='video_thumb'
                                              // onMouseEnter={handleMouseEnter}
                                              // onMouseLeave={handleMouseLeave}
                                              muted
                                            >
                                              <source src={video.url} />
                                              Your browser does not support the video tag.
                                            </video>
                                          </div>

                                          <div className="ant_upload_list--info">
                                            <span className="ant_upload_list--info-name">{video?.url?.includes("blob") ? video?.filename : video?.url?.substring(video?.url?.lastIndexOf('/') + 1)}</span>
                                            <span className="ant_upload_list--info-size">{video?.url?.includes("blob") ? video?.size / 1024 > 100 ? `${(video.size / (1024 * 1024)).toFixed(2)} MB` : `${(video.size / (1024)).toFixed(2)} KB` : ""}</span>
                                          </div>



                                        </div>
                                        <button type="link" className="download_icon download_icon_d2"
                                          onClick={() => {
                                            const newArray = [...mainTableVideo_playertag];
                                            newArray.splice(index, 1);
                                            setMainTableVideo_playertag(newArray);
                                          }}
                                        >
                                          <img src={deleteIcon} alt="USP" />
                                        </button>

                                      </div>
                                    </>

                                  ))}
                                </>
                              }
                            </div>
                          </Col>
                          <Col span={16}>
                            <div className="form_content_block--group mb_0">

                              <Modal
                                centered
                                className='custom_modal custom_modal_d2'
                                title={<div className='custom_modal--header --tabs'><h3 className='heading'><img src={addVideoIcon} alt='USP' /> Add Video</h3>
                                  <div className="tab_content--buttons">
                                    <>
                                      {(role === "admin" || role === "u_admin") ?
                                        <>
                                          {items_admin_playertag.map((item) => (
                                            <button
                                              key={item.key}
                                              onClick={() => onTabChangeVideo(item.key, item.tab)}
                                              className={activeKeyVideoTab === item.key ? 'btn active' : 'btn'}
                                            >
                                              {item.tab}
                                            </button>
                                          ))}
                                        </>
                                        :
                                        <>
                                          {items_notAdmin_playertag.map((item) => (
                                            <button
                                              key={item.key}
                                              onClick={() => onTabChangeVideo(item.key, item.tab)}
                                              className={activeKeyVideoTab === item.key ? 'btn active' : 'btn'}
                                            >
                                              {item.tab}
                                            </button>
                                          ))}

                                        </>}

                                    </>
                                  </div>
                                </div>}
                                visible={isModalVisibleVideo}
                                maskClosable={false}
                                onCancel={() => { setIsModalVisibleVideo(false) }}
                                // This removes the default close button
                                width={1000}
                                footer={[
                                  <div className="custom_modal--footer d_flex justify_content_end">
                                    {activeKeyVideoTabName === "Suggested" ?
                                      <>
                                        <span className='selected_items'>{tempTableSuggestedMainVideoChecked_playertag.length > 0 ? `${tempTableSuggestedMainVideoChecked_playertag.length} Selected` : ""} </span>
                                        <button key="submit" className='btn btn_primary w_fit_content'
                                          disabled={tempTableSuggestedMainVideoChecked_playertag.length === 0}
                                          onClick={() => {
                                            setMainTableVideo_playertag([...mainTableVideo_playertag, ...tempTableSuggestedMainVideoChecked_playertag])
                                            resetModalVideo_playertag()
                                          }}
                                        >
                                          Upload
                                        </button>
                                      </> :
                                      activeKeyVideoTabName === "My Video" ?
                                        <>

                                          <span className='selected_items'>{tempTableSuggestedSubVideoChecked_playertag.length > 0 ? `${tempTableSuggestedSubVideoChecked_playertag.length} Selected` : ""} </span>
                                          <button key="submit" className='btn btn_primary w_fit_content'
                                            disabled={tempTableSuggestedSubVideoChecked_playertag.length === 0}
                                            onClick={() => {
                                              setMainTableVideo_playertag([...mainTableVideo_playertag, ...tempTableSuggestedSubVideoChecked_playertag])
                                              resetModalVideo_playertag()
                                            }}
                                          >
                                            Upload
                                          </button>

                                        </> :
                                        activeKeyVideoTabName === "Link" ?
                                          <>
                                            <button key="submit" className='btn btn_primary w_fit_content'
                                              disabled={tempTableLinkVideo_playertag.length === 0}
                                              onClick={() => {
                                                setMainTableVideo_playertag([...mainTableVideo_playertag, ...tempTableLinkVideo_playertag])
                                                resetModalVideo_playertag()
                                              }}
                                            >
                                              Upload
                                            </button>
                                          </>
                                          :
                                          activeKeyVideoTabName === "Upload" ?
                                            <>
                                              <button key="submit" className='btn btn_primary w_fit_content'
                                                disabled={tempTableUploadVideo_playertag.length === 0}
                                                onClick={() => {
                                                  setMainTableVideo_playertag([...mainTableVideo_playertag, ...tempTableUploadVideo_playertag])
                                                  resetModalVideo_playertag()
                                                }}
                                              >
                                                Upload
                                              </button>
                                            </>
                                            :
                                            <></>
                                    }
                                  </div>
                                ]}
                              >
                                <div className="custom_modal--body">
                                  <div className="tab_content--body">
                                    {(role === "admin" || role === "u_admin") ?
                                      <>
                                        {items_admin_playertag.map((item) => (
                                          <div
                                            key={item.key}
                                            style={{ display: activeKeyVideoTab === item.key ? 'block' : 'none' }}
                                          >
                                            {item.content}
                                          </div>
                                        ))}
                                      </>
                                      :
                                      <>
                                        {items_notAdmin_playertag.map((item) => (
                                          <div
                                            key={item.key}
                                            style={{ display: activeKeyVideoTab === item.key ? 'block' : 'none' }}
                                          >
                                            {item.content}
                                          </div>
                                        ))}
                                      </>
                                    }

                                  </div>
                                </div>
                              </Modal>

                            </div>
                          </Col>
                        </Row>

                      </>
                      :
                      formType === "GAM" ? (
                        <>
                          {/* ------- General details ------- */}
                          <Row gutter={16}>
                            <Col span={8}>
                              <div className="container_box--label-info">
                                <label>General details</label>
                                <p className="sub_text">Please enter zone details</p>
                              </div>
                            </Col>
                            <Col span={16}>
                              <div className="container_box--form-container">
                                <Row gutter={16}>
                                  <Col span={24}>
                                    <div className="form_content_block--group">
                                      <label className="form_label">Traffic Type *</label>
                                      <Radio.Group
                                        onChange={onChangePlatformType_gam}
                                        value={platformType_gam}
                                        className="form_radio equal_space"
                                      >
                                        <Radio className="radio_btn" value="Website">
                                          Website
                                        </Radio>
                                        <Radio className="radio_btn" value="Inapp">
                                          Inapp
                                        </Radio>
                                        <Radio className="radio_btn" value="CTV">
                                          CTV
                                        </Radio>
                                      </Radio.Group>
                                    </div>
                                    <div className="form_content_block--group">
                                      <label className="form_label">Format Type *</label>
                                      <Radio.Group
                                        onChange={onChangeFormatType_gam}
                                        value={platformType_gam === "CTV" ? "Video" : formatType_gam}
                                        className="form_radio equal_space"
                                        disabled={platformType_gam === "CTV"}
                                      >
                                        {formatTypeOptions_gam.map((opt) => (
                                          <Radio className="radio_btn" key={opt.value} value={opt.value}>
                                            {opt.label}
                                          </Radio>
                                        ))}
                                      </Radio.Group>
                                    </div>
                                    <div className="form_content_block--group">
                                      <label className="form_label">Ad Unit/Zone Name *</label>
                                      <Input
                                        className={
                                          zoneNameIsRequiredError_gam || zoneNameMaxError_gam || nameExists.gam
                                            ? "form_control basic error"
                                            : "form_control basic"
                                        }
                                        value={zoneName_gam}
                                        onBlur={onBlurZoneName_gam}
                                        onChange={onChangeZoneName_gam}
                                        maxLength={90}
                                        autocomplete="off"
                                        suffix={nameChecking.gam ? <img src={loaderIcon} alt="" style={{ width: 16, height: 16 }} /> : <span />}
                                      />
                                      <span className="error_content">
                                        {zoneNameIsRequiredError_gam && (
                                          <> This field is required</>
                                        )}
                                        {zoneNameMaxError_gam && (
                                          <> Maximum 90 characters allowed</>
                                        )}
                                        {nameExists.gam && (
                                          <> Zone name already exists</>
                                        )}
                                      </span>
                                    </div>
                                    <div className="form_content_block--group mb_0">
                                      <div className="primary_checkbox">
                                        <Checkbox
                                          id="zone_checkbox_gam"
                                          name="zone_checkbox_gam"
                                          checked={zoneActiveCheckbox_gam}
                                          onChange={onChangeZoneActiveCheckbox_gam}
                                        >
                                          <span className="form_label">Is Zone Active?</span>
                                        </Checkbox>
                                      </div>
                                    </div>
                                  </Col>
                                </Row>
                              </div>
                            </Col>
                          </Row>

                          {/* ------- Sizes ------- */}
                          <Row gutter={16}>
                            <Col span={8}>
                              <div className="container_box--label-info">
                                <label>Sizes</label>
                                <p className="sub_text">Choose ad sizes</p>
                              </div>
                            </Col>
                            <Col span={16}>
                              <div className="container_box--form-container --form_contaier_sizes">
                                <Row gutter={16}>
                                  <Col span={24}>
                                    {/* Sizes (multi-select) - Banner: sizes.json | Video: vastMasterSizes.json */}
                                    <div className="form_content_block--group mt-0">
                                      <label className="form_label">Sizes *</label>
                                      <div className="checkbox_value_select_d2 multi_select_tag_d2 w-100">
                                        <Select
                                          value={sizesList_gam}
                                          popupClassName='diff_select_d2 form_select_multiple--dropdown'
                                          maxTagCount={3}
                                          showSearch={false}
                                          placeholder='- Select -'
                                          maxTagPlaceholder={(omittedValues) => `+${omittedValues.length}`}
                                          className={sizesIsRequiredError_gam ? "form_select_multiple error" : "form_select_multiple"}
                                          mode='multiple'
                                          optionLabelProp="label"
                                          onChange={(event) => {
                                            setSizesList_gam(event);
                                            if (event.length > 0) setSizesIsRequiredError_gam(false);
                                          }}
                                          open={!!openSelectState_gam[`sizes-gam`]}
                                          onDropdownVisibleChange={(open) => toggleSelectOpen_gam(`sizes-gam`, open)}
                                          dropdownRender={menu => (
                                            <>
                                              <div className="custom_inside_searchbar_d2">
                                                <Input placeholder="Search" value={searchSizesList_gam}
                                                  onChange={(e) => { handleSearchSizesList_gam(e) }}
                                                  onKeyDown={(e) => e.stopPropagation()}
                                                  ref={getRef_gam(`sizes-gam`)}
                                                  prefix={<img src={searchIcon} alt="USP" />} allowClear
                                                  onClear={() => {
                                                    setSearchSizesList_gam('');
                                                    setTimeout(() => { refsMap_gam.current[`sizes-gam`]?.current?.focus(); }, 0);
                                                  }} />
                                              </div>
                                              {searchSizesList_gam.length === 0 && sizesListOptions_gam?.length > 0 &&
                                                <div
                                                  className={`select_all_d2 ${(sizesList_gam?.length > 0 && sizesList_gam?.length !== sizesListOptions_gam?.length) ? 'intermediate_state' : ''}`}
                                                  onClick={() => handleSelectAllSizesList_gam()}
                                                >
                                                  <Checkbox
                                                    checked={sizesList_gam?.length === sizesListOptions_gam?.length}
                                                    onClick={(e) => e.stopPropagation()}
                                                  >
                                                    Select All
                                                  </Checkbox>
                                                </div>
                                              }
                                              {menu}
                                            </>
                                          )}
                                        >
                                          {[
                                            ...filterSizesList_gam?.filter(option => sizesList_gam?.includes(option.value)),
                                            ...filterSizesList_gam?.filter(option => !sizesList_gam?.includes(option.value))
                                          ].map(option => (
                                            <Option key={option.value} value={option.value} label={option.label}>
                                              <div
                                                onClick={() => handleSizesList_gam(option.value)}
                                                style={{ display: 'flex', alignItems: 'center' }}
                                              >
                                                <Checkbox
                                                  checked={sizesList_gam?.includes(option.value)}
                                                  onClick={(e) => e.stopPropagation()}
                                                >
                                                  {option.label}
                                                </Checkbox>
                                              </div>
                                            </Option>
                                          ))}
                                        </Select>
                                      </div>
                                      <span className="error_content">
                                        {sizesIsRequiredError_gam && (<> Minimum 1 selection is required</>)}
                                      </span>
                                    </div>

                                    {/* Companion (multi-select) - Video only, companionSizes.json */}
                                    {formatType_gam === "Video" && (
                                      <div className="form_content_block--group">
                                        <label className="form_label">Companion</label>
                                        <div className="checkbox_value_select_d2 multi_select_tag_d2 w-100">
                                          <Select
                                            value={companionList_gam}
                                            popupClassName='diff_select_d2 form_select_multiple--dropdown'
                                            maxTagCount={3}
                                            showSearch={false}
                                            placeholder='- Select -'
                                            maxTagPlaceholder={(omittedValues) => `+${omittedValues.length}`}
                                            className="form_select_multiple"
                                            mode='multiple'
                                            optionLabelProp="label"
                                            onChange={(event) => { setCompanionList_gam(event); }}
                                            open={!!openSelectState_gam[`companion-gam`]}
                                            onDropdownVisibleChange={(open) => toggleSelectOpen_gam(`companion-gam`, open)}
                                            dropdownRender={menu => (
                                              <>
                                                <div className="custom_inside_searchbar_d2">
                                                  <Input placeholder="Search" value={searchCompanionList_gam}
                                                    onChange={(e) => { handleSearchCompanionList_gam(e) }}
                                                    onKeyDown={(e) => e.stopPropagation()}
                                                    ref={getRef_gam(`companion-gam`)}
                                                    prefix={<img src={searchIcon} alt="USP" />} allowClear
                                                    onClear={() => {
                                                      setSearchCompanionList_gam('');
                                                      setTimeout(() => { refsMap_gam.current[`companion-gam`]?.current?.focus(); }, 0);
                                                    }} />
                                                </div>
                                                {searchCompanionList_gam.length === 0 && companionListOptions_gam?.length > 0 &&
                                                  <div
                                                    className={`select_all_d2 ${(companionList_gam?.length > 0 && companionList_gam?.length !== companionListOptions_gam?.length) ? 'intermediate_state' : ''}`}
                                                    onClick={() => handleSelectAllCompanionList_gam()}
                                                  >
                                                    <Checkbox
                                                      checked={companionList_gam?.length === companionListOptions_gam?.length}
                                                      onClick={(e) => e.stopPropagation()}
                                                    >
                                                      Select All
                                                    </Checkbox>
                                                  </div>
                                                }
                                                {menu}
                                              </>
                                            )}
                                          >
                                            {[
                                              ...filterCompanionList_gam?.filter(option => companionList_gam?.includes(option.value)),
                                              ...filterCompanionList_gam?.filter(option => !companionList_gam?.includes(option.value))
                                            ].map(option => (
                                              <Option key={option.value} value={option.value} label={option.label}>
                                                <div
                                                  onClick={() => handleCompanionList_gam(option.value)}
                                                  style={{ display: 'flex', alignItems: 'center' }}
                                                >
                                                  <Checkbox
                                                    checked={companionList_gam?.includes(option.value)}
                                                    onClick={(e) => e.stopPropagation()}
                                                  >
                                                    {option.label}
                                                  </Checkbox>
                                                </div>
                                              </Option>
                                            ))}
                                          </Select>
                                        </div>
                                      </div>
                                    )}
                                    {platformType_gam === "CTV" && !isGamRestricted && (
                                      <>
                                        <div className="form_content_block--group">
                                          <div className="primary_checkbox">
                                            <Checkbox
                                              id="tv_app_name_gam"
                                              name="tv_app_name_gam"
                                              checked={tvAppNameCheckbox_gam}
                                              onChange={onChangeTvAppNameCheckbox_gam}
                                            >
                                              <span className="form_label">TV app name</span>
                                            </Checkbox>
                                          </div>
                                        </div>
                                        {tvAppNameCheckbox_gam && (
                                          <div className="form_content_block--group mb_0">
                                            <label className="form_label">TV Application *</label>
                                            <Select
                                              showSearch
                                              optionFilterProp="label"
                                              className={tvApplicationIsRequiredError_gam ? "form_select basic error" : "form_select basic"}
                                              value={tvApplication_gam}
                                              placeholder="- Select -"
                                              onChange={onChangeTvApplication_gam}
                                              options={tvApplicationOptions_gam}
                                            />
                                            <span className="error_content">
                                              {tvApplicationIsRequiredError_gam && (
                                                <> This field is required</>
                                              )}
                                            </span>
                                          </div>
                                        )}
                                      </>
                                    )}
                                  </Col>
                                </Row>
                              </div>
                            </Col>
                          </Row>

                          {/* ------- Pricing ------- */}
                          <Row gutter={16}>
                            <Col span={8}>
                              <div className="container_box--label-info">
                                <label>Pricing</label>
                                <p className="sub_text">Set zone pricing</p>
                              </div>
                            </Col>
                            <Col span={16}>
                              <div className="container_box--form-container mb_0">
                                <Row gutter={16}>
                                  <Col span={24}>
                                    <Row gutter={16}>
                                      <Col span={overrideUpr_gam ? 8 : 12}>
                                        <div className="form_content_block--group">
                                          <label className="form_label">Fixed Price *</label>
                                          <Input
                                            className={
                                              fixedPriceIsRequiredError_gam || fixedPriceValidError_gam
                                                ? "form_control basic prefix_sign error"
                                                : "form_control basic prefix_sign"
                                            }
                                            placeholder="0"
                                            autocomplete="off"
                                            value={fixedPrice_gam}
                                            onChange={onChangeFixedPrice_gam}
                                            onBlur={onBlurFixedPrice_gam}
                                            prefix={"$"}
                                          />
                                          <span className="error_content">
                                            {fixedPriceIsRequiredError_gam && (
                                              <> This field is required</>
                                            )}
                                            {fixedPriceValidError_gam && (
                                              <> Value must be greater than 0</>
                                            )}
                                          </span>
                                        </div>
                                      </Col>
                                      <Col span={overrideUpr_gam ? 8 : 12}>
                                        <div className="form_content_block--group">
                                          {/* <div className="d_flex justify-content-between align-items-center"> */}
                                          <label className="form_label">Set UPR *</label>
                                          {/* {!isGamRestricted && (
                                              <div className="primary_checkbox">
                                                <Checkbox
                                                  id="override_upr_gam"
                                                  name="override_upr_gam"
                                                  checked={overrideUpr_gam}
                                                  onChange={onChangeOverrideUpr_gam}
                                                >
                                                  <span className="form_label">Override UPR</span>
                                                </Checkbox>
                                              </div>
                                            )} */}
                                          {/* </div> */}
                                          <Input
                                            className="form_control basic prefix_sign"
                                            placeholder="0"
                                            autocomplete="off"
                                            value={upr_gam}
                                            prefix={"$"}
                                            disabled
                                          />
                                        </div>
                                      </Col>
                                      {/* {overrideUpr_gam && (
                                        <Col span={8}>
                                          <div className="form_content_block--group">
                                            <label className="form_label">Override Set UPR *</label>
                                            <Input
                                              className={
                                                overrideSetUprIsRequiredError_gam || overrideSetUprValidError_gam
                                                  ? "form_control basic prefix_sign error"
                                                  : "form_control basic prefix_sign"
                                              }
                                              placeholder="0"
                                              autocomplete="off"
                                              value={overrideSetUpr_gam}
                                              onChange={onChangeOverrideSetUpr_gam}
                                              onBlur={onBlurOverrideSetUpr_gam}
                                              prefix={"$"}
                                            />
                                            <span className="error_content">
                                              {overrideSetUprIsRequiredError_gam && (
                                                <> This field is required</>
                                              )}
                                              {overrideSetUprValidError_gam && (
                                                <> Value must be greater than 0</>
                                              )}
                                            </span>
                                          </div>
                                        </Col>
                                      )} */}
                                    </Row>
                                    {!isGamRestricted && (
                                      <div className="form_content_block--group mb_0">
                                        <label className="form_label">UPR Category *</label>
                                        <Select
                                          optionFilterProp="label"
                                          className="form_select basic no_search"
                                          // className={
                                          //   uprCategoryIsRequiredError_gam || uprCategoryNotFoundError_gam
                                          //     ? "form_select basic no_search error"
                                          //     : "form_select basic no_search"
                                          // }
                                          value={uprCategory_gam || undefined}
                                          onChange={onChangeUprCategory_gam}
                                          options={uprCategoryOptions_gam}
                                          placeholder="- Select -"
                                        />
                                        <span className="error_content">
                                          {uprCategoryIsRequiredError_gam && (
                                            <> This field is required</>
                                          )}
                                          {uprCategoryNotFoundError_gam && (
                                            <> UPR Category as per UPR not found</>
                                          )}
                                        </span>
                                        {uprCategoryMatched_gam && !uprCategoryNotFoundError_gam && !uprCategoryIsRequiredError_gam && uprCategory_gam && !isUprCategoryMismatch_gam() && (
                                          <span className="error_content" style={{ color: "#12B76A" }}>
                                            UPR Category set as per UPR
                                          </span>
                                        )}
                                        {!uprCategoryNotFoundError_gam && !uprCategoryIsRequiredError_gam && isUprCategoryMismatch_gam() && (
                                          <div className="upr_category_info">
                                            <div className="d-flex align-items-center justify-content-between">
                                              <p>UPR Category does not match the price. Please cross-check the details or proceed if you wish to continue.</p>
                                              <span onClick={handleSetNowUprCategory_gam} style={{ cursor: "pointer" }}>Set now</span>
                                            </div>
                                          </div>
                                        )}
                                      </div>
                                    )}
                                  </Col>

                                </Row>
                              </div>
                            </Col>
                          </Row>
                        </>
                      ) : (
                        <>
                          <Row gutter={16}>
                            <Col span={8}>
                              <div className="container_box--label-info">
                                <label>General details</label>
                                <p className="sub_text">Please enter zone details</p>
                              </div>
                            </Col>

                            <Col span={16}>
                              <div className="container_box--form-container mb_0">
                                <Row gutter={16}>
                                  <Col span={24}>

                                    <div className="form_content_block--group">
                                      <label className="form_label">Account Name *</label>
                                      <Input
                                        className={
                                          accountNameIsRequiredError_gamtag
                                            ? "form_control basic error"
                                            : "form_control basic"
                                        }
                                        value={accountName_gamtag}
                                        onBlur={onBlurAccountName_gamtag}
                                        onChange={onChangeAccountName_gamtag}
                                        autocomplete="off"
                                      />
                                      <span className="error_content">
                                        {accountNameIsRequiredError_gamtag && (
                                          <> This field is required</>
                                        )}
                                      </span>
                                    </div>

                                    <div className="form_content_block--group">
                                      <label className="form_label">Inventory Type *</label>
                                      <Input
                                        className="form_control basic"
                                        value="Video"
                                        autocomplete="off"
                                        disabled
                                      />
                                      <span className="error_content">
                                      </span>
                                    </div>


                                    <div className="form_content_block--group">
                                      <label className="form_label">
                                        Traffic Type *
                                      </label>
                                      <Radio.Group
                                        onChange={onChangePlatformType_gamtag}
                                        value={platformType_gamtag}
                                        className="form_radio equal_space"
                                      >
                                        <Radio className="radio_btn" value="Website">
                                          Website
                                        </Radio>
                                        <Radio className="radio_btn" value="Inapp">
                                          Inapp
                                        </Radio>
                                        <Radio className="radio_btn" value="CTV">
                                          CTV
                                        </Radio>
                                      </Radio.Group>
                                    </div>



                                    <div className="form_content_block--group">
                                      <label className="form_label">Ownership *</label>
                                      <Select
                                        optionFilterProp="label"
                                        className="form_select basic no_search"
                                        value={ownership_gamtag}
                                        onChange={onChangeOwnership_gamtag}
                                        options={ownershipOptions_gamtag}
                                      />
                                    </div>

                                    <div className="form_content_block--group">
                                      <label className="form_label">VAST Version *</label>
                                      <Select
                                        optionFilterProp="label"
                                        className="form_select basic no_search"
                                        value={vastVersion_gamtag}
                                        onChange={onChangeVastVersion_gamtag}
                                        options={vastVersionOptions_gamtag}
                                      />
                                    </div>

                                    <div className="form_content_block--group mb_0">
                                      <label className="form_label">eCPM *</label>
                                      <Select
                                        optionFilterProp="label"
                                        className="form_select basic no_search"
                                        value={eCPM_gamtag}
                                        onChange={onChangeeCPM_gamtag}
                                        options={eCPMOptions_gamtag}
                                      />
                                    </div>


                                  </Col>
                                </Row>
                              </div>
                            </Col>
                          </Row>

                        </>
                      )

            }

          </div >
          <div className="hr_custom mb_20"></div>
          <div className="btn_group justify-content-end gap_8 pb_50">
            {buttonProcessing ?
              <>
                <button className="w_120_d2 btn btn_white_outline w_fit_content"
                  disabled
                >
                  Discard
                </button>
                <button
                  className="w_120_d2 btn btn_primary w_fit_content loader"

                >
                  <span>Create Zone</span>

                  <img
                    src={loaderIcon}
                    alt="USP"
                    className="loader_icon"
                  />
                </button>
              </> :
              <>
                <button className="w_120_d2 btn btn_white_outline w_fit_content"
                  onClick={() => {
                    handlePageViewChange("table")
                    resetFormView()
                  }}
                >
                  Discard
                </button>
                <button
                  className="w_120_d2 btn btn_primary w_fit_content"
                  onClick={handleSubmit}
                >
                  Create zone
                </button>
              </>
            }

          </div>


          <Modal
            centered
            className='custom_modal'
            title={<div className='custom_modal--header --tabs'><h3 className='heading'><img src={zoneInfoIcon} alt='USP' /> Zone info</h3>
              <div className="tab_content--buttons">
                <>
                  {formType === "Open RTB" ?
                    <>
                      {items_openrtb.map((item) => (
                        <button
                          key={item.key}
                          onClick={() => onTabChange(item.key)}
                          className={activeKey === item.key ? 'btn active' : 'btn'}
                        >
                          {item.tab}
                        </button>
                      ))}
                    </>
                    :
                    formType === "Prebid" ?
                      <>
                        {items_prebid.map((item) => (
                          <button
                            key={item.key}
                            onClick={() => onTabChange(item.key)}
                            className={activeKey === item.key ? 'btn active' : 'btn'}
                          >
                            {item.tab}
                          </button>
                        ))}
                      </>
                      :
                      formType === "Vast Zone" ?
                        <>
                          {items_vastzone.map((item) => (
                            <button
                              key={item.key}
                              onClick={() => onTabChange(item.key)}
                              className={activeKey === item.key ? 'btn active' : 'btn'}
                            >
                              {item.tab}
                            </button>
                          ))}

                        </>
                        :
                        formType === "vast_aniview" ?
                          <>
                            {items_vast_aniview.map((item) => (
                              <button
                                key={item.key}
                                onClick={() => onTabChange(item.key)}
                                className={activeKey === item.key ? 'btn active' : 'btn'}
                              >
                                {item.tab}
                              </button>
                            ))}
                          </>
                          :
                          formType === "publica" ?
                            <>
                              {items_publica.map((item) => (
                                <button
                                  key={item.key}
                                  onClick={() => onTabChange(item.key)}
                                  className={activeKey === item.key ? 'btn active' : 'btn'}
                                >
                                  {item.tab}
                                </button>
                              ))}
                            </>
                            :
                            (formType === "Player Tag" || formType === "tag_outstream") ?
                              <>
                                {items_playertag.map((item) => (
                                  <button
                                    key={item.key}
                                    onClick={() => onTabChange(item.key)}
                                    className={activeKey === item.key ? 'btn active' : 'btn'}
                                  >
                                    {item.tab}
                                  </button>
                                ))}
                              </>
                              :
                              <>
                                {items_gamtag.map((item) => (
                                  <button
                                    key={item.key}
                                    onClick={() => onTabChange(item.key)}
                                    className={activeKey === item.key ? 'btn active' : 'btn'}
                                  >
                                    {item.tab}
                                  </button>
                                ))}
                              </>

                  }

                </>
              </div>
            </div>}
            visible={isModalVisible}
            onOk={() => { window.location.reload() }}
            closable={false} // This removes the default close button
            width={770}
            footer={[
              <div className="custom_modal--footer d_flex justify_content_end">
                <button key="submit" className='btn btn_primary w_fit_content' onClick={() => { window.location.reload() }}>
                  Ok
                </button>
              </div>
            ]}
          >
            <div className="custom_modal--body">
              <div className="tab_content--body">
                <>
                  {formType === "Open RTB" ?
                    <>
                      {items_openrtb.map((item) => (
                        <div
                          key={item.key}
                          style={{ display: activeKey === item.key ? 'block' : 'none' }}
                        >
                          {item.content}
                        </div>
                      ))}
                    </>
                    :
                    formType === "Prebid" ?
                      <>
                        {items_prebid.map((item) => (
                          <div
                            key={item.key}
                            style={{ display: activeKey === item.key ? 'block' : 'none' }}
                          >
                            {item.content}
                          </div>
                        ))}
                      </>
                      :
                      formType === "Vast Zone" ?
                        <>
                          {items_vastzone.map((item) => (
                            <div
                              key={item.key}
                              style={{ display: activeKey === item.key ? 'block' : 'none' }}
                            >
                              {item.content}
                            </div>
                          ))}
                        </>
                        :
                        formType === "vast_aniview" ?
                          <>
                            {items_vast_aniview.map((item) => (
                              <div
                                key={item.key}
                                style={{ display: activeKey === item.key ? 'block' : 'none' }}
                              >
                                {item.content}
                              </div>
                            ))}
                          </>
                          :
                          formType === "publica" ?
                            <>
                              {items_publica.map((item) => (
                                <div
                                  key={item.key}
                                  style={{ display: activeKey === item.key ? 'block' : 'none' }}
                                >
                                  {item.content}
                                </div>
                              ))}
                            </>
                            :
                            (formType === "Player Tag" || formType === "tag_outstream") ?
                              <>
                                {items_playertag.map((item) => (
                                  <div
                                    key={item.key}
                                    style={{ display: activeKey === item.key ? 'block' : 'none' }}
                                  >
                                    {item.content}
                                  </div>
                                ))}
                              </>
                              :
                              <>
                                {items_gamtag.map((item) => (
                                  <div
                                    key={item.key}
                                    style={{ display: activeKey === item.key ? 'block' : 'none' }}
                                  >
                                    {item.content}
                                  </div>
                                ))}
                              </>

                  }

                </>
              </div>
            </div>
          </Modal>

          <Modal
            className='custom_modal custom_modal_form_d2'
            visible={isTemplateModalOpen}
            onOk={closeTemplateModal}
            width={770}
            onCancel={closeTemplateModal}
            maskClosable={false}
            title={<div className='custom_modal--header'><h3 className='heading'><img src={creativetemicon} alt='USP' /> Create Template</h3>
            </div>}
            closable={true} // This removes the default close button
            footer={[
              <div className="custom_modal--footer d_flex justify_content_end">
                <div className="btn_group justify-content-end gap_8">
                  <button className="w_120_d2 btn btn_white_outline w_fit_content" onClick={closeTemplateModal}> Discard </button>
                  <button className="w_120_d2 btn btn_primary w_fit_content" onClick={handleTemplateCreationValidation}>Create</button>
                </div>
              </div>
            ]}>
            <div className="custom_modal--body">
              <div className="form_content_block--group modal_form_bottom_gap_d2">
                <label className="form_label">Template Name * </label>
                <Input className={nameTemplate_htmlIsRequiredError ? 'form_control basic error ' : 'form_control basic '} placeholder='' autocomplete="off"
                  value={nameTemplate_html}
                  onChange={onChangeNameTemplate_html}
                  onBlur={onBlurNameTemplate_html}
                />
                <span className="error_content">{nameTemplate_htmlIsRequiredError && <>This field is required</>} </span>
              </div>
              <div className="form_content_block--group">
                <label className="form_label">Tag * </label>
                <TextArea autocomplete="off" placeholder='' className={tagTemplate_htmlIsRequiredError ? 'form_control basic form_control_h --160 error textarea_paddingY_d2' : 'form_control basic form_control_h --160 textarea_paddingY_d2'}
                  value={tagTemplate_html}
                  onChange={onChangeTagTemplate_html}
                  onBlur={onBlurTagTemplate_html}
                />
                <span className="error_content"> {tagTemplate_htmlIsRequiredError && <>This field is required</>}</span>
              </div>

            </div>
          </Modal>
        </div >
      </div >

    </>
  );
};

export default ZoneCreate;
